<template>
  <div>
    <div class="container-fluid mt-3">
        <!-- Fila 1: Selects -->
        <b-row v-if="hasEmpresas" class="align-items-center mb-4">
          <b-col md="2">
            <template v-if="showEmpresaBadge">
              <span class="small text-muted mr-2">{{ $t('empresa') }}:</span>
              <span class="badge badge-primary px-3 text-uppercase" style="display:inline-flex;align-items:center;height:32px;font-size:.85rem;">{{ nombreEmpresaSeleccionada || '—' }}</span>
            </template>
            <template v-else>
              <el-select v-model="empresaSeleccionada" :placeholder="$t('placeholder_empresa')"
                @change="onEmpresaSeleccionada" style="width: 100%;" filterable>
                <el-option v-for="empresa in empresasCliente" :key="empresa.id" :label="empresa.nombre"
                  :value="empresa.id" />
              </el-select>
            </template>
          </b-col>

        </b-row>

        <!-- Tabla Upload Files -->
        <div v-if="empresaSeleccionada && archivosLogs.length && !archivoSeleccionado" class="my-2">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <h5 class="text-primary mb-0">{{ $t('archivos_cargados') }}</h5>
            <b-button size="sm" variant="primary" @click="onEmpresaSeleccionada">
              <i class="fas fa-sync-alt mr-1"></i> {{ $t('refrescar') }}
            </b-button>
          </div>
          <table class="table table-bordered table-hover table-sm tabla-archivos-cargados">
            <thead class="thead-light">
              <tr>
                <th style="width:40px;">#</th>
                <th class="th-ordenable" @click="ordenarPorArchivos('nombreXLSX')">
                  <input class="th-search-input" v-model="filterColArchivos.nombreXLSX" @click.stop :placeholder="$t('buscar')" />
                  <span class="th-label">{{ $t('nombre_archivo') }} <i :class="iconoOrdenArchivos('nombreXLSX')"></i></span>
                </th>
                <th class="th-ordenable text-center" @click="ordenarPorArchivos('estadoFlujoDesc')">
                  <input class="th-search-input" v-model="filterColArchivos.estadoFlujoDesc" @click.stop :placeholder="$t('buscar')" />
                  <span class="th-label">{{ $t('estado') }} <i :class="iconoOrdenArchivos('estadoFlujoDesc')"></i></span>
                </th>
                <th class="th-ordenable text-right" @click="ordenarPorArchivos('fechaRentabilizacion')">
                  <input class="th-search-input" v-model="filterColArchivos.fechaRentabilizacion" @click.stop :placeholder="$t('buscar')" />
                  <span class="th-label">{{ $t('fecha_rentabilizacion') }} (GMT 0) <i :class="iconoOrdenArchivos('fechaRentabilizacion')"></i></span>
                </th>
                <th class="th-ordenable text-right" @click="ordenarPorArchivos('fechaClusterizacion')">
                  <input class="th-search-input" v-model="filterColArchivos.fechaClusterizacion" @click.stop :placeholder="$t('buscar')" />
                  <span class="th-label">{{ $t('fecha_clusterizacion') }} (GMT 0) <i :class="iconoOrdenArchivos('fechaClusterizacion')"></i></span>
                </th>
                <th class="th-ordenable text-center" @click="ordenarPorArchivos('tipoFlujo')">
                  <input class="th-search-input" v-model="filterColArchivos.tipoFlujo" @click.stop :placeholder="$t('buscar')" />
                  <span class="th-label">{{ $t('tipo_flujo') }} <i :class="iconoOrdenArchivos('tipoFlujo')"></i></span>
                </th>
                <th>{{ $t('accion') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(archivo, index) in processedArchivosLogs" :key="archivo.token">
                <td>{{ index + 1 }}</td>
                <td>{{ archivo.nombreXLSX }}</td>
                <td class="text-center align-middle">
                  <span v-if="['K','J','L'].includes(normalizeEstado(archivo.estadoFlujo))" class="badge badge-danger">{{ archivo.estadoFlujoDesc || $t('error') || 'Error' }}</span>
                  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'P'" class="badge badge-danger">{{ archivo.estadoFlujoDesc || $t('sin_rentabilizacion') }}</span>
                  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'S'" class="badge badge-warning">{{ archivo.estadoFlujoDesc || $t('en_proceso') }}</span>
                  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'R'" class="badge badge-success">{{ archivo.estadoFlujoDesc || $t('rentabilizado') }}</span>
                  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'C'" class="badge badge-info">{{ archivo.estadoFlujoDesc || $t('clusterizando') }}</span>
                  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'T'" class="badge badge-primary">{{ archivo.estadoFlujoDesc || $t('clusterizado') || 'Clusterizado' }}</span>
                  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'I'" class="badge badge-warning">{{ archivo.estadoFlujoDesc || $t('esperando_procesar') || 'Esperando procesar' }}</span>
                  <span v-else-if="normalizeEstado(archivo.estadoFlujo) === 'E'" class="badge badge-ecommerce">{{ archivo.estadoFlujoDesc || $t('ecommerce') || 'E-Commerce' }}</span>
                  <span v-else class="badge badge-dark">{{ archivo.estadoFlujoDesc || $t('desconocido') }}</span>
                </td>
                <td class="text-right">{{ formatFechaGmt0(archivo.fechaRentabilizacion) }}</td>
                <td class="text-right">{{ formatFechaGmt0(archivo.fechaClusterizacion) }}</td>
                <td class="text-center align-middle">
                  <span v-if="(archivo.tipoFlujo || '').trim() === 'FN'" class="badge badge-primary">{{ $t('tipo_flujo_fn') }}</span>
                  <span v-else-if="(archivo.tipoFlujo || '').trim() === 'NR'" class="badge badge-warning">{{ $t('tipo_flujo_nr') }}</span>
                  <span v-else-if="(archivo.tipoFlujo || '').trim() === 'DE'" class="badge badge-info">{{ $t('tipo_flujo_de') }}</span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <template v-if="['T','E','C','G'].includes(normalizeEstado(archivo.estadoFlujo))">
                    <b-button v-if="['T','E'].includes(normalizeEstado(archivo.estadoFlujo))" size="sm" class="btn-green mr-1" variant="info" @click="seleccionarArchivoDesdeTabla(archivo)">
                      {{ $t('ver_detalle') }}
                    </b-button>
                    <b-button v-if="puedeEscribir" size="sm" variant="warning" @click="seleccionarArchivoYVolverAdm(archivo)">
                      {{ $t('volver_adm_inventario') || 'Back to Inv. Admin' }}
                    </b-button>
                  </template>
                  <template v-else-if="normalizeEstado(archivo.estadoFlujo) === 'P'">
                    <b-button v-if="puedeEscribir && !esFlujoDirectoCluster(archivo)" size="sm" variant="primary" class="mr-1" @click="ejecutarRentabilizar(archivo)">
                      {{ $t('btn_rentabilizar') || 'Rentabilize' }}
                    </b-button>
                    <b-button v-if="puedeEscribir" size="sm" variant="warning" @click="seleccionarArchivoYVolverAdm(archivo)">
                      {{ $t('volver_adm_inventario') || 'Back to Inv. Admin' }}
                    </b-button>
                  </template>
                  <template v-else-if="normalizeEstado(archivo.estadoFlujo) === 'R'">
                    <b-button v-if="puedeEscribir" size="sm" variant="primary" class="mr-1" @click="ejecutarClusterizar(archivo)">
                      {{ $t('clusterizar') || 'Clusterizar' }}
                    </b-button>
                    <b-button v-if="puedeEscribir" size="sm" variant="warning" @click="seleccionarArchivoYVolverAdm(archivo)">
                      {{ $t('volver_adm_inventario') || 'Back to Inv. Admin' }}
                    </b-button>
                  </template>
                  <span v-else class="text-muted small">—</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mensaje sin archivos -->
        <div v-if="empresaSeleccionada && archivosConsultados && !archivosLogs.length && !archivoSeleccionado"
          class="my-4 text-center text-muted">
          <i class="fas fa-folder-open fa-2x mb-2 d-block"></i>
          {{ $t('sin_archivos_empresa') || 'Esta empresa no tiene archivos cargados.' }}
        </div>

        <!-- Fila 2: Botones alineados a la izquierda -->
        <b-row v-if="hasEmpresas && archivoSeleccionado && isEstadoCT" class="mb-3">
          <b-col class="d-flex flex-wrap align-items-center">
            <b-button v-for="(tipo, index) in tiposCluster" :key="index" class="fw-bold me-2 mb-1 btn-sm"
              :class="['text-dark', 'btn-green', (tipoClusterSeleccionado && tipoClusterSeleccionado.id === tipo.id) ? 'border border-primary' : '']"
              @click="aplicarCluster(tipo)">
              {{ tipo.texto }}
            </b-button>
            <b-button class="btn fw-bold me-2 mb-1 btn-sm btn-secondary text-dark btn-custom" @click="onClickCustom1">
              Custom 1
            </b-button>
            <b-button class="btn fw-bold me-2 mb-1 btn-sm btn-secondary text-dark btn-custom" @click="onClickCustom2">
              Custom 2
            </b-button>
            <b-button class="btn fw-bold me-2 mb-1 btn-sm btn-secondary text-dark btn-custom" @click="onClickCustom3">
              Custom 3
            </b-button>
            <b-button v-if="!isCustomMode" class="btn fw-bold me-2 mb-1 btn-sm btn-outline-info" @click="showGraficoModal = true">
              <i class="fas fa-chart-area mr-1"></i> {{ $t('ver_grafico') }}
            </b-button>
            <b-button v-if="puedeEscribir && archivoSeleccionado" class="btn fw-bold me-2 mb-1 btn-sm btn-warning" @click="confirmarVolverAdmInventario">
              {{ $t('volver_adm_inventario') || 'Volver Adm. Inventario' }}
            </b-button>
            <b-button class="btn fw-bold me-2 mb-1 btn-sm btn-secondary" @click="archivoSeleccionado = null">
              <i class="fas fa-arrow-left mr-1"></i> {{ $t('volver') || 'Volver' }}
            </b-button>
          </b-col>
        </b-row>

        <b-row v-if="hasEmpresas && shouldShowSinDatos">
          <b-col>
            <b-alert show variant="info" class="mt-2" style="margin: 0 auto;">
              {{ msgSinDatos }}
            </b-alert>
          </b-col>
        </b-row>
    </div>

    <!-- Contenido dinámico al seleccionar archivo -->
    <b-container fluid class="mt-4">
      <b-row>
        <b-col>
          <div v-if="archivoSeleccionado">
            <div v-if="isEstadoCT && mostrarCluster" class="mt-4">

              <!-- Modal Gráfico -->
              <b-modal v-model="showGraficoModal" :title="$t('grafico')" size="lg" ok-only :ok-title="$t('cerrar')" hide-footer centered>
                <div class="p-3">
                  <RadarChart :values="radarChartValues" />
                </div>
              </b-modal>

              <b-row>
                <!-- Tabla a ancho completo -->
                <b-col md="12">
                  <div class="p-3 border rounded bg-white" style="overflow-x: auto;">
                    <!-- ===== VISTA CUSTOM 1: lista de materiales + Guardar ===== -->
                    <div v-if="mostrarCustom1" class="mb-3">

                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <b-button v-if="isCustom1Finalizado" variant="secondary" size="sm" class="mb-3"
                          @click="volverAlResumenCustom1">
                          {{ $t('volver_al_resumen') }}
                        </b-button>
                        <b-button v-if="puedeEscribir" size="sm" class="mb-3 btn-outline-primary"
                          @click="addCriterioC1">
                          {{ $t('agregar_criterio') }}
                        </b-button>
                        <label class="mb-3 ml-2 mr-2 d-flex align-items-center small">
                          <input type="checkbox" v-model="filtrarSeleccionadasC1" class="mr-1" />
                          {{ $t('filtrar_seleccionadas') }}
                        </label>
                        <b-button v-if="puedeEscribir && c1Max > 3" size="sm" class="mb-3 btn-outline-danger"
                          @click="eliminarUltimoCriterioC1">
                          {{ $t('eliminar_criterio') }}
                        </b-button>

                        <h5 class="text-primary mb-0">Custom 1 {{ $t('en_edicion') }}</h5>

                        <div class="d-flex align-items-center">
                          <button
  class="btn btn-success btn-sm ml-2"
  v-if="puedeEscribir && !isCustom1Finalizado"
  :disabled="finalizandoCustom1"
  @click="onClickFinalizarCustom(1)">
  {{ finalizandoCustom1 ? $t('finalizando') : $t('finalizar_custom', { n: 1 }) }}
</button>
                        </div>
                      </div>

                    

                      <div v-if="cargandoCustom1" class="text-center my-4">
                        <b-spinner small type="grow" :label="$t('cargando')"></b-spinner>
                        <span class="ml-2">{{ $t('cargando') }}</span>
                      </div>

                      <div v-else>
                        <div class="tabla-scroll-fixed" ref="tablaScrollC1">
                        <table class="table table-bordered table-sm mb-0">
                          <thead class="thead-sticky thead-light">
                            <tr>
                              <th style="width: 35px; text-align:center;">
                                <div>C1</div>
                                <input type="checkbox" :checked="isTodosC1Checked(1)" @change="toggleTodosC1(1, $event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
                              </th>
<th style="width: 35px; text-align:center;">
  <div>C2</div>
  <input type="checkbox" :checked="isTodosC1Checked(2)" @change="toggleTodosC1(2, $event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
</th>
<th style="width: 35px; text-align:center;">
  <div>C3</div>
  <input type="checkbox" :checked="isTodosC1Checked(3)" @change="toggleTodosC1(3, $event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
</th>
<th v-for="n in criterioC1ExtraRange" :key="'c1h-'+n" style="width: 35px; text-align:center;">
  <div>{{ 'C' + n }}</div>
  <input type="checkbox" :checked="isTodosC1Checked(n)" @change="toggleTodosC1(n, $event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
</th>
<th class="th-ordenable" style="min-width:150px; width:150px; max-width:150px;" @click="ordenarC1('partNumber')">
  <input class="th-search-input" v-model="filterC1.partNumber" @click.stop />
  <span class="th-label">{{ $t('part_number') }} <i :class="iconoOrdenC1('partNumber')"></i></span>
</th>
                              <th class="th-ordenable" style="min-width:210px; width:210px; max-width:210px;" @click="ordenarC1('partName')">
                                <input class="th-search-input" v-model="filterC1.partName" @click.stop />
                                <span class="th-label">{{ $t('nombre_corto') }} <i :class="iconoOrdenC1('partName')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:300px; width:300px; max-width:300px;" @click="ordenarC1('detalles')">
                                <input class="th-search-input" v-model="filterC1.descripcion" @click.stop />
                                <span class="th-label">{{ $t('nombre_largo') }} <i :class="iconoOrdenC1('detalles')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:150px;" @click="ordenarC1('brandName')">
                                <input class="th-search-input" v-model="filterC1.brandName" @click.stop />
                                <el-select v-model="filterC1.brandNameSeleccion" multiple collapse-tags filterable size="mini"
                                  :placeholder="$t('fabricante')" class="th-filter-select" @click.native.stop>
                                  <el-option v-for="b in fabricantesC1Options" :key="b" :label="b" :value="b" />
                                </el-select>
                                <span class="th-label">{{ $t('fabricante') }} <i :class="iconoOrdenC1('brandName')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:90px;" @click="ordenarC1('modelo')">
                                <input class="th-search-input" v-model="filterC1.modelo" @click.stop />
                                <span class="th-label">{{ $t('modelo') }} <i :class="iconoOrdenC1('modelo')"></i></span>
                              </th>
                              <th class="th-ordenable text-right" style="min-width:75px;" @click="ordenarC1('horometro')">
                                <input class="th-search-input" v-model="filterC1.horometro" @click.stop />
                                <span class="th-label">{{ $t('horometro') }} <i :class="iconoOrdenC1('horometro')"></i></span>
                              </th>
                              <th class="th-ordenable text-right" style="min-width:75px;" @click="ordenarC1('odometro')">
                                <input class="th-search-input" v-model="filterC1.odometro" @click.stop />
                                <span class="th-label">{{ $t('col_odometro') }} <i :class="iconoOrdenC1('odometro')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:55px; width:55px; max-width:55px;" @click="ordenarC1('cantidad')">
                                <span class="th-label">{{ $t('qty') }} <i :class="iconoOrdenC1('cantidad')"></i></span>
                              </th>
                              <th class="th-ordenable" style="white-space: normal; min-width:90px;" @click="ordenarC1('valorSugeridoGeneral')">
                                <span class="th-label">Valor Sugerido<br>(USD) <i :class="iconoOrdenC1('valorSugeridoGeneral')"></i></span>
                              </th>
                              <th class="th-ordenable" style="white-space: normal; min-width:90px;" @click="ordenarC1('valorSugeridoGeneralTotal')">
                                <span class="th-label">Total Suggested<br>Value (USD) <i :class="iconoOrdenC1('valorSugeridoGeneralTotal')"></i></span>
                              </th>
                              <th class="th-ordenable th-criterio" @click="ordenarC1('criterioPorCantidad')">
                                <input class="th-search-input" v-model="filterC1.criterioPorCantidad" @click.stop />
                                <span class="th-label">{{ $t('criterioPorCantidad') }} <i :class="iconoOrdenC1('criterioPorCantidad')"></i></span>
                              </th>
                              <th class="th-ordenable th-criterio" @click="ordenarC1('criterioPorClase')">
                                <input class="th-search-input" v-model="filterC1.criterioPorClase" @click.stop />
                                <span class="th-label">{{ $t('criterioPorClase') }} <i :class="iconoOrdenC1('criterioPorClase')"></i></span>
                              </th>
                              <th class="th-ordenable th-criterio" @click="ordenarC1('criterioPorCategoria')">
                                <input class="th-search-input" v-model="filterC1.criterioPorCategoria" @click.stop />
                                <span class="th-label">{{ $t('criterioPorCategoria') }} <i :class="iconoOrdenC1('criterioPorCategoria')"></i></span>
                              </th>
                              <th class="th-ordenable th-criterio" @click="ordenarC1('criterioPorFamilia')">
                                <input class="th-search-input" v-model="filterC1.criterioPorFamilia" @click.stop />
                                <span class="th-label">{{ $t('criterioPorFamilia') }} <i :class="iconoOrdenC1('criterioPorFamilia')"></i></span>
                              </th>
                              <th class="th-ordenable th-criterio" @click="ordenarC1('criterioPorSegmento')">
                                <input class="th-search-input" v-model="filterC1.criterioPorSegmento" @click.stop />
                                <span class="th-label">{{ $t('criterioPorSegmento') }} <i :class="iconoOrdenC1('criterioPorSegmento')"></i></span>
                              </th>
                              <th class="th-ordenable th-criterio" @click="ordenarC1('criterioPorMarca')">
                                <input class="th-search-input" v-model="filterC1.criterioPorMarca" @click.stop />
                                <span class="th-label">{{ $t('criterioPorMarca') }} <i :class="iconoOrdenC1('criterioPorMarca')"></i></span>
                              </th>
                              <th class="th-ordenable th-criterio" @click="ordenarC1('criterioPorPartName')">
                                <input class="th-search-input" v-model="filterC1.criterioPorPartName" @click.stop />
                                <span class="th-label">{{ $t('criterioPorPartName') }} <i :class="iconoOrdenC1('criterioPorPartName')"></i></span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="row in custom1DataFiltrado" :key="row.idMaterialETL">
                              <!-- C1 -->
<td class="text-center" style="min-width: 35px;">
  <input type="checkbox"
         :checked="isC1Checked(row, 1)"
         @change="onToggleC1(row, 1, $event.target.checked)" />
</td>
<!-- C2 -->
<td class="text-center" style="min-width: 35px;">
  <input type="checkbox"
         :checked="isC1Checked(row, 2)"
         @change="onToggleC1(row, 2, $event.target.checked)" />
</td>
<!-- C3 -->
<td class="text-center" style="min-width: 35px;">
  <input type="checkbox"
         :checked="isC1Checked(row, 3)"
         @change="onToggleC1(row, 3, $event.target.checked)" />
</td>
<!-- Extras C4..CN -->
<td v-for="n in criterioC1ExtraRange"
    :key="'c1c-'+row.idMaterialETL+'-'+n"
    class="text-center" style="min-width: 35px;">
  <input type="checkbox"
         :checked="isC1Checked(row, n)"
         @change="onToggleC1(row, n, $event.target.checked)" />
</td>

                              <td style="max-width:150px;">
                                <el-tooltip :content="row.partNumber || '—'" placement="top" :disabled="!row.partNumber" effect="dark">
                                  <span class="d-inline-block text-truncate txt-truncate-sm" style="max-width:150px;">{{ textoCorto(row.partNumber, 40) }}</span>
                                </el-tooltip>
                              </td>
                              <td style="max-width:210px;">
                                <el-tooltip :content="row.partName || '—'" placement="top" :disabled="!row.partName" effect="dark">
                                  <span class="d-inline-block text-truncate txt-truncate-sm" style="max-width:210px;">{{ textoCorto(row.partName, 60) }}</span>
                                </el-tooltip>
                              </td>
                              <td style="max-width:300px;">
                                <el-tooltip :content="row.detalles || '—'" placement="top" :disabled="!row.detalles" effect="dark">
                                  <span class="text-primary text-truncate d-inline-block txt-truncate-sm"
                                        style="cursor:pointer; max-width: 300px;"
                                        @click="abrirDetalle('modal-c1-detalle', row)">
                                    {{ textoCorto(row.detalles, 80) }}
                                  </span>
                                </el-tooltip>
                              </td>
                              <td>{{ row.brandName || '—' }}</td>
                              <td>{{ row.modelo || '—' }}</td>
                              <td class="text-right">{{ row.horometro || '—' }}</td>
                              <td class="text-right">{{ row.odometro || '—' }}</td>
                              <td class="text-right" style="min-width:55px; width:55px; max-width:55px;">{{ row.cantidad }}</td>

                              <!-- Suggested Value (SOLO LECTURA) -->
                              <td class="text-right" style="min-width: 100px;">
                                {{ formatPrecio(row.valorSugeridoGeneral) }}
                              </td>

                              <!-- Total Suggested Value (calc) -->
                              <td class="text-right" style="min-width: 100px;">
                                {{ formatPrecio(row.valorSugeridoGeneralTotal) }}
                              </td>

                              <!-- NUEVAS celdas (solo lectura) -->
                              <td class="text-right td-criterio">{{ row.criterioPorCantidad }}</td>
                              <td class="text-right td-criterio">{{ row.criterioPorClase }}</td>
                              <td class="text-right td-criterio">{{ row.criterioPorCategoria }}</td>
                              <td class="text-right td-criterio">{{ row.criterioPorFamilia }}</td>
                              <td class="text-right td-criterio">{{ row.criterioPorSegmento }}</td>
                              <td class="text-right td-criterio">{{ row.criterioPorMarca }}</td>
                              <td class="text-right td-criterio">{{ row.criterioPorPartName }}</td>
                            </tr>
                          </tbody>
                        </table>
                        </div><!-- /tabla-scroll-fixed C1 -->

                        <!-- barra scroll C1 -->
                        <div class="pagination-floating-bar justify-content-between">
                          <span class="text-muted small">{{ custom1DataFiltrado.length }} / {{ custom1Data.length }} {{ $t('items_label') }}</span>
                          <div class="d-flex align-items-center" style="gap:6px;">
                            <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollC1','left')" title="Scroll izquierda"><i class="fas fa-chevron-left"></i></button>
                            <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollC1','right')" title="Scroll derecha"><i class="fas fa-chevron-right"></i></button>
                            <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollC1','top')" title="Ir al inicio"><i class="fas fa-chevron-up"></i></button>
                            <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollC1','bottom')" title="Ir al final"><i class="fas fa-chevron-down"></i></button>
                          </div>
                        </div>
                      </div>

                      <!-- Modal para ver Description completo -->
                      <b-modal id="modal-c1-detalle" :title="$t('detalle_completo')" size="lg" ok-only :ok-title="$t('cerrar')"
                        hide-footer>
                        <p class="text-justify">{{ detalleSeleccionado }}</p>
                      </b-modal>
                    </div>
                    <div v-else-if="!isCustomMode">

                      <!-- Vista detalle del cluster seleccionado -->
                    <div v-if="mostrarDetalleCluster && clusterDetalle.length">
                      <b-button variant="secondary" size="sm" class="mb-3"
                        @click="mostrarDetalleCluster = false; mostrarCluster = true">
                        {{ $t('volver_al_resumen') }}
                      </b-button>

                      <h5 class="text-primary mb-2">
                        {{ $t('detalle_cluster_seleccionado') }}<span v-if="clusterDetalleNombre">: {{ clusterDetalleNombre }}</span>
                      </h5>

                      <div class="tabla-scroll-fixed" ref="tablaScrollDetalle">
                        <table class="table table-sm table-bordered mb-0">
                          <thead class="thead-sticky thead-light">
                            <tr>
                              <th style="min-width:40px;">#</th>
                              <th class="th-ordenable" style="min-width:60px;cursor:pointer;" @click="ordenarDetalle('id')">
                                <input class="th-search-input" v-model="filterDetalle.id" @click.stop placeholder="" />
                                <span class="th-label">ID <i :class="iconoOrdenDetalle('id')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:180px;cursor:pointer;" @click="ordenarDetalle('nombre')">
                                <input class="th-search-input" v-model="filterDetalle.nombre" @click.stop placeholder="" />
                                <span class="th-label">{{ $t('nombre_corto') }} <i :class="iconoOrdenDetalle('nombre')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:130px;cursor:pointer;" @click="ordenarDetalle('partNumber')">
                                <input class="th-search-input" v-model="filterDetalle.partNumber" @click.stop placeholder="" />
                                <span class="th-label">{{ $t('part_number') }} <i :class="iconoOrdenDetalle('partNumber')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:90px;cursor:pointer;" @click="ordenarDetalle('brandName')">
                                <input class="th-search-input" v-model="filterDetalle.brandName" @click.stop placeholder="" />
                                <span class="th-label">{{ $t('fabricante') }} <i :class="iconoOrdenDetalle('brandName')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:90px;cursor:pointer;" @click="ordenarDetalle('modelo')">
                                <input class="th-search-input" v-model="filterDetalle.modelo" @click.stop placeholder="" />
                                <span class="th-label">{{ $t('modelo') }} <i :class="iconoOrdenDetalle('modelo')"></i></span>
                              </th>
                              <th class="th-ordenable text-right" style="min-width:75px;cursor:pointer;" @click="ordenarDetalle('horometro')">
                                <input class="th-search-input" v-model="filterDetalle.horometro" @click.stop placeholder="" />
                                <span class="th-label">{{ $t('horometro') }} <i :class="iconoOrdenDetalle('horometro')"></i></span>
                              </th>
                              <th class="th-ordenable text-right" style="min-width:75px;cursor:pointer;" @click="ordenarDetalle('odometro')">
                                <input class="th-search-input" v-model="filterDetalle.odometro" @click.stop placeholder="" />
                                <span class="th-label">{{ $t('col_odometro') }} <i :class="iconoOrdenDetalle('odometro')"></i></span>
                              </th>
                              <th class="th-ordenable text-right" style="min-width:80px;cursor:pointer;" @click="ordenarDetalle('cantidad')">
                                <input class="th-search-input" v-model="filterDetalle.cantidad" @click.stop placeholder="" />
                                <span class="th-label">{{ $t('cantidad') }} <i :class="iconoOrdenDetalle('cantidad')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:90px;cursor:pointer;" @click="ordenarDetalle('unidadDeMedida')">
                                <input class="th-search-input" v-model="filterDetalle.unidadDeMedida" @click.stop placeholder="" />
                                <span class="th-label">{{ $t('uom') }} <i :class="iconoOrdenDetalle('unidadDeMedida')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:110px;cursor:pointer;" @click="ordenarDetalle('condicion')">
                                <input class="th-search-input" v-model="filterDetalle.condicion" @click.stop placeholder="" />
                                <span class="th-label">{{ $t('condicion') }} <i :class="iconoOrdenDetalle('condicion')"></i></span>
                              </th>
                              <!-- Encabezados en dos lineas: el texto trae el <br> desde la
                                   traduccion (th_*), asi que se pinta con v-html y el icono
                                   de orden queda al final, sobre la segunda linea. -->
                              <th class="th-ordenable text-right" style="min-width:120px;cursor:pointer;" @click="ordenarDetalle('valorLibro')">
                                <input class="th-search-input" v-model="filterDetalle.valorLibro" @click.stop placeholder="" />
                                <span class="th-label"><span v-html="$t('th_valor_libro_usd')"></span> <i :class="iconoOrdenDetalle('valorLibro')"></i></span>
                              </th>
                              <th class="th-ordenable text-right" style="min-width:130px;cursor:pointer;" @click="ordenarDetalle('valorLibroTotal')">
                                <input class="th-search-input" v-model="filterDetalle.valorLibroTotal" @click.stop placeholder="" />
                                <span class="th-label"><span v-html="$t('th_valor_libro_total_usd')"></span> <i :class="iconoOrdenDetalle('valorLibroTotal')"></i></span>
                              </th>
                              <th class="th-ordenable text-right" style="min-width:160px;cursor:pointer;" @click="ordenarDetalle('valorTotal')">
                                <input class="th-search-input" v-model="filterDetalle.valorTotal" @click.stop placeholder="" />
                                <span class="th-label">
                                  <span v-html="$t('th_valor_total_sugerido_usd')"></span>
                                  <i :class="iconoOrdenDetalle('valorTotal')"></i>
                                  <!-- @click.stop para que abrir la ayuda no reordene la tabla. -->
                                  <i class="fas fa-info-circle btn-info-columna"
                                     :title="$t('info_valor_sugerido_titulo')"
                                     @click.stop="modalInfoValorSugerido = true"></i>
                                </span>
                              </th>
                              <th style="min-width:70px;"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in pagedDetalle" :key="item.id">
                              <td>{{ indexInicioDetalle + index + 1 }}</td>
                              <td>{{ item.id }}</td>
                              <td>{{ item.nombre }}</td>
                              <td>{{ item.partNumber || '—' }}</td>
                              <td>{{ item.brandName || '—' }}</td>
                              <td>{{ item.modelo || '—' }}</td>
                              <td class="text-right">{{ item.horometro || '—' }}</td>
                              <td class="text-right">{{ item.odometro || '—' }}</td>
                              <td class="text-right">{{ item.cantidad != null ? item.cantidad : '—' }}</td>
                              <td>{{ item.unidadDeMedida || '—' }}</td>
                              <td>{{ item.condicion || '—' }}</td>
                              <td class="text-right">{{ formatValorLibroDetalle(item) }}</td>
                              <td class="text-right">{{ formatValorLibroTotalDetalle(item) }}</td>
                              <td class="text-right">{{ formatValorTotalDetalle(item) }}</td>
                              <td class="text-center">
                                <b-button v-if="puedeEscribir" size="sm" variant="danger"
                                          :disabled="item._eliminando"
                                          @click="eliminarItemDeCluster(item)">
                                  {{ item._eliminando ? '…' : '✕' }}
                                </b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div><!-- /tabla-scroll-fixed Detalle -->

                      <div class="pagination-floating-bar">
                        <div class="d-flex align-items-center">
                          <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') }}</label>
                          <select v-model.number="pageSizeDetalle" @change="currentPageDetalle = 1" class="form-control form-control-sm" style="width:70px;">
                            <option :value="20">20</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                            <option :value="200">200</option>
                            <option :value="999999">Todas</option>
                          </select>
                        </div>
                        <div class="d-flex align-items-center" style="gap:12px;">
                          <button class="btn btn-outline-secondary btn-sm" :disabled="currentPageDetalle === 1" @click="currentPageDetalle--">
                            <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') }}
                          </button>
                          <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
                            {{ $t('pagina') }} {{ currentPageDetalle }} {{ $t('de') }} {{ totalPagesDetalle }}
                          </span>
                          <button class="btn btn-outline-primary btn-sm" :disabled="currentPageDetalle === totalPagesDetalle" @click="currentPageDetalle++">
                            {{ $t('siguiente') }} <i class="fas fa-arrow-right ml-1"></i>
                          </button>
                        </div>
                        <div class="d-flex align-items-center" style="gap:6px;">
                          <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollDetalle','left')" title="Scroll izquierda"><i class="fas fa-chevron-left"></i></button>
                          <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollDetalle','right')" title="Scroll derecha"><i class="fas fa-chevron-right"></i></button>
                          <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollDetalle','top')" title="Ir al inicio"><i class="fas fa-chevron-up"></i></button>
                          <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollDetalle','bottom')" title="Ir al final"><i class="fas fa-chevron-down"></i></button>
                        </div>
                      </div>
                    </div>
                      <div v-else>
                        <div v-if="mostrarResumenPermitido" class="mt-4">

                          <div class="d-flex align-items-center justify-content-between mb-2">
  <h5 class="text-primary mb-0">
    <!-- Título dinámico según el criterio seleccionado -->
    {{ tipoClusterSeleccionado && tipoClusterSeleccionado.texto
        ? ($t('resumen_clusters') + ' ' + tipoClusterSeleccionado.texto)
        : $t('resumen_clusters') }}
  </h5>

  <!-- Botón Editar según el criterio del RESUMEN -->
  <div>
    <b-button v-if="tipoClusterSeleccionado && tipoClusterSeleccionado.id === 8"
              variant="warning" size="sm" @click="editarCustom1DesdeResumen">
      {{ $t('editar_custom', { n: 1 }) }}
    </b-button>

    <b-button v-if="tipoClusterSeleccionado && tipoClusterSeleccionado.id === 9"
              variant="warning" size="sm" @click="editarCustom2DesdeResumen">
      {{ $t('editar_custom', { n: 2 }) }}
    </b-button>

    <b-button v-if="tipoClusterSeleccionado && tipoClusterSeleccionado.id === 10"
              variant="warning" size="sm" @click="editarCustom3DesdeResumen">
      {{ $t('editar_custom', { n: 3 }) }}
    </b-button>
  </div>
</div>

                          <div class="tabla-scroll-fixed" ref="tablaScrollResumen">
                            <table class="table table-bordered table-sm mb-0">
                              <thead class="thead-sticky thead-light">
                                <tr>
                                  <th style="min-width: 50px; text-align: center;">
                                    <input type="checkbox" v-model="checkAllResumen" @change="toggleAllClustersResumen" title="Seleccionar todos" />
                                  </th>
                                  <th class="th-ordenable" style="min-width:160px;cursor:pointer;" @click="ordenarResumen('cluster')">
                                    <input class="th-search-input" v-model="buscarCluster" @click.stop placeholder="" />
                                    <span class="th-label">Cluster <i :class="iconoOrdenResumen('cluster')"></i></span>
                                  </th>
                                  <th class="th-ordenable text-right" style="min-width:130px;cursor:pointer;" @click="ordenarResumen('totalSuggestedValue')">
                                    <input class="th-search-input" v-model="filterResumen.totalSuggestedValue" @click.stop placeholder="" />
                                    <span class="th-label">{{ $t('totalSuggestedValue') }} <i :class="iconoOrdenResumen('totalSuggestedValue')"></i></span>
                                  </th>
                                  <th class="th-ordenable text-right" style="min-width:130px;cursor:pointer;" @click="ordenarResumen('valorLibroTotal')">
                                    <input class="th-search-input" v-model="filterResumen.valorLibroTotal" @click.stop placeholder="" />
                                    <span class="th-label">{{ $t('valorLibroTotal') }} <i :class="iconoOrdenResumen('valorLibroTotal')"></i></span>
                                  </th>
                                  <th class="th-ordenable text-right" style="min-width:120px;cursor:pointer;" @click="ordenarResumen('valorPromedio')">
                                    <input class="th-search-input" v-model="filterResumen.valorPromedio" @click.stop placeholder="" />
                                    <span class="th-label">{{ $t('valorPromedio') }} <i :class="iconoOrdenResumen('valorPromedio')"></i></span>
                                  </th>
                                  <th class="th-ordenable text-right" style="min-width:110px;cursor:pointer;" @click="ordenarResumen('cantidadTotal')">
                                    <input class="th-search-input" v-model="filterResumen.cantidadTotal" @click.stop placeholder="" />
                                    <span class="th-label">{{ $t('cantidadTotal') }} <i :class="iconoOrdenResumen('cantidadTotal')"></i></span>
                                  </th>
                                  <th class="th-ordenable text-right" style="min-width:120px;cursor:pointer;" @click="ordenarResumen('cantidadPromedio')">
                                    <input class="th-search-input" v-model="filterResumen.cantidadPromedio" @click.stop placeholder="" />
                                    <span class="th-label">{{ $t('cantidadPromedio') }} <i :class="iconoOrdenResumen('cantidadPromedio')"></i></span>
                                  </th>
                                  <th class="th-ordenable text-right" style="min-width:90px;cursor:pointer;" @click="ordenarResumen('registros')">
                                    <input class="th-search-input" v-model="filterResumen.registros" @click.stop placeholder="" />
                                    <span class="th-label">{{ $t('registros') }} <i :class="iconoOrdenResumen('registros')"></i></span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="item in clusterResumenPaginado" :key="item.id"
                                    @click="onResumenRowClick(item)"
                                    style="cursor: pointer;">
                                  <td class="text-center" style="width: 50px;" @click.stop>
                                    <input type="checkbox" v-model="clustersSelectedResumen" :value="item.nombreCluster || item.NombreCluster" @change="onCheckResumenChange(item, $event)" />
                                  </td>
                                  <td class="text-primary fw-bold">
                                    {{ nombreClusterParaMostrar(item.nombreCustom || item.NombreCustom || item.nombreCluster || item.NombreCluster || item.NombreClase || item.nombreClase || item.cluster || item.numeroCluster) }}
                                    <button v-if="tipoClusterSeleccionado && [8, 9, 10].includes(tipoClusterSeleccionado.id)"
                                            class="btn btn-sm btn-link p-0 ml-1" style="vertical-align:baseline;"
                                            @click.stop="editarNombreCustomCluster(item)" :title="$t('editar')">
                                      <i class="fas fa-pencil-alt"></i>
                                    </button>
                                  </td>
                                  <td class="text-right">
                                    {{ formatPrecio(item.valor || 0) }}
                                  </td>
                                  <td class="text-right">
                                    {{ formatPrecio(item.valorLibro || item.ValorLibro || 0) }}
                                  </td>
                                  <td class="text-right">
                                    {{ formatPrecio(item.valorPromedio || item.ValorPromedio || 0) }}
                                  </td>
                                  <td class="text-right">
                                    {{ Number(item.cantidadTotal || item.CantidadTotal || 0).toLocaleString('es-CL') }}
                                  </td>
                                  <td class="text-right">
                                    {{ formatPrecio(item.cantidadPromedio || item.CantidadPromedio || 0) }}
                                  </td>
                                  <td class="text-right">
                                    {{ Number(item.registros || item.Registros || 0).toLocaleString('es-CL') }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div><!-- /tabla-scroll-fixed Resumen -->

                          <div class="pagination-floating-bar">
                            <div class="d-flex align-items-center">
                              <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') }}</label>
                              <select v-model.number="pageSizeResumen" @change="currentPageResumen = 1" class="form-control form-control-sm" style="width:70px;">
                                <option :value="20">20</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                                <option :value="200">200</option>
              <option :value="999999">Todas</option>
                              </select>
                            </div>
                            <div class="d-flex align-items-center" style="gap:12px;">
                              <button class="btn btn-outline-secondary btn-sm" :disabled="currentPageResumen === 1" @click="currentPageResumen--">
                                <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') }}
                              </button>
                              <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
                                {{ $t('pagina') }} {{ currentPageResumen }} {{ $t('de') }} {{ totalPagesResumen }}
                              </span>
                              <button class="btn btn-outline-primary btn-sm" :disabled="currentPageResumen === totalPagesResumen" @click="currentPageResumen++">
                                {{ $t('siguiente') }} <i class="fas fa-arrow-right ml-1"></i>
                              </button>
                            </div>
                            <div class="d-flex align-items-center" style="gap:6px;">
                              <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollResumen','left')" title="Scroll izquierda"><i class="fas fa-chevron-left"></i></button>
                              <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollResumen','right')" title="Scroll derecha"><i class="fas fa-chevron-right"></i></button>
                              <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollResumen','top')" title="Ir al inicio"><i class="fas fa-chevron-up"></i></button>
                              <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollResumen','bottom')" title="Ir al final"><i class="fas fa-chevron-down"></i></button>
                            </div>
                            <div class="d-flex align-items-center" style="gap:6px;">
                              <b-button v-if="showBtnRanking"
                                        class="fw-bold btn-sm text-dark btn-green border"
                                        :disabled="!archivoSeleccionado || cargandoRanking"
                                        @click="abrirRanking">
                                {{ cargandoRanking ? $t('cargando') : $t('ver_ranking') }}
                              </b-button>
                              <b-button v-if="puedeEscribir && (showBtnEcommerce)"
                                        class="fw-bold btn-sm text-dark btn-green border"
                                        :disabled="!archivoSeleccionado"
                                        @click="enviarAEcommerce">
                                {{ $t('enviar_ecommerce') }}
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <!-- ===== /Vista detalle / resumen ===== -->

                    <!-- ===== VISTA CUSTOM 2: lista de materiales + Guardar ===== -->
                    <div v-if="mostrarCustom2" class="mb-3">

                      <!-- Header Custom 2: mismo comportamiento que C1 -->
                      <div class="d-flex align-items-center justify-content-between mb-2">
  <div class="d-flex align-items-center">
    <b-button v-if="isCustom2Finalizado" variant="secondary" size="sm" class="mb-3 mr-2"
      @click="volverAlResumenCustom2">
      {{ $t('volver_al_resumen') }}
    </b-button>
    <h5 class="text-primary mb-0">
      Custom 2 <span v-if="!isCustom2Finalizado">{{ $t('en_edicion') }}</span>
    </h5>
  </div>

  <!-- Controles -->
  <div class="d-flex align-items-center">
    <b-button v-if="puedeEscribir" size="sm" class="mb-2 btn-outline-primary mr-2" @click="addCriterioC2">
      {{ $t('agregar_criterio') }}
    </b-button>
    <label class="mb-2 mr-2 d-flex align-items-center small">
      <input type="checkbox" v-model="filtrarSeleccionadasC2" class="mr-1" />
      {{ $t('filtrar_seleccionadas') }}
    </label>
    <b-button v-if="puedeEscribir && c2Max > 3" size="sm" class="mb-2 btn-outline-danger mr-2" @click="eliminarUltimoCriterioC2">
      {{ $t('eliminar_criterio') }}
    </b-button>

    <button
  class="btn btn-success btn-sm ml-2"
  v-if="puedeEscribir && !isCustom2Finalizado"
  :disabled="finalizandoCustom2"
  @click="onClickFinalizarCustom(2)">
  {{ finalizandoCustom2 ? $t('finalizando') : $t('finalizar_custom', { n: 2 }) }}
</button>
  </div>
</div>

<div v-if="cargandoCustom2" class="text-center my-4">
  <b-spinner small type="grow" :label="$t('cargando')"></b-spinner>
  <span class="ml-2">{{ $t('cargando') }}</span>
</div>

<div v-else>
  <div class="tabla-scroll-fixed" ref="tablaScrollC2">
  <table class="table table-bordered table-sm mb-0">
    <thead class="thead-sticky thead-light">
      <tr>
        <th style="width: 35px; text-align:center;">
          <div>C1</div>
          <input type="checkbox" :checked="isTodosC2Checked(1)" @change="toggleTodosC2(1, $event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
        </th>
        <th style="width: 35px; text-align:center;">
          <div>C2</div>
          <input type="checkbox" :checked="isTodosC2Checked(2)" @change="toggleTodosC2(2, $event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
        </th>
        <th style="width: 35px; text-align:center;">
          <div>C3</div>
          <input type="checkbox" :checked="isTodosC2Checked(3)" @change="toggleTodosC2(3, $event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
        </th>
        <th v-for="n in criterioC2ExtraRange" :key="'c2h-'+n" style="width: 35px; text-align:center;">
          <div>{{ 'C' + n }}</div>
          <input type="checkbox" :checked="isTodosC2Checked(n)" @change="toggleTodosC2(n, $event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
        </th>
        <th class="th-ordenable" style="min-width:150px; width:150px; max-width:150px;" @click="ordenarC2('partNumber')">
          <input class="th-search-input" v-model="filterC2.partNumber" :placeholder="$t('buscar')+'...'" @click.stop />
          <span class="th-label">{{ $t('part_number') }} <i :class="iconoOrdenC2('partNumber')"></i></span>
        </th>
        <th class="th-ordenable" style="min-width:210px; width:210px; max-width:210px;" @click="ordenarC2('partName')">
          <input class="th-search-input" v-model="filterC2.partName" :placeholder="$t('buscar')+'...'" @click.stop />
          <span class="th-label">{{ $t('part_name') }} <i :class="iconoOrdenC2('partName')"></i></span>
        </th>
        <th class="th-ordenable" style="min-width:300px; width:300px; max-width:300px;" @click="ordenarC2('detalles')">
          <input class="th-search-input" v-model="filterC2.descripcion" :placeholder="$t('buscar')+'...'" @click.stop />
          <span class="th-label">{{ $t('descripcion') }} <i :class="iconoOrdenC2('detalles')"></i></span>
        </th>
        <th class="th-ordenable" style="min-width:150px;" @click="ordenarC2('brandName')">
          <input class="th-search-input" v-model="filterC2.brandName" :placeholder="$t('buscar')+'...'" @click.stop />
          <el-select v-model="filterC2.brandNameSeleccion" multiple collapse-tags filterable size="mini"
            :placeholder="$t('fabricante')" class="th-filter-select" @click.native.stop>
            <el-option v-for="b in fabricantesC2Options" :key="b" :label="b" :value="b" />
          </el-select>
          <span class="th-label">{{ $t('fabricante') }} <i :class="iconoOrdenC2('brandName')"></i></span>
        </th>
        <th class="th-ordenable" style="min-width:90px;" @click="ordenarC2('modelo')">
          <input class="th-search-input" v-model="filterC2.modelo" :placeholder="$t('buscar')+'...'" @click.stop />
          <span class="th-label">{{ $t('modelo') }} <i :class="iconoOrdenC2('modelo')"></i></span>
        </th>
        <th class="th-ordenable text-right" style="min-width:75px;" @click="ordenarC2('horometro')">
          <input class="th-search-input" v-model="filterC2.horometro" :placeholder="$t('buscar')+'...'" @click.stop />
          <span class="th-label">{{ $t('horometro') }} <i :class="iconoOrdenC2('horometro')"></i></span>
        </th>
        <th class="th-ordenable text-right" style="min-width:75px;" @click="ordenarC2('odometro')">
          <input class="th-search-input" v-model="filterC2.odometro" :placeholder="$t('buscar')+'...'" @click.stop />
          <span class="th-label">{{ $t('col_odometro') }} <i :class="iconoOrdenC2('odometro')"></i></span>
        </th>
        <th class="th-ordenable" style="min-width:55px; width:55px; max-width:55px;" @click="ordenarC2('cantidad')">
          <span class="th-label">{{ $t('qty') }} <i :class="iconoOrdenC2('cantidad')"></i></span>
        </th>
        <th class="th-ordenable" style="white-space: normal; min-width:90px;" @click="ordenarC2('valorSugeridoGeneral')">
          <span class="th-label">Valor Sugerido<br>(USD) <i :class="iconoOrdenC2('valorSugeridoGeneral')"></i></span>
        </th>
        <th class="th-ordenable" style="white-space: normal; min-width:90px;" @click="ordenarC2('valorSugeridoGeneralTotal')">
          <span class="th-label">Total Suggested<br>Value (USD) <i :class="iconoOrdenC2('valorSugeridoGeneralTotal')"></i></span>
        </th>
        <th class="th-ordenable th-criterio" @click="ordenarC2('criterioPorCantidad')">
          <input class="th-search-input" v-model="filterC2.criterioPorCantidad" @click.stop />
          <span class="th-label">{{ $t('criterioPorCantidad') }} <i :class="iconoOrdenC2('criterioPorCantidad')"></i></span>
        </th>
        <th class="th-ordenable th-criterio" @click="ordenarC2('criterioPorClase')">
          <input class="th-search-input" v-model="filterC2.criterioPorClase" :placeholder="$t('buscar')+'...'" @click.stop />
          <span class="th-label">{{ $t('criterioPorClase') }} <i :class="iconoOrdenC2('criterioPorClase')"></i></span>
        </th>
        <th class="th-ordenable th-criterio" @click="ordenarC2('criterioPorCategoria')">
          <input class="th-search-input" v-model="filterC2.criterioPorCategoria" :placeholder="$t('buscar')+'...'" @click.stop />
          <span class="th-label">{{ $t('criterioPorCategoria') }} <i :class="iconoOrdenC2('criterioPorCategoria')"></i></span>
        </th>
        <th class="th-ordenable th-criterio" @click="ordenarC2('criterioPorFamilia')">
          <input class="th-search-input" v-model="filterC2.criterioPorFamilia" :placeholder="$t('buscar')+'...'" @click.stop />
          <span class="th-label">{{ $t('criterioPorFamilia') }} <i :class="iconoOrdenC2('criterioPorFamilia')"></i></span>
        </th>
        <th class="th-ordenable th-criterio" @click="ordenarC2('criterioPorSegmento')">
          <input class="th-search-input" v-model="filterC2.criterioPorSegmento" :placeholder="$t('buscar')+'...'" @click.stop />
          <span class="th-label">{{ $t('criterioPorSegmento') }} <i :class="iconoOrdenC2('criterioPorSegmento')"></i></span>
        </th>
        <th class="th-ordenable th-criterio" @click="ordenarC2('criterioPorMarca')">
          <input class="th-search-input" v-model="filterC2.criterioPorMarca" :placeholder="$t('buscar')+'...'" @click.stop />
          <span class="th-label">{{ $t('criterioPorMarca') }} <i :class="iconoOrdenC2('criterioPorMarca')"></i></span>
        </th>
        <th class="th-ordenable th-criterio" @click="ordenarC2('criterioPorPartName')">
          <input class="th-search-input" v-model="filterC2.criterioPorPartName" :placeholder="$t('buscar')+'...'" @click.stop />
          <span class="th-label">{{ $t('criterioPorPartName') }} <i :class="iconoOrdenC2('criterioPorPartName')"></i></span>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="row in custom2DataFiltrado" :key="row.idMaterialETL">
        <!-- Checks (radio) de C2 -->
        <td class="text-center" style="min-width: 35px;">
          <input type="checkbox" :checked="isC2Checked(row, 1)"
                 :disabled="!puedeEscribir" @change="onToggleC2(row, 1, $event.target.checked)" />
        </td>
        <td class="text-center" style="min-width: 35px;">
          <input type="checkbox" :checked="isC2Checked(row, 2)"
                 :disabled="!puedeEscribir" @change="onToggleC2(row, 2, $event.target.checked)" />
        </td>
        <td class="text-center" style="min-width: 35px;">
          <input type="checkbox" :checked="isC2Checked(row, 3)"
                 :disabled="!puedeEscribir" @change="onToggleC2(row, 3, $event.target.checked)" />
        </td>

        <!-- Extras C4..CN -->
        <td v-for="n in criterioC2ExtraRange"
            :key="'c2c-'+row.idMaterialETL+'-'+n"
            class="text-center" style="min-width: 35px;">
          <input type="checkbox" :checked="isC2Checked(row, n)"
                 :disabled="!puedeEscribir" @change="onToggleC2(row, n, $event.target.checked)" />
        </td>

        <td style="max-width:150px;">
          <el-tooltip :content="row.partNumber || '—'" placement="top" :disabled="!row.partNumber" effect="dark">
            <span class="d-inline-block text-truncate txt-truncate-sm" style="max-width:150px;">{{ textoCorto(row.partNumber, 40) }}</span>
          </el-tooltip>
        </td>
        <td style="max-width:210px;">
          <el-tooltip :content="row.partName || '—'" placement="top" :disabled="!row.partName" effect="dark">
            <span class="d-inline-block text-truncate txt-truncate-sm" style="max-width:210px;">{{ textoCorto(row.partName, 60) }}</span>
          </el-tooltip>
        </td>
        <td style="max-width:300px;">
          <el-tooltip :content="row.detalles || '—'" placement="top" :disabled="!row.detalles" effect="dark">
            <span class="text-primary text-truncate d-inline-block txt-truncate-sm"
                  style="cursor:pointer; max-width: 300px;"
                  @click="abrirDetalle('modal-c2-detalle', row)">
              {{ textoCorto(row.detalles, 80) }}
            </span>
          </el-tooltip>
        </td>
        <td>{{ row.brandName || '—' }}</td>
        <td>{{ row.modelo || '—' }}</td>
        <td class="text-right">{{ row.horometro || '—' }}</td>
        <td class="text-right">{{ row.odometro || '—' }}</td>

        <td class="text-right" style="min-width:55px; width:55px; max-width:55px;">{{ row.cantidad }}</td>
        <td class="text-right" style="min-width: 120px;">{{ formatPrecio(row.valorSugeridoGeneral) }}</td>
        <td class="text-right" style="min-width: 140px;">{{ formatPrecio(row.valorSugeridoGeneralTotal) }}</td>

        <td class="text-right">{{ row.criterioPorCantidad }}</td>
        <td class="text-right">{{ row.criterioPorClase }}</td>
        <td class="text-right">{{ row.criterioPorCategoria }}</td>
        <td class="text-right">{{ row.criterioPorFamilia }}</td>
        <td class="text-right">{{ row.criterioPorSegmento }}</td>
        <td class="text-right">{{ row.criterioPorMarca }}</td>
        <td class="text-right">{{ row.criterioPorPartName }}</td>
      </tr>
    </tbody>
  </table>
  </div><!-- /tabla-scroll-fixed C2 -->

  <!-- barra scroll C2 -->
  <div class="pagination-floating-bar justify-content-between">
    <span class="text-muted small">{{ custom2DataFiltrado.length }} / {{ custom2Data.length }} {{ $t('items_label') }}</span>
    <div class="d-flex align-items-center" style="gap:6px;">
      <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollC2','left')" title="Scroll izquierda"><i class="fas fa-chevron-left"></i></button>
      <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollC2','right')" title="Scroll derecha"><i class="fas fa-chevron-right"></i></button>
      <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollC2','top')" title="Ir al inicio"><i class="fas fa-chevron-up"></i></button>
      <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollC2','bottom')" title="Ir al final"><i class="fas fa-chevron-down"></i></button>
    </div>
  </div>
</div>


                      <!-- Modal para ver Description completo -->
                      <b-modal id="modal-c2-detalle" :title="$t('detalle_completo')" size="lg" ok-only :ok-title="$t('cerrar')"
                        hide-footer>
                        <p class="text-justify">{{ detalleSeleccionado }}</p>
                      </b-modal>
                    </div>
                    <!-- ===== /VISTA CUSTOM 2 ===== -->

                    <!-- ===== VISTA CUSTOM 3: lista de materiales + Guardar ===== -->
                    <div v-if="mostrarCustom3" class="mb-3">

                     <!-- Header Custom 3: mismo comportamiento que C1 -->
<div class="d-flex align-items-center justify-content-between mb-2">
  <div class="d-flex align-items-center">
    <b-button v-if="isCustom3Finalizado"
          variant="secondary" size="sm" class="mb-3 mr-2"
          @click="volverAlResumenCustom3">
  {{ $t('volver_al_resumen') }}
</b-button>
    <h5 class="text-primary mb-0">
      Custom 3 <span v-if="!isCustom3Finalizado">{{ $t('en_edicion') }}</span>
    </h5>
  </div>

  <!-- Controles (siempre visibles como en C2) -->
<div class="d-flex align-items-center">
  <b-button v-if="puedeEscribir" size="sm" class="mb-2 btn-outline-primary mr-2" @click="addCriterioC3">
    {{ $t('agregar_criterio') }}
  </b-button>
  <label class="mb-2 mr-2 d-flex align-items-center small">
    <input type="checkbox" v-model="filtrarSeleccionadasC3" class="mr-1" />
    {{ $t('filtrar_seleccionadas') }}
  </label>
  <b-button v-if="puedeEscribir && c3Max > 3" size="sm" class="mb-2 btn-outline-danger mr-2" @click="eliminarUltimoCriterioC3">
    {{ $t('eliminar_criterio') }}
  </b-button>

  <button
  class="btn btn-success btn-sm ml-2"
  v-if="puedeEscribir && !isCustom3Finalizado"
  :disabled="finalizandoCustom3"
  @click="onClickFinalizarCustom(3)">
  {{ finalizandoCustom3 ? $t('finalizando') : $t('finalizar_custom', { n: 3 }) }}
</button>
<!-- (Eliminar el <b-modal id="modal-confirmar-finalizar-custom3"> completo) -->
</div>
</div>
                     
                      <div v-if="cargandoCustom3" class="text-center my-4">
                        <b-spinner small type="grow" :label="$t('cargando')"></b-spinner>
                        <span class="ml-2">{{ $t('cargando') }}</span>
                      </div>

                      <div v-else>
                        <div class="tabla-scroll-fixed" ref="tablaScrollC3">
                        <table class="table table-bordered table-sm mb-0">
                          <thead class="thead-sticky thead-light">
                            <tr>
                              <th style="width: 35px; text-align:center;">
                                <div>C1</div>
                                <input type="checkbox" :checked="isTodosC3Checked(1)" @change="toggleTodosC3(1, $event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
                              </th>
<th style="width: 35px; text-align:center;">
  <div>C2</div>
  <input type="checkbox" :checked="isTodosC3Checked(2)" @change="toggleTodosC3(2, $event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
</th>
<th style="width: 35px; text-align:center;">
  <div>C3</div>
  <input type="checkbox" :checked="isTodosC3Checked(3)" @change="toggleTodosC3(3, $event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
</th>
<th v-for="n in criterioC3ExtraRange" :key="'c3h-'+n" style="width: 35px; text-align:center;">
  <div>{{ 'C' + n }}</div>
  <input type="checkbox" :checked="isTodosC3Checked(n)" @change="toggleTodosC3(n, $event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
</th>
<th class="th-ordenable" style="min-width:150px; width:150px; max-width:150px;" @click="ordenarC3('partNumber')">
  <input class="th-search-input" v-model="filterC3.partNumber" :placeholder="$t('buscar')+'...'" @click.stop />
  <span class="th-label">{{ $t('part_number') }} <i :class="iconoOrdenC3('partNumber')"></i></span>
</th>
                              <th class="th-ordenable" style="min-width:210px; width:210px; max-width:210px;" @click="ordenarC3('partName')">
                                <input class="th-search-input" v-model="filterC3.partName" :placeholder="$t('buscar')+'...'" @click.stop />
                                <span class="th-label">{{ $t('part_name') }} <i :class="iconoOrdenC3('partName')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:300px; width:300px; max-width:300px;" @click="ordenarC3('detalles')">
                                <input class="th-search-input" v-model="filterC3.descripcion" :placeholder="$t('buscar')+'...'" @click.stop />
                                <span class="th-label">{{ $t('descripcion') }} <i :class="iconoOrdenC3('detalles')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:150px;" @click="ordenarC3('brandName')">
                                <input class="th-search-input" v-model="filterC3.brandName" :placeholder="$t('buscar')+'...'" @click.stop />
                                <el-select v-model="filterC3.brandNameSeleccion" multiple collapse-tags filterable size="mini"
                                  :placeholder="$t('fabricante')" class="th-filter-select" @click.native.stop>
                                  <el-option v-for="b in fabricantesC3Options" :key="b" :label="b" :value="b" />
                                </el-select>
                                <span class="th-label">{{ $t('fabricante') }} <i :class="iconoOrdenC3('brandName')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:90px;" @click="ordenarC3('modelo')">
                                <input class="th-search-input" v-model="filterC3.modelo" :placeholder="$t('buscar')+'...'" @click.stop />
                                <span class="th-label">{{ $t('modelo') }} <i :class="iconoOrdenC3('modelo')"></i></span>
                              </th>
                              <th class="th-ordenable text-right" style="min-width:75px;" @click="ordenarC3('horometro')">
                                <input class="th-search-input" v-model="filterC3.horometro" :placeholder="$t('buscar')+'...'" @click.stop />
                                <span class="th-label">{{ $t('horometro') }} <i :class="iconoOrdenC3('horometro')"></i></span>
                              </th>
                              <th class="th-ordenable text-right" style="min-width:75px;" @click="ordenarC3('odometro')">
                                <input class="th-search-input" v-model="filterC3.odometro" :placeholder="$t('buscar')+'...'" @click.stop />
                                <span class="th-label">{{ $t('col_odometro') }} <i :class="iconoOrdenC3('odometro')"></i></span>
                              </th>
                              <th class="th-ordenable" style="min-width:55px; width:55px; max-width:55px;" @click="ordenarC3('cantidad')">
                                <span class="th-label">{{ $t('qty') }} <i :class="iconoOrdenC3('cantidad')"></i></span>
                              </th>
                              <th class="th-ordenable" style="white-space: normal; min-width:90px;" @click="ordenarC3('valorSugeridoGeneral')">
                                <span class="th-label">Valor Sugerido<br>(USD) <i :class="iconoOrdenC3('valorSugeridoGeneral')"></i></span>
                              </th>
                              <th class="th-ordenable" style="white-space: normal; min-width:90px;" @click="ordenarC3('valorSugeridoGeneralTotal')">
                                <span class="th-label">Total Suggested<br>Value (USD) <i :class="iconoOrdenC3('valorSugeridoGeneralTotal')"></i></span>
                              </th>
                              <th class="th-ordenable" @click="ordenarC3('criterioPorCantidad')">
                                <input class="th-search-input" v-model="filterC3.criterioPorCantidad" @click.stop />
                                <span class="th-label">{{ $t('criterioPorCantidad') }} <i :class="iconoOrdenC3('criterioPorCantidad')"></i></span>
                              </th>
                              <th class="th-ordenable" @click="ordenarC3('criterioPorClase')">
                                <input class="th-search-input" v-model="filterC3.criterioPorClase" :placeholder="$t('buscar')+'...'" @click.stop />
                                <span class="th-label">{{ $t('criterioPorClase') }} <i :class="iconoOrdenC3('criterioPorClase')"></i></span>
                              </th>
                              <th class="th-ordenable" @click="ordenarC3('criterioPorCategoria')">
                                <input class="th-search-input" v-model="filterC3.criterioPorCategoria" :placeholder="$t('buscar')+'...'" @click.stop />
                                <span class="th-label">{{ $t('criterioPorCategoria') }} <i :class="iconoOrdenC3('criterioPorCategoria')"></i></span>
                              </th>
                              <th class="th-ordenable" @click="ordenarC3('criterioPorFamilia')">
                                <input class="th-search-input" v-model="filterC3.criterioPorFamilia" :placeholder="$t('buscar')+'...'" @click.stop />
                                <span class="th-label">{{ $t('criterioPorFamilia') }} <i :class="iconoOrdenC3('criterioPorFamilia')"></i></span>
                              </th>
                              <th class="th-ordenable" @click="ordenarC3('criterioPorSegmento')">
                                <input class="th-search-input" v-model="filterC3.criterioPorSegmento" :placeholder="$t('buscar')+'...'" @click.stop />
                                <span class="th-label">{{ $t('criterioPorSegmento') }} <i :class="iconoOrdenC3('criterioPorSegmento')"></i></span>
                              </th>
                              <th class="th-ordenable" @click="ordenarC3('criterioPorMarca')">
                                <input class="th-search-input" v-model="filterC3.criterioPorMarca" :placeholder="$t('buscar')+'...'" @click.stop />
                                <span class="th-label">{{ $t('criterioPorMarca') }} <i :class="iconoOrdenC3('criterioPorMarca')"></i></span>
                              </th>
                              <th class="th-ordenable" @click="ordenarC3('criterioPorPartName')">
                                <input class="th-search-input" v-model="filterC3.criterioPorPartName" :placeholder="$t('buscar')+'...'" @click.stop />
                                <span class="th-label">{{ $t('criterioPorPartName') }} <i :class="iconoOrdenC3('criterioPorPartName')"></i></span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="row in custom3DataFiltrado" :key="row.idMaterialETL">
                            <!-- C1 -->
<td class="text-center" style="min-width: 35px;">
  <input type="checkbox"
         :checked="isC3Checked(row, 1)"
         @change="onToggleC3(row, 1, $event.target.checked)" />
</td>
<!-- C2 -->
<td class="text-center" style="min-width: 35px;">
  <input type="checkbox"
         :checked="isC3Checked(row, 2)"
         @change="onToggleC3(row, 2, $event.target.checked)" />
</td>
<!-- C3 -->
<td class="text-center" style="min-width: 35px;">
  <input type="checkbox"
         :checked="isC3Checked(row, 3)"
         @change="onToggleC3(row, 3, $event.target.checked)" />
</td>
<!-- Extras C4..CN -->
<td v-for="n in criterioC3ExtraRange"
    :key="'c3c-'+row.idMaterialETL+'-'+n"
    class="text-center" style="min-width: 35px;">
  <input type="checkbox"
         :checked="isC3Checked(row, n)"
         @change="onToggleC3(row, n, $event.target.checked)" />
</td>

                              <td style="max-width:150px;">
                                <el-tooltip :content="row.partNumber || '—'" placement="top" :disabled="!row.partNumber" effect="dark">
                                  <span class="d-inline-block text-truncate txt-truncate-sm" style="max-width:150px;">{{ textoCorto(row.partNumber, 40) }}</span>
                                </el-tooltip>
                              </td>
                              <td style="max-width:210px;">
                                <el-tooltip :content="row.partName || '—'" placement="top" :disabled="!row.partName" effect="dark">
                                  <span class="d-inline-block text-truncate txt-truncate-sm" style="max-width:210px;">{{ textoCorto(row.partName, 60) }}</span>
                                </el-tooltip>
                              </td>
                              <td style="max-width:300px;">
                                <el-tooltip :content="row.detalles || '—'" placement="top" :disabled="!row.detalles" effect="dark">
                                  <span class="text-primary text-truncate d-inline-block txt-truncate-sm"
                                    style="cursor:pointer; max-width: 300px;"
                                    @click="$bvModal.show('modal-c3-detalle'); detalleSeleccionado = row.detalles">
                                    {{ textoCorto(row.detalles, 80) }}
                                  </span>
                                </el-tooltip>
                              </td>
                              <td>{{ row.brandName || '—' }}</td>
                              <td>{{ row.modelo || '—' }}</td>
                              <td class="text-right">{{ row.horometro || '—' }}</td>
                              <td class="text-right">{{ row.odometro || '—' }}</td>

                              <td class="text-right" style="min-width:55px; width:55px; max-width:55px;">{{ row.cantidad }}</td>
                              <td class="text-right" style="min-width: 120px;">{{
                                formatPrecio(row.valorSugeridoGeneral) }}</td>
                              <td class="text-right" style="min-width: 140px;">{{
                                formatPrecio(row.valorSugeridoGeneralTotal) }}</td>

                              <!-- NUEVAS celdas -->
                              <td class="text-right">{{ row.criterioPorCantidad }}</td>
                              <td class="text-right">{{ row.criterioPorClase }}</td>
                              <td class="text-right">{{ row.criterioPorCategoria }}</td>
                              <td class="text-right">{{ row.criterioPorFamilia }}</td>
                              <td class="text-right">{{ row.criterioPorSegmento }}</td>
                              <td class="text-right">{{ row.criterioPorMarca }}</td>
                              <td class="text-right">{{ row.criterioPorPartName }}</td>
                            </tr>
                          </tbody>
                        </table>
                        </div><!-- /tabla-scroll-fixed C3 -->

                        <!-- barra scroll C3 -->
                        <div class="pagination-floating-bar justify-content-between">
                          <span class="text-muted small">{{ custom3DataFiltrado.length }} / {{ custom3Data.length }} {{ $t('items_label') }}</span>
                          <div class="d-flex align-items-center" style="gap:6px;">
                            <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollC3','left')" title="Scroll izquierda"><i class="fas fa-chevron-left"></i></button>
                            <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollC3','right')" title="Scroll derecha"><i class="fas fa-chevron-right"></i></button>
                            <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollC3','top')" title="Ir al inicio"><i class="fas fa-chevron-up"></i></button>
                            <button class="btn btn-sm btn-scroll-nav" @click="scrollTablaCustom('tablaScrollC3','bottom')" title="Ir al final"><i class="fas fa-chevron-down"></i></button>
                          </div>
                        </div>
                      </div>

                      <!-- Modal para ver Description completo -->
                      <b-modal id="modal-c3-detalle" :title="$t('detalle_completo')" size="lg" ok-only :ok-title="$t('cerrar')"
                        hide-footer>
                        <p class="text-justify">{{ detalleSeleccionado }}</p>
                      </b-modal>
                    </div>
                    <!-- ===== /VISTA CUSTOM 3 ===== -->


                  </div>
                </b-col>
              </b-row>

            </div>


          </div>
        </b-col>
      </b-row>
    </b-container>
   
    
    <!-- Modal de Ranking  -->
    <b-modal id="modal-ranking"
         :title="`Ranking de Clusters ${rankingContext && rankingContext.numeroCluster ? rankingContext.numeroCluster : ''}`"
         size="lg">
      <div v-if="rankingError" class="alert alert-danger mb-3">{{ rankingError }}</div>

      <div v-if="!rankingError && rankingItems.length === 0" class="text-muted">
        No hay datos para mostrar.
      </div>

      <div v-else>
       <table class="table table-striped table-bordered" style="width: 100%">
  <thead>
    <tr>
      <th style="width: 90px;">Seleccionar</th>
      <th @click="ordenarPor('nombreCluster')" style="cursor:pointer">
        Nombre Cluster
        <span v-if="ordenCampo === 'nombreCluster'">
          {{ ordenAsc ? '▲' : '▼' }}
        </span>
      </th>
      <th @click="ordenarPor('valor')" style="cursor:pointer">
        Valor
        <span v-if="ordenCampo === 'valor'">
          {{ ordenAsc ? '▲' : '▼' }}
        </span>
      </th>
      <th @click="ordenarPor('id')" style="cursor:pointer">
        ID
        <span v-if="ordenCampo === 'id'">
          {{ ordenAsc ? '▲' : '▼' }}
        </span>
      </th>
      <th @click="ordenarPor('criterio')" style="cursor:pointer">
        {{ $t('criterio') }}
        <span v-if="ordenCampo === 'criterio'">
          {{ ordenAsc ? '▲' : '▼' }}
        </span>
      </th>
    </tr>
  </thead>

  <tbody>
    <tr v-for="(item, idx) in rankingOrdenado" :key="rankingRowKey(item, idx)">
  <td>
    <input
      type="checkbox"
      :checked="isRankingRowSelected(item, idx)"
      :disabled="!puedeEscribir" @change="onToggleRankingRow(item, idx, $event.target.checked)"
    />
  </td>
  <td>{{ item.nombreCluster || '-' }}</td>
  <td>{{ formatearMiles(item.valor) }}</td>
  <td>{{ item.id }}</td>
  <td>{{ item.criterio }}</td>
</tr>
  </tbody>
</table>
      </div>

      <!-- Footer con botones -->
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-ranking')">
          Cancelar
        </b-button>
        <b-button v-if="puedeEscribir" variant="success" class="ml-2"
          :disabled="guardandoRanking || rankingSelectedCount === 0"
          @click="guardarRankingSeleccion">
          {{ guardandoRanking ? 'Guardando…' : 'Guardar' }}
        </b-button>
      </template>
    </b-modal>

    <!-- Ayuda de la columna Valor Unitario Sugerido -->
    <b-modal v-model="modalInfoValorSugerido"
             :title="$t('info_valor_sugerido_titulo')"
             size="md" centered ok-only :ok-title="$t('cerrar')">
      <div class="d-flex">
        <i class="fas fa-info-circle text-primary mr-3 mt-1" style="font-size:1.4rem;"></i>
        <p class="mb-0">{{ $t('info_valor_sugerido_texto') }}</p>
      </div>
    </b-modal>
  </div>

</template>

<script>
import materialService from "@/api/materialService";
import utilsService from "@/api/utilsService";
import { Select, Option } from "element-ui";
import RadarChart from '@/components/RadarChart.vue'
import Swal from 'sweetalert2'

export default {
  name: "ClusterizacionView",
  components: {
    RadarChart,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      lang: localStorage.getItem('language') || 'es',
      // Propiedades para checkboxes de Resumen de Clusters
      checkAllResumen: false,
      clustersSelectedResumen: [],
      
      showGraficoModal: false,
      buscarCluster: '',
      filterColArchivos: { nombreXLSX: '', estadoFlujoDesc: '', fechaRentabilizacion: '', fechaClusterizacion: '', tipoFlujo: '' },
      ordenColumnaArchivos: null,
      ordenDireccionArchivos: 'asc',
      filterResumen: { totalSuggestedValue: '', valorLibroTotal: '', valorPromedio: '', cantidadTotal: '', cantidadPromedio: '', registros: '' },
      ordenResumen: { campo: '', dir: 1 },
      currentPageResumen: 1,
      pageSizeResumen: 50,
      filterDetalle: { nombre: '', id: '', valorTotal: '', valorLibro: '', valorLibroTotal: '', brandName: '', modelo: '', horometro: '', odometro: '', partNumber: '', cantidad: '', condicion: '', unidadDeMedida: '' },
      ordenDetalle: { campo: '', dir: 1 },
      filtrarSeleccionadasC1: false,
      filtrarSeleccionadasC2: false,
      filtrarSeleccionadasC3: false,
      filterC1: { partNumber: '', partName: '', descripcion: '', brandName: '', brandNameSeleccion: [], modelo: '', horometro: '', odometro: '', criterioPorCantidad: '', criterioPorClase: '', criterioPorCategoria: '', criterioPorFamilia: '', criterioPorSegmento: '', criterioPorMarca: '', criterioPorPartName: '' },
      filterC2: { partNumber: '', partName: '', descripcion: '', brandName: '', brandNameSeleccion: [], modelo: '', horometro: '', odometro: '', criterioPorCantidad: '', criterioPorClase: '', criterioPorCategoria: '', criterioPorFamilia: '', criterioPorSegmento: '', criterioPorMarca: '', criterioPorPartName: '' },
      filterC3: { partNumber: '', partName: '', descripcion: '', brandName: '', brandNameSeleccion: [], modelo: '', horometro: '', odometro: '', criterioPorCantidad: '', criterioPorClase: '', criterioPorCategoria: '', criterioPorFamilia: '', criterioPorSegmento: '', criterioPorMarca: '', criterioPorPartName: '' },
      ordenC1: { campo: '', dir: 1 },
      ordenC2: { campo: '', dir: 1 },
      ordenC3: { campo: '', dir: 1 },
      finalizandoCustom1: false,
finalizandoCustom2: false,
finalizandoCustom3: false,
      ordenCampo: 'valor',
      ordenAsc: false,
      rankingContext: { idCriterio: null, numeroCluster: null },
      sinDatos: false,
      msgSinDatos: this.$t('no_hay_datos_criterio'),
      seHizoConsultaResumen: false,  
      pollErrorCount: 0,
      pollErrorMax: 3,  
      pollTimerId: null,
      pollIntervalMs: 4000, // cada 4s
      cargandoRanking: false,
      rankingItems: [],
      rankingFields: [],
      rankingError: null,
      rankingSelectedKeys: new Set(),
      rankingSelectedCount: 0, 
      guardandoRanking: false,
      isEditing: false,
      archivoPendienteFinalizacion: null,
      archivoPendienteFinalizacionCustom3: null,
      archivoPendienteFinalizacionCustom2: null,
      archivoPendienteFinalizacionCustom1: null,
      mostrarCustom3: false,
      cargandoCustom3: false,
      custom3Data: [],
      initialCustom3Data: [],
      currentPageC3: 1,
      pageSizeC3: 100,
      mostrarCustom2: false,
      cargandoCustom2: false,
      custom2Data: [],
      initialCustom2Data: [],
      currentPageC2: 1,
      pageSizeC2: 100,
      mostrarCustom1: false,
      cargandoCustom1: false,
      custom1Data: [],
      initialCustom1Data: [],
      currentPageC1: 1,
      pageSizeC1: 100,
      c1Max: 3,
c2Max: 3,  
c3Max: 3,  
      detalleSeleccionado: '',
      clusterDetalleNombre: '',
      clusterResumen: [],
      mostrarDetalleCluster: false,
      // Ayuda de la columna Valor Unitario Sugerido del detalle
      modalInfoValorSugerido: false,
      clusterDetalle: [],
      currentPageDetalle: 1,
      pageSizeDetalle: 100,
      empresasCliente: [],
      archivosLogs: [],
      archivoSeleccionado: null,
      archivosConsultados: false,
      resultados: [], // Aquí irán los resultados del proceso
      mostrarCluster: false,
      tipoClusterSeleccionado: null,
      clusterData: [],
      tiposCluster: [
        { texto: this.$t('cluster_por_cantidad'), id: 1 },
        { texto: this.$t('cluster_por_clase'), id: 2 },
        { texto: this.$t('cluster_por_categoria'), id: 3 },
        { texto: this.$t('cluster_por_familia'), id: 4 },
        { texto: this.$t('cluster_por_segmento'), id: 5 },
        { texto: this.$t('cluster_por_marca'), id: 6 },
        { texto: this.$t('cluster_por_partname'), id: 7 },
        { texto: this.$t('cluster_por_modelo_equipo') || 'Modelo de Equipo', id: 11 }
      ],
    };
  },
  async mounted() {
  this.$store.dispatch('setSidebarCollapsed', false);
  try {
    const resp = await materialService.getEmpresasAsociadas();
    const data = (resp && resp.data) ? resp.data
                : (resp && resp.items) ? resp.items
                : resp;
    this.empresasCliente = Array.isArray(data) ? data : [];
    console.log('Empresas cargadas:', this.empresasCliente.length, this.empresasCliente);
  } catch (error) {
    console.error("Error al cargar empresas:", error);
    this.empresasCliente = [];
  }
  if (this.empresaSeleccionada) {
    await this.onEmpresaSeleccionada();
  }
  window.addEventListener('scroll', this._onWindowScrollC1);
  window.addEventListener('scroll', this._onWindowScrollC2);
  window.addEventListener('scroll', this._onWindowScrollC3);
  window.addEventListener('scroll', this._onWindowScrollResumen);
  window.addEventListener('scroll', this._onWindowScrollDetalle);
},
  beforeDestroy() {
  this.$store.dispatch('setSidebarCollapsed', false);
  this.stopPollingEstado();
  window.removeEventListener('scroll', this._onWindowScrollC1);
  window.removeEventListener('scroll', this._onWindowScrollC2);
  window.removeEventListener('scroll', this._onWindowScrollC3);
  window.removeEventListener('scroll', this._onWindowScrollResumen);
  window.removeEventListener('scroll', this._onWindowScrollDetalle);
},
  computed: {
    empresaSeleccionada: {
      get() { return this.$store.getters.empresaActiva; },
      set(val) { this.$store.dispatch('setEmpresaActiva', val); },
    },
    rol() {
      return (utilsService.getRol() || '').toLowerCase().trim();
    },
    showEmpresaBadge() {
      return (this.rol === 'cliente' || this.rol === 'ventas inex') && this.empresasCliente.length === 1;
    },
    nombreEmpresaSeleccionada() {
      const e = (this.empresasCliente || []).find(x => x.id === this.empresaSeleccionada);
      return e ? (e.nombre || '') : '';
    },
    processedArchivosLogs() {
      const f = this.filterColArchivos;
      let rows = (this.archivosLogs || []).filter(a => {
        for (const k in f) {
          const needle = String(f[k] == null ? '' : f[k]).trim().toLowerCase();
          if (!needle) continue;
          const cell = k === 'estadoFlujoDesc'
            ? (String(a.estadoFlujoDesc || '') + ' ' + String(a.estadoFlujo || '')).toLowerCase()
            : String(a[k] == null ? '' : a[k]).toLowerCase();
          if (!cell.includes(needle)) return false;
        }
        return true;
      });
      if (this.ordenColumnaArchivos) {
        const key = this.ordenColumnaArchivos;
        const dir = this.ordenDireccionArchivos === 'asc' ? 1 : -1;
        rows = [...rows].sort((a, b) => {
          let va = a[key] == null ? '' : a[key];
          let vb = b[key] == null ? '' : b[key];
          if (!isNaN(Date.parse(va)) && !isNaN(Date.parse(vb))) return (new Date(va) - new Date(vb)) * dir;
          va = String(va).toLowerCase();
          vb = String(vb).toLowerCase();
          return va < vb ? -dir : va > vb ? dir : 0;
        });
      }
      return rows;
    },

    rankingOrdenado() {
  if (!Array.isArray(this.rankingItems)) return [];
  const arr = this.rankingItems.slice();
  const campo = this.ordenCampo;
  const asc = this.ordenAsc ? 1 : -1;

  return arr.sort((a, b) => {
    const av = (a && a[campo] !== null && a[campo] !== undefined) ? a[campo] : '';
    const bv = (b && b[campo] !== null && b[campo] !== undefined) ? b[campo] : '';

    const an = parseFloat(av);
    const bn = parseFloat(bv);
    if (!isNaN(an) && !isNaN(bn)) return (an - bn) * asc;

    const sa = String(av).toLowerCase();
    const sb = String(bv).toLowerCase();
    return sa.localeCompare(sb) * asc;
  });
},
    criterioC1Range() {
  // array [1, 2, ..., c1Max]
  return Array.from({ length: Math.max(3, this.c1Max) }, (_, i) => i + 1);
},
criterioC1ExtraRange() {
  const max = Math.max(3, this.c1Max);
  // Devuelve [4, 5, ..., max]; si max==3 => []
  return Array.from({ length: Math.max(0, max - 3) }, (_, i) => i + 4);
},
criterioC2ExtraRange() {
  const max = Math.max(3, this.c2Max);
  return Array.from({ length: Math.max(0, max - 3) }, (_, i) => i + 4); // [4..max]
},
criterioC3ExtraRange() {
  const max = Math.max(3, this.c3Max);
  return Array.from({ length: Math.max(0, max - 3) }, (_, i) => i + 4); // [4..max]
},


radarChartValues() {
  if (!this.clusterResumen || this.clusterResumen.length === 0) return [];

  return this.clusterResumen.map(x => {
    // parseNumero y no un replace directo: quitar todos los puntos convertia
    // 136.29 en 13629, inflando el radar x100 en los valores con decimales.
    const val = this.parseNumero(x.valor || x.Valor || 0);

    const numCluster = (
      x.nombreCluster ||
      x.NombreCluster ||
      x.cluster ||
      x.numeroCluster ||
      ''
    ).toString();

    return {
      label: numCluster,
      value: val
    };
  });
},

    shouldShowSinDatos() {
  // si no hay datos
  if (!(this.seHizoConsultaResumen && this.sinDatos)) return false;

  // si estoy en custom 1/2/3 y finalizado, ocultar mensaje
  const t = this.tipoClusterSeleccionado;
  if (t && (
    (t.id === 8 && this.isCustom1Finalizado) ||
    (t.id === 9 && this.isCustom2Finalizado) ||
    (t.id === 10 && this.isCustom3Finalizado)
  )) {
    return false;
  }

  // en cualquier otro caso, mostrar
  return !this.isCustomMode && !this.mostrarDetalleCluster;
},
    totalPagesResumen() {
      return Math.max(1, Math.ceil(this.clusterResumenFiltrado.length / this.pageSizeResumen));
    },
    clusterResumenPaginado() {
      const start = (this.currentPageResumen - 1) * this.pageSizeResumen;
      return this.clusterResumenFiltrado.slice(start, start + this.pageSizeResumen);
    },
    clusterDetalleFiltrado() {
      let data = this.clusterDetalle || [];
      const f = this.filterDetalle;
      if (f.nombre) data = data.filter(r => (r.nombre || '').toLowerCase().includes(f.nombre.toLowerCase()));
      if (f.id) data = data.filter(r => String(r.id || '').toLowerCase().includes(f.id.toLowerCase()));
      if (f.valorTotal) data = data.filter(r => String(r.valorTotal != null ? r.valorTotal : (r.ValorTotal != null ? r.ValorTotal : '')).includes(f.valorTotal));
      if (f.valorLibro) data = data.filter(r => String(r.valorLibro != null ? r.valorLibro : (r.ValorLibro != null ? r.ValorLibro : '')).includes(f.valorLibro));
      if (f.valorLibroTotal) data = data.filter(r => String(r.valorLibroTotal != null ? r.valorLibroTotal : (r.ValorLibroTotal != null ? r.ValorLibroTotal : '')).includes(f.valorLibroTotal));
      if (f.brandName) data = data.filter(r => (r.brandName || '').toLowerCase().includes(f.brandName.toLowerCase()));
      if (f.modelo) data = data.filter(r => (r.modelo || '').toLowerCase().includes(f.modelo.toLowerCase()));
      if (f.horometro) data = data.filter(r => String(r.horometro || '').toLowerCase().includes(f.horometro.toLowerCase()));
      if (f.odometro) data = data.filter(r => String(r.odometro || '').toLowerCase().includes(f.odometro.toLowerCase()));
      if (f.partNumber) data = data.filter(r => (r.partNumber || '').toLowerCase().includes(f.partNumber.toLowerCase()));
      if (f.cantidad) data = data.filter(r => String(r.cantidad != null ? r.cantidad : '').includes(f.cantidad));
      if (f.condicion) data = data.filter(r => (r.condicion || '').toLowerCase().includes(f.condicion.toLowerCase()));
      if (f.unidadDeMedida) data = data.filter(r => (r.unidadDeMedida || '').toLowerCase().includes(f.unidadDeMedida.toLowerCase()));
      const { campo, dir } = this.ordenDetalle;
      if (campo) {
        // Los campos de valor pueden llegar con la inicial en mayúscula segun
        // como serialice la API, por eso el fallback antes de comparar.
        const valorDe = (row, col) => {
          if (col === 'valorTotal') return row.valorTotal != null ? row.valorTotal : (row.ValorTotal || 0);
          if (col === 'valorLibro') return row.valorLibro != null ? row.valorLibro : (row.ValorLibro || 0);
          if (col === 'valorLibroTotal') return row.valorLibroTotal != null ? row.valorLibroTotal : (row.ValorLibroTotal || 0);
          return row[col];
        };
        data = data.slice().sort((a, b) => {
          const av = valorDe(a, campo);
          const bv = valorDe(b, campo);
          const an = parseFloat(av); const bn = parseFloat(bv);
          if (!isNaN(an) && !isNaN(bn)) return (an - bn) * dir;
          return String(av || '').localeCompare(String(bv || '')) * dir;
        });
      }
      return data;
    },
    totalPagesDetalle() {
      return Math.max(1, Math.ceil(this.clusterDetalleFiltrado.length / this.pageSizeDetalle));
    },
    indexInicioDetalle() {
      return (this.currentPageDetalle - 1) * this.pageSizeDetalle;
    },
    pagedDetalle() {
      const start = this.indexInicioDetalle;
      const end = start + this.pageSizeDetalle;
      return this.clusterDetalleFiltrado.slice(start, end);
    },
  isEstadoC() {
  return this.getEstadoFlujoLocal() === 'C';
},
isEstadoT() {
  return this.getEstadoFlujoLocal() === 'T';
},
isEstadoG() {
  return this.getEstadoFlujoLocal() === 'G';
},
isEstadoCT() {
  const e = this.getEstadoFlujoLocal();
  return e === 'C' || e === 'T' || e === 'G' || e === 'E';
},
    hasEmpresas() {
    return Array.isArray(this.empresasCliente) && this.empresasCliente.length > 0;
  },
    rankingTableFields() {
      // Inserta la columna de selección al inicio
      return [
        { key: '__sel', label: 'Seleccionar' },
        ...(this.rankingFields || [])
      ];
    },
    clusterResumenFiltrado() {
      let data = this.clusterResumen || [];
      if (this.buscarCluster && this.buscarCluster.trim()) {
        const q = this.buscarCluster.trim().toLowerCase();
        data = data.filter(item => {
          const nombre = (item.nombreCluster || item.NombreCluster || item.NombreClase || item.nombreClase || item.cluster || item.numeroCluster || '').toString().toLowerCase();
          return nombre.includes(q);
        });
      }
      const f = this.filterResumen;
      if (f.totalSuggestedValue) data = data.filter(r => String(r.valor || r.Valor || '').includes(f.totalSuggestedValue));
      if (f.valorLibroTotal) data = data.filter(r => String(r.valorLibro || r.ValorLibro || '').includes(f.valorLibroTotal));
      if (f.valorPromedio) data = data.filter(r => String(r.valorPromedio || r.ValorPromedio || '').includes(f.valorPromedio));
      if (f.cantidadTotal) data = data.filter(r => String(r.cantidadTotal || r.CantidadTotal || '').includes(f.cantidadTotal));
      if (f.cantidadPromedio) data = data.filter(r => String(r.cantidadPromedio || r.CantidadPromedio || '').includes(f.cantidadPromedio));
      if (f.registros) data = data.filter(r => String(r.registros || r.Registros || '').includes(f.registros));
      const { campo, dir } = this.ordenResumen;
      if (campo) {
        data = data.slice().sort((a, b) => {
          let av, bv;
          if (campo === 'cluster') {
            av = (a.nombreCluster || a.NombreCluster || a.NombreClase || a.nombreClase || a.cluster || a.numeroCluster || '');
            bv = (b.nombreCluster || b.NombreCluster || b.NombreClase || b.nombreClase || b.cluster || b.numeroCluster || '');
          } else if (campo === 'totalSuggestedValue') {
            av = a.valor || a.Valor || 0; bv = b.valor || b.Valor || 0;
          } else if (campo === 'valorLibroTotal') {
            av = a.valorLibro || a.ValorLibro || 0; bv = b.valorLibro || b.ValorLibro || 0;
          } else if (campo === 'valorPromedio') {
            av = a.valorPromedio || a.ValorPromedio || 0; bv = b.valorPromedio || b.ValorPromedio || 0;
          } else if (campo === 'cantidadTotal') {
            av = a.cantidadTotal || a.CantidadTotal || 0; bv = b.cantidadTotal || b.CantidadTotal || 0;
          } else if (campo === 'cantidadPromedio') {
            av = a.cantidadPromedio || a.CantidadPromedio || 0; bv = b.cantidadPromedio || b.CantidadPromedio || 0;
          } else if (campo === 'registros') {
            av = a.registros || a.Registros || 0; bv = b.registros || b.Registros || 0;
          } else {
            av = a[campo]; bv = b[campo];
          }
          const an = parseFloat(av); const bn = parseFloat(bv);
          if (!isNaN(an) && !isNaN(bn)) return (an - bn) * dir;
          return String(av || '').localeCompare(String(bv || '')) * dir;
        });
      }
      return data;
    },
    // Checklist de Fabricante: opciones sacadas de lo ya cargado para ese cluster custom
    // (no hay catalogo global de fabricantes), igual que los filtros de usuario del
    // modal de detalle en /analytics.
    fabricantesC1Options() {
      const vistos = new Set((this.custom1Data || []).map(r => r.brandName).filter(Boolean));
      return Array.from(vistos).sort((a, b) => a.localeCompare(b, 'es'));
    },
    fabricantesC2Options() {
      const vistos = new Set((this.custom2Data || []).map(r => r.brandName).filter(Boolean));
      return Array.from(vistos).sort((a, b) => a.localeCompare(b, 'es'));
    },
    fabricantesC3Options() {
      const vistos = new Set((this.custom3Data || []).map(r => r.brandName).filter(Boolean));
      return Array.from(vistos).sort((a, b) => a.localeCompare(b, 'es'));
    },
    custom1DataFiltrado() {
  let data = this.custom1Data || [];
  const f = this.filterC1;
  if (f.partNumber) data = data.filter(r => (r.partNumber || '').toLowerCase().includes(f.partNumber.toLowerCase()));
  if (f.partName) data = data.filter(r => (r.partName || '').toLowerCase().includes(f.partName.toLowerCase()));
  if (f.descripcion) data = data.filter(r => (r.detalles || '').toLowerCase().includes(f.descripcion.toLowerCase()));
  if (f.brandName) data = data.filter(r => (r.brandName || '').toLowerCase().includes(f.brandName.toLowerCase()));
  if (f.brandNameSeleccion && f.brandNameSeleccion.length) data = data.filter(r => f.brandNameSeleccion.includes(r.brandName));
  if (f.modelo) data = data.filter(r => (r.modelo || '').toLowerCase().includes(f.modelo.toLowerCase()));
  if (f.horometro) data = data.filter(r => (r.horometro || '').toString().toLowerCase().includes(f.horometro.toLowerCase()));
  if (f.odometro) data = data.filter(r => (r.odometro || '').toString().toLowerCase().includes(f.odometro.toLowerCase()));
  if (f.criterioPorCantidad) data = data.filter(r => (r.criterioPorCantidad || '').toLowerCase().includes(f.criterioPorCantidad.toLowerCase()));
  if (f.criterioPorClase) data = data.filter(r => (r.criterioPorClase || '').toLowerCase().includes(f.criterioPorClase.toLowerCase()));
  if (f.criterioPorCategoria) data = data.filter(r => (r.criterioPorCategoria || '').toLowerCase().includes(f.criterioPorCategoria.toLowerCase()));
  if (f.criterioPorFamilia) data = data.filter(r => (r.criterioPorFamilia || '').toLowerCase().includes(f.criterioPorFamilia.toLowerCase()));
  if (f.criterioPorSegmento) data = data.filter(r => (r.criterioPorSegmento || '').toLowerCase().includes(f.criterioPorSegmento.toLowerCase()));
  if (f.criterioPorMarca) data = data.filter(r => (r.criterioPorMarca || '').toLowerCase().includes(f.criterioPorMarca.toLowerCase()));
  if (f.criterioPorPartName) data = data.filter(r => (r.criterioPorPartName || '').toLowerCase().includes(f.criterioPorPartName.toLowerCase()));
  if (this.filtrarSeleccionadasC1) data = data.filter(r => this.hasSeleccionC1(r));
  const { campo, dir } = this.ordenC1;
  if (campo) {
    data = data.slice().sort((a, b) => {
      const av = a[campo]; const bv = b[campo];
      const an = parseFloat(av); const bn = parseFloat(bv);
      if (!isNaN(an) && !isNaN(bn)) return (an - bn) * dir;
      return String(av || '').localeCompare(String(bv || '')) * dir;
    });
  }
  return data;
},
custom2DataFiltrado() {
  let data = this.custom2Data || [];
  const f = this.filterC2;
  if (f.partNumber) data = data.filter(r => (r.partNumber || '').toLowerCase().includes(f.partNumber.toLowerCase()));
  if (f.partName) data = data.filter(r => (r.partName || '').toLowerCase().includes(f.partName.toLowerCase()));
  if (f.descripcion) data = data.filter(r => (r.detalles || '').toLowerCase().includes(f.descripcion.toLowerCase()));
  if (f.brandName) data = data.filter(r => (r.brandName || '').toLowerCase().includes(f.brandName.toLowerCase()));
  if (f.brandNameSeleccion && f.brandNameSeleccion.length) data = data.filter(r => f.brandNameSeleccion.includes(r.brandName));
  if (f.modelo) data = data.filter(r => (r.modelo || '').toLowerCase().includes(f.modelo.toLowerCase()));
  if (f.horometro) data = data.filter(r => (r.horometro || '').toString().toLowerCase().includes(f.horometro.toLowerCase()));
  if (f.odometro) data = data.filter(r => (r.odometro || '').toString().toLowerCase().includes(f.odometro.toLowerCase()));
  if (f.criterioPorCantidad) data = data.filter(r => (r.criterioPorCantidad || '').toLowerCase().includes(f.criterioPorCantidad.toLowerCase()));
  if (f.criterioPorClase) data = data.filter(r => (r.criterioPorClase || '').toLowerCase().includes(f.criterioPorClase.toLowerCase()));
  if (f.criterioPorCategoria) data = data.filter(r => (r.criterioPorCategoria || '').toLowerCase().includes(f.criterioPorCategoria.toLowerCase()));
  if (f.criterioPorFamilia) data = data.filter(r => (r.criterioPorFamilia || '').toLowerCase().includes(f.criterioPorFamilia.toLowerCase()));
  if (f.criterioPorSegmento) data = data.filter(r => (r.criterioPorSegmento || '').toLowerCase().includes(f.criterioPorSegmento.toLowerCase()));
  if (f.criterioPorMarca) data = data.filter(r => (r.criterioPorMarca || '').toLowerCase().includes(f.criterioPorMarca.toLowerCase()));
  if (f.criterioPorPartName) data = data.filter(r => (r.criterioPorPartName || '').toLowerCase().includes(f.criterioPorPartName.toLowerCase()));
  if (this.filtrarSeleccionadasC2) data = data.filter(r => this.hasSeleccionC2(r));
  const { campo, dir } = this.ordenC2;
  if (campo) {
    data = data.slice().sort((a, b) => {
      const av = a[campo]; const bv = b[campo];
      const an = parseFloat(av); const bn = parseFloat(bv);
      if (!isNaN(an) && !isNaN(bn)) return (an - bn) * dir;
      return String(av || '').localeCompare(String(bv || '')) * dir;
    });
  }
  return data;
},
custom3DataFiltrado() {
  let data = this.custom3Data || [];
  const f = this.filterC3;
  if (f.partNumber) data = data.filter(r => (r.partNumber || '').toLowerCase().includes(f.partNumber.toLowerCase()));
  if (f.partName) data = data.filter(r => (r.partName || '').toLowerCase().includes(f.partName.toLowerCase()));
  if (f.descripcion) data = data.filter(r => (r.detalles || '').toLowerCase().includes(f.descripcion.toLowerCase()));
  if (f.brandName) data = data.filter(r => (r.brandName || '').toLowerCase().includes(f.brandName.toLowerCase()));
  if (f.brandNameSeleccion && f.brandNameSeleccion.length) data = data.filter(r => f.brandNameSeleccion.includes(r.brandName));
  if (f.modelo) data = data.filter(r => (r.modelo || '').toLowerCase().includes(f.modelo.toLowerCase()));
  if (f.horometro) data = data.filter(r => (r.horometro || '').toString().toLowerCase().includes(f.horometro.toLowerCase()));
  if (f.odometro) data = data.filter(r => (r.odometro || '').toString().toLowerCase().includes(f.odometro.toLowerCase()));
  if (f.criterioPorCantidad) data = data.filter(r => (r.criterioPorCantidad || '').toLowerCase().includes(f.criterioPorCantidad.toLowerCase()));
  if (f.criterioPorClase) data = data.filter(r => (r.criterioPorClase || '').toLowerCase().includes(f.criterioPorClase.toLowerCase()));
  if (f.criterioPorCategoria) data = data.filter(r => (r.criterioPorCategoria || '').toLowerCase().includes(f.criterioPorCategoria.toLowerCase()));
  if (f.criterioPorFamilia) data = data.filter(r => (r.criterioPorFamilia || '').toLowerCase().includes(f.criterioPorFamilia.toLowerCase()));
  if (f.criterioPorSegmento) data = data.filter(r => (r.criterioPorSegmento || '').toLowerCase().includes(f.criterioPorSegmento.toLowerCase()));
  if (f.criterioPorMarca) data = data.filter(r => (r.criterioPorMarca || '').toLowerCase().includes(f.criterioPorMarca.toLowerCase()));
  if (f.criterioPorPartName) data = data.filter(r => (r.criterioPorPartName || '').toLowerCase().includes(f.criterioPorPartName.toLowerCase()));
  if (this.filtrarSeleccionadasC3) data = data.filter(r => this.hasSeleccionC3(r));
  const { campo, dir } = this.ordenC3;
  if (campo) {
    data = data.slice().sort((a, b) => {
      const av = a[campo]; const bv = b[campo];
      const an = parseFloat(av); const bn = parseFloat(bv);
      if (!isNaN(an) && !isNaN(bn)) return (an - bn) * dir;
      return String(av || '').localeCompare(String(bv || '')) * dir;
    });
  }
  return data;
},
    showBtnRanking() {
      return (
        !!this.archivoSeleccionado &&
        this.mostrarCluster &&
        this.mostrarResumenPermitido &&
        !this.mostrarCustom1 &&
        !this.mostrarCustom2 &&
        !this.mostrarCustom3 &&
        !this.mostrarDetalleCluster
      );
    },

    showBtnEcommerce() {
      // Muestra el botón solo cuando:
      // - hay archivo seleccionado
      // - estás en la vista de clusters (mostrarCluster)
      // - NO estás en modo edición de Custom 1/2/3
      // - NO estás viendo el detalle de un cluster
      // - y el resumen está permitido (hay datos y cumple reglas de finalización)
      return (
        !!this.archivoSeleccionado &&
        this.mostrarCluster &&
        this.mostrarResumenPermitido &&
        !this.mostrarCustom1 &&
        !this.mostrarCustom2 &&
        !this.mostrarCustom3 &&
        !this.mostrarDetalleCluster
      );
    },
    isEstadoE() {
      const v = this.archivoSeleccionado && (this.archivoSeleccionado.estadoFlujo || this.archivoSeleccionado.EstadoFlujo);
      return this.normalizeEstado(v) === 'E';
    },
    isCustom3Finalizado() {
      const v = (this.archivoSeleccionado && (this.archivoSeleccionado.EstadoCustom3 || this.archivoSeleccionado.estadoCustom3));
      return this.normalizeEstado(v) === 'F';
    },
    mostrarResumenPermitido() {
  const hayResumen = Array.isArray(this.clusterResumen) && this.clusterResumen.length > 0;
  const t = this.tipoClusterSeleccionado;

  // Si no hay criterio seleccionado, permite mostrar (layout base)
  if (!t) return true;

  // Custom 1/2/3: si está F, permitir mostrar SIEMPRE (aunque no haya datos)
  if (t.id === 8) return this.isCustom1Finalizado ? true : hayResumen;
  if (t.id === 9) return this.isCustom2Finalizado ? true : hayResumen;
  if (t.id === 10) return this.isCustom3Finalizado ? true : hayResumen;

  // Otros criterios: mostrar si hay datos
  return hayResumen;
},
    isCustom2Finalizado() {
      const v = (this.archivoSeleccionado && (this.archivoSeleccionado.EstadoCustom2 || this.archivoSeleccionado.estadoCustom2));
      return this.normalizeEstado(v) === 'F';
    },
    isCustomMode() {
      return this.mostrarCustom1 || this.mostrarCustom2 || this.mostrarCustom3;
    },
    // ✅ estado normalizado para decidir si se muestra/oculta “Finalizar”
    isCustom1Finalizado() {
      const v = (this.archivoSeleccionado && (this.archivoSeleccionado.EstadoCustom1 || this.archivoSeleccionado.estadoCustom1));
      return this.normalizeEstado(v) === 'F';
    },
    totalPagesC1() {
      return Math.max(1, Math.ceil(this.custom1DataFiltrado.length / this.pageSizeC1));
    },
    totalPagesC2() {
      return Math.max(1, Math.ceil(this.custom2DataFiltrado.length / this.pageSizeC2));
    },
    totalPagesC3() {
      return Math.max(1, Math.ceil(this.custom3DataFiltrado.length / this.pageSizeC3));
    },
    custom1DataPaginado() {
      const start = (this.currentPageC1 - 1) * this.pageSizeC1;
      return this.custom1DataFiltrado.slice(start, start + this.pageSizeC1);
    },
    custom2DataPaginado() {
      const start = (this.currentPageC2 - 1) * this.pageSizeC2;
      return this.custom2DataFiltrado.slice(start, start + this.pageSizeC2);
    },
    custom3DataPaginado() {
      const start = (this.currentPageC3 - 1) * this.pageSizeC3;
      return this.custom3DataFiltrado.slice(start, start + this.pageSizeC3);
    },

  },

  watch: {
  filterC1: { handler() { this.currentPageC1 = 1; }, deep: true },
  filterC2: { handler() { this.currentPageC2 = 1; }, deep: true },
  filterC3: { handler() { this.currentPageC3 = 1; }, deep: true },
  filterDetalle: { handler() { this.currentPageDetalle = 1; }, deep: true },
  filterResumen: { handler() { this.currentPageResumen = 1; }, deep: true },
  buscarCluster() { this.currentPageResumen = 1; },
  filtrarSeleccionadasC1() { this.currentPageC1 = 1; },
  filtrarSeleccionadasC2() { this.currentPageC2 = 1; },
  filtrarSeleccionadasC3() { this.currentPageC3 = 1; },
  // Loguea SIEMPRE que cambie el arreglo que alimenta la tabla de detalle
  clusterDetalle: {
    handler: function (val) {
      try {
        var arr = Array.isArray(val) ? val : [];
        console.log('📦 clusterDetalle (len=' + arr.length + '):');
        if (arr.length > 0) {
          console.table(arr.slice(0, 20)); // primeras filas
          console.log('🔑 Claves primer elemento:', Object.keys(arr[0]));
        }
        // JSON crudo (copiable)
        try {
          console.log('🧾 JSON clusterDetalle:', JSON.stringify(arr, null, 2));
        } catch (e) {
          console.warn('No se pudo stringify clusterDetalle:', e);
        }
      } catch (e) {
        console.warn('watch clusterDetalle error:', e);
      }
    },
    deep: false,
    immediate: false
  }
},
  methods: {
    formatFechaGmt0(valor) {
      if (!valor) return '—';
      // No se usa Date(): el valor ya viene en GMT 0 desde la BD y Date()
      // lo reinterpretaría como hora local del navegador, corriendo la hora.
      // Se extrae el texto tal cual (YYYY-MM-DD HH:mm) sin conversión de zona horaria.
      const match = String(valor).match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/);
      return match ? `${match[1]} ${match[2]}` : String(valor);
    },
    parseNumero(v) {
    if (v === null || v === undefined) return 0;
    let s = String(v).trim();

    // Formato es-CL: 12.345,67  ó solo miles: 16.089
    if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(s)) {
      s = s.replace(/\./g, '').replace(',', '.'); // "16.089" -> "16089" ; "12.345,67" -> "12345.67"
    }
    // Formato en-US con miles por coma: 12,345.67
    else if (/^\d{1,3}(,\d{3})+(\.\d+)?$/.test(s)) {
      s = s.replace(/,/g, ''); // "12,345.67" -> "12345.67"
    }
    return Number(s) || 0;
  },
    // === C1: normaliza y coloca numeroClusterCustom1 ===
normalizeC1Value(row) {
  if (!row) return 0;
  const picks = [
    'numeroClusterCustom1','NumeroClusterCustom1',
    'clusterCustom1','ClusterCustom1',
    'c1','C1',
    'criterioCustom1','CriterioCustom1',
    'numeroCluster','NumeroCluster' // por si el endpoint trae nombre genérico
  ];
  for (let k of picks) {
    const v = row[k];
    if (v !== undefined && v !== null && String(v).trim() !== '') return Number(v);
  }
  return 0;
},
mapRowC1(row) {
  if (!row || typeof row !== 'object') return row;
  const base = this.mapRowCommon(row); // ya existe en tu archivo
  return {
    ...base,
    numeroClusterCustom1: this.normalizeC1Value(row),
  };
},
getRowInitialC1Map() {
  const map = new Map();
  (this.initialCustom1Data || []).forEach(it => {
    const id = Number(it.idMaterialETL || 0);
    map.set(id, Number(it.numeroClusterCustom1 || 0));
  });
  return map;
},
getModifiedRowsCustom1() {
  const init = this.getRowInitialC1Map();
  const cambios = [];
  (this.custom1Data || []).forEach(r => {
    const id = Number(this.getMaterialId(r) || 0); // usa tu helper getMaterialId
    if (!id) return;
    const prev = init.has(id) ? init.get(id) : 0;
    const cur  = this.normalizeC1Value(r);
    if (Number(prev) !== Number(cur)) {
      cambios.push({ idMaterialETL: id, valor: cur }); // lo que espera tu API
    }
  });
  return cambios;
},
    formatPrecio(precio) {
      if (precio === null || precio === undefined || precio === '') return '';
      const numero = Number(precio);
      if (Number.isNaN(numero)) return '';
      const locale = this.lang === 'en' ? 'en-US' : 'es-CL';
      return numero.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },
    // Valor libro: en la tabla ETL es la columna Precio. Mismo tratamiento que
    // el valor sugerido, porque tambien llega como texto en registros antiguos.
    formatValorLibroDetalle(item) {
      if (!item) return '-';
      var raw = item.valorLibro != null ? item.valorLibro : item.ValorLibro;
      if (raw == null || String(raw).trim() === '') return '-';
      // parseNumero y no un replace ciego de puntos: cuando la API manda el
      // numero 136.29, quitar todos los puntos lo convertia en 13629 (x100).
      // parseNumero solo trata el punto como separador de miles si el string
      // tiene realmente ese formato (12.345,67), asi que sirve para los dos
      // casos: numero JSON y texto de registros antiguos.
      return this.formatPrecio(this.parseNumero(raw));
    },

    // Valor libro total: Precio * Cantidad, ya calculado por el backend. Mismo
    // tratamiento que formatValorLibroDetalle.
    formatValorLibroTotalDetalle(item) {
      if (!item) return '-';
      var raw = item.valorLibroTotal != null ? item.valorLibroTotal : item.ValorLibroTotal;
      if (raw == null || String(raw).trim() === '') return '-';
      return this.formatPrecio(this.parseNumero(raw));
    },

    formatValorTotalDetalle(item) {
  if (!item) return '-';

  // Toma el valor que viene del backend (puede ser numérico o texto)
  var raw = item.valorTotal != null ? item.valorTotal : item.ValorTotal;
  if (raw == null || String(raw).trim() === '') return '-';

  // Mismo criterio que formatValorLibroDetalle: parseNumero distingue el punto
  // decimal del separador de miles, un replace directo no.
  return this.formatPrecio(this.parseNumero(raw));
},
    async finalizarCustom(nro) {
  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  if (!tok) {
    this.$notify && this.$notify({ type: 'warning', message: 'Selecciona un archivo válido' });
    return false;
  }
  const apiBase = process.env.VUE_APP_API_URL || '';

  try {
    const resp = await fetch(`${apiBase}/api/cluster/update-estado-custom/${encodeURIComponent(nro)}`, {
      method: 'PUT',
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ token: tok, nuevoEstado: 'F' })
    });

    let payload = null;
    try { payload = await resp.clone().json(); } catch (_) { /* puede ser texto */ }
    if (!resp.ok) {
      const txt = payload && (payload.error || payload.message)
        ? (payload.error || payload.message)
        : (await resp.text().catch(() => `HTTP ${resp.status}`));
      throw new Error(String(txt || `HTTP ${resp.status}`));
    }

    // ✅ Forzar estado local del custom a F
const keyUp = nro === 1 ? 'EstadoCustom1' : nro === 2 ? 'EstadoCustom2' : 'EstadoCustom3';
const keyLo = nro === 1 ? 'estadoCustom1' : nro === 2 ? 'estadoCustom2' : 'estadoCustom3';
this.archivoSeleccionado = { ...this.archivoSeleccionado, [keyUp]: 'F', [keyLo]: 'F' };

// ✅ Salir de edición y mostrar el RESUMEN del custom finalizado
this.isEditing = false;
this.mostrarCustom1 = this.mostrarCustom2 = this.mostrarCustom3 = false;
this.mostrarDetalleCluster = false;
this.mostrarCluster = true;

// idCriterio del resumen según custom
const idCriterio = nro === 1 ? 8 : nro === 2 ? 9 : 10;

// 🔥 AQUÍ VA LA LÍNEA QUE TE PEDÍ:
this.tipoClusterSeleccionado = {
  id: nro === 1 ? 8 : nro === 2 ? 9 : 10,
  texto: `Custom ${nro}`
};
   
    this.tipoClusterSeleccionado = { id: idCriterio, texto: `Custom ${nro}` };

    // limpia y vuelve a cargar el resumen (si no hay datos, igual se muestra el contenedor)
    this.clusterResumen = [];
    this.seHizoConsultaResumen = false;
    this.sinDatos = false;

    let ok = false;
    try {
      ok = await this.tryFetchResumen(idCriterio);
    } catch (_) { ok = false; }

    this.seHizoConsultaResumen = true;
    this.sinDatos = !ok;

    this.$notify && this.$notify({ type: 'success', message: `Custom ${nro} finalizado correctamente.` });
    return true;
  } catch (e) {
    const msg = e && e.message ? e.message : 'No se pudo finalizar';
    // Muestra el error real que vino del backend (ej. “Cannot insert the value NULL into column 'Valor' …”)
    this.$notify && this.$notify({ type: 'danger', message: `No se pudo finalizar Custom ${nro}: ${msg}` });
    console.warn('finalizarCustom error:', e);
    return false;
  }
},
    isMarcadoBD(it) {
  // acepta varias variantes: Seleccion/selected/etc. y distintos tipos
  const v = (
    it &&
    (it.seleccion !== undefined ? it.seleccion :
    it.Seleccion !== undefined ? it.Seleccion :
    it.selected !== undefined ? it.selected :
    it.isSelected !== undefined ? it.isSelected : 0)
  );

  if (typeof v === 'boolean') return v;
  const s = String(v).trim().toLowerCase();
  return s === '1' || s === 'true' || s === 's' || s === 'y' || s === 'yes';
},
    ordenarPor(campo) {
    if (this.ordenCampo === campo) {
      this.ordenAsc = !this.ordenAsc;
    } else {
      this.ordenCampo = campo;
      this.ordenAsc = true;
    }
  },
  formatearMiles(valor) {
    if (valor == null || valor === '') return '-';
    return valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  },
getNumeroClusterFrom(item) {
  if (!item) return null;
  // intenta todas las variantes que suelen venir
  const candidates = [
    item.numeroCluster, item.NumeroCluster,
    item.cluster, item.Cluster
  ];
  for (const v of candidates) {
    const n = Number(v);
    if (!isNaN(n) && n > 0) return n;
  }
  // a veces viene en "nombreCluster" con texto "3" o "CLASE 3"
  const txt = String(item.nombreCluster || item.NombreCluster || '').match(/\d+/);
  return txt ? Number(txt[0]) : null;
},

onResumenRowClick(item) {
  const num = this.getNumeroClusterFrom(item);
  this.rankingContext = {
    idCriterio: this.tipoClusterSeleccionado ? this.tipoClusterSeleccionado.id : null,
    numeroCluster: num
  };
  this.clusterDetalleNombre = this.nombreClusterParaMostrar(item.nombreCustom || item.NombreCustom || item.nombreCluster || item.NombreCluster || item.NombreClase || item.nombreClase || item.cluster || String(num || ''));
  this.obtenerClusterDetalle(item);
},
    normalizeRankingResponse(data) {
  if (!data) return [];

  // 1) Array directo
  if (Array.isArray(data)) return data;

  // 2) Envolturas comunes
  if (Array.isArray(data.items))   return data.items;
  if (Array.isArray(data.result))  return data.result;
  if (Array.isArray(data.data))    return data.data;   // a veces backend usa "data: []"
  if (Array.isArray(data.Results)) return data.Results;

  // 3) Si viene un objeto con numeradas o propiedades tipo 'records'
  if (Array.isArray(data.records)) return data.records;
  if (Array.isArray(data.Records)) return data.Records;

  // 4) Si trae un objeto con "value" que es array
  if (Array.isArray(data.value)) return data.value;

  // 5) Nada de lo anterior → intenta detectar un array en alguna propiedad
  for (const k of Object.keys(data)) {
    const v = data[k];
    if (Array.isArray(v)) return v;
  }

  // 6) Si aún no, no hay filas renderizables
  return [];
},
    // ===== C2: normaliza y coloca numeroClusterCustom2 =====
normalizeC2Value(row) {
  // lee TODAS las variantes que podría enviar el backend
  if (!row) return 0;
  const picks = [
    'numeroClusterCustom2', 'NumeroClusterCustom2',
    'clusterCustom2',       'ClusterCustom2',
    'c2',                   'C2',
    'criterioCustom2',      'CriterioCustom2',
    'numeroCluster',        'NumeroCluster',     // por si tu endpoint de C2 trae un "numeroCluster" genérico
  ];
  for (let k of picks) {
    const v = row[k];
    if (v !== undefined && v !== null && String(v).trim() !== '') return Number(v);
  }
  return 0;
},
mapRowC2(row) {
  if (!row || typeof row !== 'object') return row;
  // preserva el resto + fuerza detalles + numeroClusterCustom2 coherente
  const base = this.mapRowCommon(row);
  return {
    ...base,
    numeroClusterCustom2: this.normalizeC2Value(row),
  };
},

// ===== C3: normaliza y coloca numeroClusterCustom3 =====
normalizeC3Value(row) {
  if (!row) return 0;

  const picks = [
    'numeroClusterCustom3','NumeroClusterCustom3',
    'clusterCustom3','ClusterCustom3',
    'c3','C3',
    'criterioCustom3','CriterioCustom3',

    // variaciones comunes del backend
    'numero_cluster_3','Numero_Cluster_3',
    'cluster3','Cluster3',
    'c_3','C_3',
    'valorCluster3','ValorCluster3',
    'valor_cluster_3','Valor_Cluster_3',

    // genérico
    'numeroCluster','NumeroCluster',
    'cluster','Cluster'
  ];

  for (let k of picks) {
    if (row[k] !== undefined && row[k] !== null && String(row[k]).trim() !== '') {
      return Number(row[k]);
    }
  }

  return 0;
},
mapRowC3(row) {
  if (!row || typeof row !== 'object') return row;
  const base = this.mapRowCommon(row);
  return {
    ...base,
    numeroClusterCustom3: this.normalizeC3Value(row),
  };
},
    textoCorto(value, max) {
  var txt = (value != null) ? String(value) : '';
  var n = Math.max(1, Number(max || 80));
  return (txt.length > n) ? (txt.slice(0, n) + '...') : txt;
},
    // Texto que se muestra en la celda (truncado)
descripcionCorta(row, max) {
  var txt = (row && row.detalles != null) ? String(row.detalles) : '';
  var n = Math.max(30, Number(max || 80));
  return (txt.length > n) ? (txt.slice(0, n) + '...') : txt;
},

// Abre el modal de detalle con el texto completo
abrirDetalle(modalId, row) {
  this.detalleSeleccionado = (row && row.detalles != null) ? String(row.detalles) : '';
  if (this.$bvModal && modalId) this.$bvModal.show(modalId);
},
    // ===== Normaliza una fila para que SIEMPRE tenga .detalles =====
mapRowCommon(row) {
  if (!row || typeof row !== 'object') return row;
  var d = '';
  if (row.detalles != null) d = row.detalles;
  else if (row.detalle != null) d = row.detalle;
  else if (row.descripcion != null) d = row.descripcion;
  else if (row.Descripcion != null) d = row.Descripcion;
  else if (row.description != null) d = row.description;
  else if (row.Description != null) d = row.Description;
  return { ...row, detalles: d };
},
getMaterialId(row) {
  if (!row) return null;
  const keys = [
    'idMaterialETL','IdMaterialETL',
    'idMaterial','IdMaterial',
    'id','Id'
  ];
  for (const k of keys) {
    const v = row[k];
    if (v !== undefined && v !== null && String(v).trim() !== '') return Number(v);
  }
  return null;
},

    // Normalizador defensivo de respuestas de lista
normalizeListaCluster(resp) {
  // Devuelve { items:[], total: X, totalPages: Y }
  let data = resp;
  if (resp && resp.data) data = resp.data;

  let items = [];
  let total = 0;
  let totalPages = 1;

  if (Array.isArray(data)) {
  items = data;
} else if (data && Array.isArray(data.items)) {
  items = data.items;
  total = Number(
    data.total || data.Total ||
    data.count || data.Count ||
    data.totalCount || data.TotalCount ||
    data.totalRecords || data.TotalRecords ||
    data.totalRows || data.TotalRows ||
    data.records || data.Records || 0
  );
  totalPages = Number(
    data.totalPages || data.TotalPages ||
    data.pages || data.Pages ||
    data.pageCount || data.PageCount ||
    data.totalPageCount || data.TotalPageCount || 0
  );
} else if (data && Array.isArray(data.result)) {
  items = data.result;
  total = Number(
    data.total || data.Total ||
    data.count || data.Count ||
    data.totalCount || data.TotalCount ||
    data.totalRecords || data.TotalRecords ||
    data.totalRows || data.TotalRows ||
    data.records || data.Records || 0
  );
  totalPages = Number(
    data.totalPages || data.TotalPages ||
    data.pages || data.Pages ||
    data.pageCount || data.PageCount ||
    data.totalPageCount || data.TotalPageCount || 0
  );
}

  // Si no vino totalPages, calcúlalo con pageSize si venía total
  return { items, total, totalPages };
},

// ============== FETCH CUSTOM 2 ==============
getRowInitialC2Map() {
  const map = new Map();
  (this.initialCustom2Data || []).forEach(it => {
    const id = Number(it.idMaterialETL || 0);
    map.set(id, Number(it.numeroClusterCustom2 || 0));
  });
  return map;
},
getModifiedRowsCustom2() {
  const init = this.getRowInitialC2Map();
  const cambios = [];
  (this.custom2Data || []).forEach(r => {
    const id = Number(this.getMaterialId(r) || 0); // ⇐ id normalizado SIEMPRE
    if (!id) return;
    const prev = init.has(id) ? init.get(id) : 0;
    const cur  = this.normalizeC2Value(r);
    if (Number(prev) !== Number(cur)) {
      cambios.push({ idMaterialETL: id, valor: cur });
    }
  });
  return cambios;
},
async fetchCustom2(page) {
  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  if (!tok) return;

  this.cargandoCustom2 = true;
  let resp = null;

  try {
    try { resp = await materialService.getCustom2(tok, 1, 999999); } catch (_) {}
    if (!resp) try { resp = await materialService.getCustom(tok, 2, 1, 999999); } catch (_) {}
    if (!resp) try { resp = await materialService.getResultETL(tok, 1, 999999); } catch (_) {}

    const norm = this.normalizeListaCluster(resp);

    // Map igual que C1
    this.custom2Data = Array.isArray(norm.items)
      ? norm.items.map(this.mapRowC2)
      : [];

    // Snapshot igual que C1
    this.initialCustom2Data = this.custom2Data.map(r => ({
      idMaterialETL: this.getMaterialId(r),
      numeroClusterCustom2: this.normalizeC2Value(r),
    }));

    this.currentPageC2 = 1;

  } catch (e) {
    console.error('fetchCustom2 error:', e);
    this.custom2Data = [];
    this.currentPageC2 = 1;
    this.$notify && this.$notify({ type: 'danger', message: 'Error al cargar Custom 2' });
  } finally {
    this.cargandoCustom2 = false;
  }
},

// ============== SNAPSHOT / DIFF CUSTOM 3 ==============
getRowInitialC3Map() {
  const map = new Map();
  (this.initialCustom3Data || []).forEach(it => {
    const id = Number(it.idMaterialETL || 0);
    map.set(id, Number(it.numeroClusterCustom3 || 0));
  });
  return map;
},
getModifiedRowsCustom3() {
  const init = this.getRowInitialC3Map();
  const cambios = [];
  (this.custom3Data || []).forEach(r => {
    const id = Number(this.getMaterialId(r) || 0);
    if (!id) return;
    const prev = init.has(id) ? init.get(id) : 0;
    const cur  = this.normalizeC3Value(r);
    if (Number(prev) !== Number(cur)) {
      cambios.push({ idMaterialETL: id, valor: cur });
    }
  });
  return cambios;
},

// ============== FETCH CUSTOM 3 ==============
async fetchCustom3(page) {
  try {
    const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
    if (!tok) return;
    this.cargandoCustom3 = true;

    let resp = null;

try {
  resp = await materialService.getCustom3(tok, 1, 999999);
} catch (_) {}

if (!resp) {
  try {
    resp = await materialService.getCustom(tok, 3, 1, 999999);
  } catch (_) {}
}

if (!resp) {
  try {
    resp = await materialService.getResultETL(tok, 1, 999999);
  } catch (_) {}
}

const norm = this.normalizeListaCluster(resp);

// mapeo + snapshot (igual que C2)
this.custom3Data = Array.isArray(norm.items) ? norm.items.map(this.mapRowC3) : [];

this.initialCustom3Data = this.custom3Data.map(r => ({
  idMaterialETL: this.getMaterialId(r),
  numeroClusterCustom3: this.normalizeC3Value(r)
}));

this.currentPageC3 = 1;
  } catch (e) {
    console.error('fetchCustom3 error:', e);
    this.custom3Data = [];
    this.currentPageC3 = 1;
    this.$notify && this.$notify({ type: 'danger', message: 'Error al cargar Custom 3' });
  } finally {
    this.cargandoCustom3 = false;
  }
},
    onClickCustom1() {
  // 8 = criterio Custom 1
  this.cargarResumenSiF(8); 
},
onClickCustom2() {
  // 9 = criterio Custom 2
  this.cargarResumenSiF(9);
},
onClickCustom3() {
  // 10 = criterio Custom 3
  this.cargarResumenSiF(10);
},
    addCriterioC1() {
      if (!this.puedeEscribir) return;
  this.c1Max = Math.max(3, this.c1Max + 1);
},
addCriterioC2() {
  if (!this.puedeEscribir) return;
  this.c2Max = Math.max(3, this.c2Max + 1);
},
addCriterioC3() {
  if (!this.puedeEscribir) return;
  this.c3Max = Math.max(3, this.c3Max + 1);
},

async eliminarUltimoCriterioC1() {
  if (!this.puedeEscribir) return;
  if (this.c1Max <= 3) return;
  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  if (!tok) return;

  const ultimo = this.c1Max;
  const { isConfirmed } = await Swal.fire({
    title: `¿Eliminar C${ultimo}?`,
    text: `Se desmarcará C${ultimo} en todos los materiales. Esta acción no se puede deshacer.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#d33',
  });
  if (!isConfirmed) return;
  const filasMarcadas = (this.custom1Data || []).filter(r => Number(this.normalizeC1Value(r)) === ultimo);

  for (const row of filasMarcadas) {
    const id = Number(this.getMaterialId(row) || 0);
    if (!id) continue;
    try {
      await this.putUpdateMaterialCluster(tok, id, 1, 0);
      this.$set(row, 'numeroClusterCustom1', 0);
      this.$set(row, 'criterioCustom1', null);
    } catch (e) {
      console.error('[eliminarUltimoCriterioC1] error:', e);
      this.$notify && this.$notify({ type: 'danger', message: 'Error al desmarcar filas.' });
      return;
    }
  }

  this.c1Max = ultimo - 1;
},

async eliminarUltimoCriterioC2() {
  if (!this.puedeEscribir) return;
  if (this.c2Max <= 3) return;
  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  if (!tok) return;

  const ultimo = this.c2Max;
  const { isConfirmed } = await Swal.fire({
    title: `¿Eliminar C${ultimo}?`,
    text: `Se desmarcará C${ultimo} en todos los materiales. Esta acción no se puede deshacer.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#d33',
  });
  if (!isConfirmed) return;
  const filasMarcadas = (this.custom2Data || []).filter(r => Number(this.normalizeC2Value(r)) === ultimo);

  for (const row of filasMarcadas) {
    const id = Number(this.getMaterialId(row) || 0);
    if (!id) continue;
    try {
      await this.putUpdateMaterialCluster(tok, id, 2, 0);
      this.$set(row, 'numeroClusterCustom2', 0);
      this.$set(row, 'criterioCustom2', null);
    } catch (e) {
      console.error('[eliminarUltimoCriterioC2] error:', e);
      this.$notify && this.$notify({ type: 'danger', message: 'Error al desmarcar filas.' });
      return;
    }
  }

  this.c2Max = ultimo - 1;
},

async eliminarUltimoCriterioC3() {
  if (!this.puedeEscribir) return;
  if (this.c3Max <= 3) return;
  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  if (!tok) return;

  const ultimo = this.c3Max;
  const { isConfirmed } = await Swal.fire({
    title: `¿Eliminar C${ultimo}?`,
    text: `Se desmarcará C${ultimo} en todos los materiales. Esta acción no se puede deshacer.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#d33',
  });
  if (!isConfirmed) return;
  const filasMarcadas = (this.custom3Data || []).filter(r => Number(this.normalizeC3Value(r)) === ultimo);

  for (const row of filasMarcadas) {
    const id = Number(this.getMaterialId(row) || 0);
    if (!id) continue;
    try {
      await this.putUpdateMaterialCluster(tok, id, 3, 0);
      this.$set(row, 'numeroClusterCustom3', 0);
      this.$set(row, 'criterioCustom3', null);
    } catch (e) {
      console.error('[eliminarUltimoCriterioC3] error:', e);
      this.$notify && this.$notify({ type: 'danger', message: 'Error al desmarcar filas.' });
      return;
    }
  }

  this.c3Max = ultimo - 1;
},
    async putUpdateMaterialCluster(token, idMaterialETL, nroCriterioCustom, numeroCluster) {
  const apiBase = process.env.VUE_APP_API_URL || '';

  // El backend requiere números en ambos segmentos.
  // Para "borrar" el valor, enviaremos 0 (backend debe tratar 0 como NULL).
  const nro   = String(nroCriterioCustom);              // "1" | "2" | "3"
  const valor = (numeroCluster === null || numeroCluster === undefined || numeroCluster === '' )
                ? '0'                                   // ⇐ BORRADO
                : String(numeroCluster);                // "1" | "2" | "3"

                const url = `${apiBase}/api/cluster/updateMaterialCluster/${encodeURIComponent(token)}/${encodeURIComponent(idMaterialETL)}/${encodeURIComponent(nro)}/${encodeURIComponent(valor)}`;

  const resp = await fetch(url, {
    method: 'PUT',
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
      'Accept': 'application/json'
    }
  });

  if (!resp.ok) {
    let txt = '';
    try { txt = await resp.text(); } catch (_) {}
    throw new Error(`Fallo al actualizar (${idMaterialETL}) [${resp.status}] ${txt}`);
  }
  return true;
},
    // Actualización masiva: un solo request que afecta TODOS los registros del Token
    // (usado por "marcar/desmarcar todos" del head, en vez de un PUT por fila).
    async putUpdateMaterialClusterBulk(token, nroCriterioCustom, numeroCluster) {
  const apiBase = process.env.VUE_APP_API_URL || '';

  const nro   = String(nroCriterioCustom);
  const valor = (numeroCluster === null || numeroCluster === undefined || numeroCluster === '')
                ? '0'
                : String(numeroCluster);

  const url = `${apiBase}/api/cluster/updateMaterialClusterBulk/${encodeURIComponent(token)}/${encodeURIComponent(nro)}/${encodeURIComponent(valor)}`;

  const resp = await fetch(url, {
    method: 'PUT',
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
      'Accept': 'application/json'
    }
  });

  if (!resp.ok) {
    let txt = '';
    try { txt = await resp.text(); } catch (_) {}
    throw new Error(`Fallo al actualizar en forma masiva [${resp.status}] ${txt}`);
  }
  return true;
},
    // Igual que putUpdateMaterialClusterBulk, pero acotado a los ids que llegan: lo usa
    // "marcar/desmarcar todos" del encabezado cuando hay un filtro de columna activo, para no
    // tocar materiales que el usuario no esta viendo en pantalla.
    async putUpdateMaterialClusterBulkByIds(token, nroCriterioCustom, numeroCluster, ids) {
  const apiBase = process.env.VUE_APP_API_URL || '';

  const nro   = String(nroCriterioCustom);
  const valor = (numeroCluster === null || numeroCluster === undefined || numeroCluster === '')
                ? '0'
                : String(numeroCluster);

  const url = `${apiBase}/api/cluster/updateMaterialClusterBulkByIds/${encodeURIComponent(token)}/${encodeURIComponent(nro)}/${encodeURIComponent(valor)}`;

  const resp = await fetch(url, {
    method: 'PUT',
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ Ids: ids })
  });

  if (!resp.ok) {
    let txt = '';
    try { txt = await resp.text(); } catch (_) {}
    throw new Error(`Fallo al actualizar en forma masiva [${resp.status}] ${txt}`);
  }
  return true;
},
    formatClusterName(s) {
    // Limpia guiones/underscores y deja nombre más legible
    return String(s)
      .replace(/[_\-]+/g, ' ')
      .replace(/\s*C0\s*$/i, '')    // opcional: quita sufijo _C0
      .trim()
      .toUpperCase();               // opcional: mismo estilo que la tabla
  },
    setPageDetalle(n) {
    const max = this.totalPagesDetalle;
    const next = Math.min(Math.max(1, n), max);
    this.currentPageDetalle = next;
  },

  resetPaginadorDetalle() {
    this.currentPageDetalle = 1;
  },
    getEstadoFlujoLocal() {
  if (!this.archivoSeleccionado) return null;

  var v = this.archivoSeleccionado.estadoFlujo;
  if (v === undefined || v === null || String(v).trim() === '') {
    v = this.archivoSeleccionado.EstadoFlujo;
  }
  if (v === undefined || v === null || String(v).trim() === '') {
    var tok = String(this.archivoSeleccionado.token || '').trim();
    var fila = (this.archivosLogs || []).find(function(a){
      return String(a.token || '').trim() === tok;
    });
    if (fila) {
      v = (fila.estadoFlujo !== undefined && fila.estadoFlujo !== null) ? fila.estadoFlujo : fila.EstadoFlujo;
    }
  }
  return this.normalizeEstado(v);
},
startPollingEstado() {
  this.stopPollingEstado();
  var tok = this.archivoSeleccionado && this.archivoSeleccionado.token;
  if (!tok) return;

  // ➜ Solo se hace polling cuando ya está en C (clusterizando)
  var estado = this.getEstadoFlujoLocal();
  if (estado !== 'C') return;

  this.pollErrorCount = 0;            // reinicia contador de errores
  this.tickPollEstado();              // tick inmediato
  this.pollTimerId = setInterval(() => this.tickPollEstado(), this.pollIntervalMs);
},

stopPollingEstado() {
  if (this.pollTimerId) {
    clearInterval(this.pollTimerId);
    this.pollTimerId = null;
  }
},


    /**
     * Da de baja todo lo asociado al archivo: fichas, clusters del resumen y ranking.
     * Solo se ofrece al volver a Administración de Inventario, porque ese camino rehace
     * rentabilización y clusterización desde cero y esos clusters dejan de corresponder.
     */
    async eliminarFichasYClustersDelArchivo(token) {
      const confirm = await Swal.fire({
        icon: 'warning',
        title: this.$t('confirmar_eliminar_fichas'),
        text: this.$t('accion_irreversible'),
        showCancelButton: true,
        confirmButtonText: this.$t('eliminar_igualmente'),
        confirmButtonColor: '#d33',
        cancelButtonText: this.$t('cancelar'),
        reverseButtons: true
      });
      if (!confirm.isConfirmed) return false;

      try {
        const apiBase = process.env.VUE_APP_API_URL || '';
        const resp = await fetch(
          `${apiBase}/api/cluster/desactivarFichasPublicadasPorToken/${encodeURIComponent(token)}`,
          {
            method: 'PUT',
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
              'Accept': 'application/json'
            }
          }
        );
        if (!resp.ok) throw new Error(await resp.text());
        return true;
      } catch (e) {
        console.error('Error al desactivar fichas y clusters:', e);
        Swal.fire({
          icon: 'error',
          title: this.$t('error') || 'Error',
          text: this.$t('no_se_pudo_eliminar') || 'No se pudo eliminar.'
        });
        return false;
      }
    },

async confirmarVolverAdmInventario() {
  if (!this.puedeEscribir) return;
  const token = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  if (!token) return;

  // Verificar si hay fichas publicadas antes de permitir volver
  try {
    const apiBase = process.env.VUE_APP_API_URL || '';
    const resp = await fetch(
      `${apiBase}/api/cluster/getFichasPublicadasPorToken/${encodeURIComponent(token)}`,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
          'Accept': 'application/json'
        }
      }
    );

    if (resp.ok) {
      const data = await resp.json();
      if (Array.isArray(data) && data.length > 0) {
        // Solo el nombre del archivo (sin duplicar): pueden ser cientos de fichas
        const nombresArchivos = [...new Set(data.map(f => f.nombreXLSX || '—'))];
        const items = nombresArchivos.map(n => `<li style="margin-bottom:4px"><b>${n}</b></li>`).join('');

        // SweetAlert2 v9 no tiene showDenyButton: el tercer botón va dentro del html.
        let eliminarIgualmenteClicked = false;
        const result = await Swal.fire({
          icon: 'error',
          title: this.$t('no_permitido'),
          html: `<p>${this.$t('archivo_fichas_publicadas')}</p>
                 <ul style="text-align:left;padding-left:1.2rem">${items}</ul>
                 <p style="margin-top:8px"><b>${this.$t('revise_modulo_ecommerce')}</b></p>
               <button id="btnEliminarIgualmente" type="button" class="btn btn-sm btn-danger mt-2">
                 ${this.$t('eliminar_igualmente')}
               </button>`,
          confirmButtonText: this.$t('entendido'),
          showCancelButton: true,
          cancelButtonText: this.$t('ir_a_ficha'),
          cancelButtonColor: '#17a2b8',
          onOpen: (popup) => {
            const btn = popup.querySelector('#btnEliminarIgualmente');
            if (btn) {
              btn.addEventListener('click', () => { eliminarIgualmenteClicked = true; Swal.close(); });
            }
          }
        });

        // Liberado el archivo, se reintenta la misma acción: la validación ya no bloquea.
        if (eliminarIgualmenteClicked) {
          const liberado = await this.eliminarFichasYClustersDelArchivo(token);
          if (liberado) return this.confirmarVolverAdmInventario();
          return;
        }

        if (result.dismiss === Swal.DismissReason.cancel) {
          sessionStorage.setItem('lecturaVentasEstado', JSON.stringify({
            empresaSeleccionada: this.empresaSeleccionada,
            tokenActual: token,
            archivoSeleccionado: this.archivoSeleccionado
          }));
          window.open('/lectura-ventas-inventario', '_blank');
        }
        return; // bloquear acción volver
      }
    }
  } catch (e) {
    console.error('Error al verificar fichas publicadas:', e);
  }

  // Sin fichas publicadas: continuar con la confirmación original
  const res = await Swal.fire({
    title: this.$t('confirmar_volver_adm_inventario') || '¿Volver a la Administración de Materiales?',
    text: this.$t('texto_volver_adm_inventario') || 'Volverá a la Administración de Materiales. Deberá ejecutar el proceso de RENTABILIDAD nuevamente.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: this.$t('volver_adm_inventario') || 'Volver Adm. Inventario',
    cancelButtonText: this.$t('cancelar') || 'Cancelar',
    reverseButtons: true
  });

  if (!res.isConfirmed) return;
  await this.editarArchivoInventario();
},

async editarArchivoInventario() {
  const archivo = this.archivoSeleccionado;
  if (!archivo || !archivo.token) {
    this.$notify && this.$notify({ type: 'warning', message: this.$t('archivo_invalido') });
    return;
  }

  const token = String(archivo.token).trim();
  this.$notify && this.$notify({ type: 'info', message: this.$t('reabriendo_archivo_edicion') });

  try {
    const resp = await materialService.updateEstadoFlujo(token, 'P');

    if (!(resp && (resp.success === true || resp.Success === true))) {
      this.$notify && this.$notify({ type: 'warning', message: this.$t('no_se_pudo_cambiar_estado_p') });
      return;
    }

    const idx = (this.archivosLogs || []).findIndex(a => a.token === token);
    if (idx !== -1) {
      this.$set(this.archivosLogs, idx, { ...this.archivosLogs[idx], estadoFlujo: 'P', EstadoFlujo: 'P' });
    }

    this.stopPollingEstado();

    try {
      this.$router.push({ path: `/materialesResultFile/${token}` });
    } catch (_) {
      window.location.href = `/materialesResultFile/${token}`;
    }
  } catch (error) {
    console.error(error);
    this.$notify && this.$notify({ type: 'error', message: this.$t('error_preparar_edicion') });
  }
},

async tickPollEstado() {
  try {
    var tok = this.archivoSeleccionado && this.archivoSeleccionado.token;
    if (!tok) return;

    var estadoLocal = this.getEstadoFlujoLocal();
  if (estadoLocal !== 'C') return;  // nada que poller si no está clusterizando

    var resp = await materialService.getEstadoFlujoArchivo(tok);

    // Normaliza respuesta (sin ?. ni ??)
    var data = (resp && resp.data) ? resp.data : resp;

    // Considera OK si trae success=true o al menos trae Estado
    var tieneEstado = !!(data && (typeof data.estadoFlujo !== 'undefined' || typeof data.EstadoFlujo !== 'undefined'));
    var ok = !!(data && ((data.success === true || data.Success === true) || tieneEstado));

    var nuevo = '';
    if (data) {
      if (typeof data.estadoFlujo !== 'undefined' && data.estadoFlujo !== null) {
        nuevo = data.estadoFlujo;
      } else if (typeof data.EstadoFlujo !== 'undefined' && data.EstadoFlujo !== null) {
        nuevo = data.EstadoFlujo;
      }
    }
    nuevo = this.normalizeEstado(nuevo);

    console.log('🩺 Poll Cluster EstadoFlujo', { tok, ok, nuevo, raw: resp });
    if (!ok) return;

    var prev = this.archivoSeleccionado && this.archivoSeleccionado.estadoFlujo
      ? this.normalizeEstado(this.archivoSeleccionado.estadoFlujo)
      : (this.archivoSeleccionado && this.archivoSeleccionado.EstadoFlujo
          ? this.normalizeEstado(this.archivoSeleccionado.EstadoFlujo) : '');

    // Actualiza seleccionado
    this.archivoSeleccionado = {
      ...this.archivoSeleccionado,
      estadoFlujo: nuevo,
      EstadoFlujo: nuevo
    };

    // Actualiza fila en la lista
    var idx = (this.archivosLogs || []).findIndex(a => a.token === tok);
    if (idx !== -1) {
      this.archivosLogs.splice(idx, 1, {
        ...this.archivosLogs[idx],
        estadoFlujo: nuevo,
        EstadoFlujo: nuevo
      });
    }

    // Cambio a T => clusterización terminada
    if (prev !== nuevo && nuevo === 'T') {
      // Puedes cargar/resumir automáticamente si quieres:
      // - si hay un criterio seleccionado, refresca su resumen
      try {
        if (this.tipoClusterSeleccionado && this.tipoClusterSeleccionado.id) {
          await this.tryFetchResumen(this.tipoClusterSeleccionado.id);
        }
      } catch (e) { console.warn('No se pudo refrescar resumen tras T:', e); }

      this.$notify && this.$notify({ type: 'success', message: 'Clusterización terminada (T).' });
    }
  } catch (e) {
  // 500 u otros errores: registra y limita reintentos
  this.pollErrorCount = (this.pollErrorCount || 0) + 1;
  if (this.pollErrorCount >= (this.pollErrorMax || 3)) {
    this.stopPollingEstado();
    if (this.$notify) {
      this.$notify({
        type: 'warning',
        message: 'No se pudo consultar el estado del archivo. Intenta nuevamente más tarde.'
      });
    }
  }
  // Log compacto para depurar, sin inundar consola
  console.warn(
    'Polling EstadoFlujo (Cluster) error (intento ' + this.pollErrorCount + '):',
    e && e.message ? e.message : e
  );
}
},
    // ✅ clave única por fila (usa id; si no, el índice)
rankingRowKey(item, index) {
  if (item && item.id != null) return `id:${item.id}`;
  return `row:${index}`;
},

isRankingRowSelected(item, index) {
  const key = this.rankingRowKey(item, index);
  return this.rankingSelectedKeys.has(key);
},

onToggleRankingRow(item, index, checked) {
  if (!this.puedeEscribir) return;
  const key = this.rankingRowKey(item, index);
  if (checked) {
    this.rankingSelectedKeys.add(key);
  } else {
    this.rankingSelectedKeys.delete(key);
  }
  // refresca contador y referencia para reactividad
  this.rankingSelectedCount = this.rankingSelectedKeys.size;
  this.rankingSelectedKeys = new Set(this.rankingSelectedKeys);
},

async guardarRankingSeleccion() {
  if (!this.puedeEscribir) return;
  if (!this.archivoSeleccionado || !this.archivoSeleccionado.token) return;

  const seleccion = [];
  this.rankingItems.forEach((it, idx) => {
    const key = this.rankingRowKey(it, idx);
    if (this.rankingSelectedKeys.has(key)) {
      let valor = null;
      if (it.total != null) valor = it.total;
      else if (it.monto != null) valor = it.monto;
      else if (it.valor != null) valor = it.valor;

      seleccion.push({
        id: (it.id != null ? it.id : null),
        numeroCluster: (it.numeroCluster != null ? it.numeroCluster : null),
        valor: valor
      });
    }
  });

  if (!seleccion.length) {
    if (this.$notify) this.$notify({ type: 'warning', message: 'Selecciona al menos un registro.' });
    return;
  }

  this.guardandoRanking = true;
  try {
    const token = String(this.archivoSeleccionado.token).trim();
    const apiBase = process.env.VUE_APP_API_URL || '';

    // 1) Resetear ranking en BD
    const urlReset = apiBase + '/api/cluster/updateRankingReset/' + encodeURIComponent(token);
    const respReset = await fetch(urlReset, {
      method: 'PUT',
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
        'Accept': 'application/json'
      }
    });
    if (!respReset.ok) {
  let txt = ''; try { txt = await respReset.text(); } catch (_) {}
  throw new Error('Fallo al actualizar [' + respReset.status + '] ' + txt);
}

    // 2) Guardar selección marcada
    for (let i = 0; i < seleccion.length; i++) {
      const sel = seleccion[i];
      const idParaActualizar = (sel.id != null ? sel.id : sel.numeroCluster);
      if (idParaActualizar == null) continue;

      const url = apiBase + '/api/cluster/updateRanking/' +
        encodeURIComponent(token) + '/' + encodeURIComponent(idParaActualizar);

      const resp = await fetch(url, {
        method: 'PUT',
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
          'Accept': 'application/json'
        }
      });

      if (!resp.ok) {
        let txt = ''; try { txt = await resp.text(); } catch (_) {}
        throw new Error('Fallo al actualizar (id=' + idParaActualizar + ') [' + resp.status + '] ' + txt);
      }
    }

   // 3) Cambiar EstadoFlujo a "G" en la BD
await materialService.updateEstadoFlujo(token, 'G');

// 4) Refrescar SOLO el estado local para que se habilite el botón
const nuevoEstado = 'G';

// - seleccionado
if (this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim() === token) {
  this.archivoSeleccionado = {
    ...this.archivoSeleccionado,
    estadoFlujo: nuevoEstado,
    EstadoFlujo: nuevoEstado
  };
}

// - fila en la lista (por si getEstadoFlujoLocal lee desde aquí)
const idx = (this.archivosLogs || []).findIndex(a => String(a.token || '').trim() === token);
if (idx !== -1) {
  this.archivosLogs.splice(idx, 1, {
    ...this.archivosLogs[idx],
    estadoFlujo: nuevoEstado,
    EstadoFlujo: nuevoEstado
  });
}

// 5) Notificar y cerrar modal (sin refrescar nada más)
if (this.$notify) this.$notify({ type: 'success', message: 'Ranking guardado correctamente.' });
this.$bvModal.hide('modal-ranking');
  } catch (e) {
    console.error('Error al guardar selección de ranking:', e);
    if (this.$notify) this.$notify({ type: 'danger', message: 'No se pudo guardar el ranking.' });
  } finally {
    this.guardandoRanking = false;
  }
},

async abrirRanking() {
  try {
    this.cargandoRanking = true;
    this.rankingError = null;
    this.rankingItems = [];
    this.rankingFields = [];
    this.rankingSelectedKeys = new Set();
    this.rankingSelectedCount = 0;

    const token = this.archivoSeleccionado && this.archivoSeleccionado.token;
    if (!token) {
      this.rankingError = 'No hay archivo seleccionado.';
      this.$bvModal.show('modal-ranking');
      return;
    }

    const ctx = (this.rankingContext && typeof this.rankingContext === 'object') ? this.rankingContext : null;

    let idCriterio = (ctx && ctx.idCriterio != null)
      ? ctx.idCriterio
      : ((this.tipoClusterSeleccionado && this.tipoClusterSeleccionado.id) || null);

    let numeroCluster = (ctx && ctx.numeroCluster != null)
      ? ctx.numeroCluster
      : (this.clusterResumen[0] ? this.getNumeroClusterFrom(this.clusterResumen[0]) : null);

    if (!numeroCluster) {
      this.rankingError = 'Selecciona un cluster del resumen para ver su ranking.';
      this.$bvModal.show('modal-ranking');
      return;
    }

    const apiBase = process.env.VUE_APP_API_URL || '';
    const url = `${apiBase}/api/cluster/getRanking/${encodeURIComponent(token)}`;

    let data = null;
    let resp = null;
    try {
      resp = await fetch(url, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
          'Accept': 'application/json'
        }
      });

      if (!resp.ok) {
        const txt = await resp.text().catch(() => '');
        this.rankingError = `Error al obtener el ranking (${resp.status}) ${txt || ''}`.trim();
        this.$bvModal.show('modal-ranking');
        return;
      }

      data = await resp.json();
    } catch (e) {
      this.rankingError = 'Error de conexión al cargar el ranking.';
      this.$bvModal.show('modal-ranking');
      return;
    }

    // ===== Normalización =====
    const arr = this.normalizeRankingResponse(data);
    this.rankingItems = Array.isArray(arr) ? arr : [];
    console.log('[RANKING] normalizado (len):', Array.isArray(arr) ? arr.length : 'no-array');

    // ===== Columnas =====
    this.rankingFields = [];
    if (this.rankingItems.length > 0 && typeof this.rankingItems[0] === 'object') {
      const keys = Object.keys(this.rankingItems[0]);
      const preferidas = ['numeroCluster', 'nombreCluster', 'cluster', 'cantidad', 'total', 'monto', 'valor', 'porcentaje'];
      const ordenadas = [
        ...preferidas.filter(k => keys.includes(k)),
        ...keys.filter(k => !preferidas.includes(k))
      ];
      this.rankingFields = ordenadas.map(k => ({
        key: k,
        label: this.formatearHeader(k),
        sortable: true
      }));
    }

    // No preseleccionar nada al abrir el modal
this.rankingSelectedKeys = new Set();
this.rankingSelectedCount = 0;

    // Mostrar modal
    this.$bvModal.show('modal-ranking');
  } catch (e) {
    console.error('Ranking error (catch):', e);
    this.rankingError = 'Ocurrió un error al cargar el ranking.';
    this.$bvModal.show('modal-ranking');
  } finally {
    this.cargandoRanking = false;
  }
},

    formatearHeader(key) {
      // Convierte camelCase / snake_case a "Título"
      const limpio = String(key).replace(/[_\-]+/g, ' ');
      return limpio
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/^\w/, c => c.toUpperCase());
    },
    async enviarAEcommerce() {
      if (!this.puedeEscribir) return;
      try {
        const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
        if (!tok) {
          this.$notify && this.$notify({ type: 'warning', message: this.$t('selecciona_archivo_valido') });
          return;
        }

        const nombresSeleccionados = (this.clustersSelectedResumen || []).filter(Boolean);

        if (nombresSeleccionados.length === 0) {
          Swal.fire({
            icon: 'warning',
            title: this.$t('atencion'),
            text: this.$t('seleccione_al_menos_un_cluster'),
          });
          return;
        }

        const todosLosNombres = (this.clusterResumen || [])
          .map(item => item.nombreCluster || item.NombreCluster)
          .filter(Boolean);

        const ok = await Swal.fire({
          title: this.$t('enviar_ecommerce'),
          text: this.$t('enviar_ecommerce_texto').replace('{n}', nombresSeleccionados.length),
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('si_confirmar'),
          cancelButtonText: this.$t('cancelar'),
        });
        if (!ok.isConfirmed) return;

        // Resetea todos a 0, luego marca los seleccionados a 1
        // (por Id real, no por nombreCluster: el nombre se repite entre distintos idCriterio)
        const idsSeleccionados = this.resolverIdsClusterResumenPorNombre(nombresSeleccionados);
        const todosLosIds = this.resolverIdsClusterResumenPorNombre(todosLosNombres);
        await materialService.updateClustersParaEcommerce(tok, idsSeleccionados, todosLosIds);

        // Refleja el nuevo estado en los items locales sin recargar
        const selSet = new Set(nombresSeleccionados);
        this.clusterResumen = this.clusterResumen.map(item => ({
          ...item,
          paraEcommerce: selSet.has(item.nombreCluster || item.NombreCluster),
          ParaEcommerce: selSet.has(item.nombreCluster || item.NombreCluster),
        }));

        // Cambia estado del archivo a 'E'
        const updateResp = await materialService.updateEstadoFlujo(tok, 'E');
        await this.refrescarEstadoArchivo();
        if (!updateResp || updateResp.success === false) {
          this.$notify && this.$notify({ type: 'warning', message: this.$t('error_enviar_ecommerce') });
          return;
        }

        let estadoActual = null;
        try {
          estadoActual = await materialService.getEstadoFlujoArchivo(tok);
        } catch (e) { /* no-op */ }

        const nuevoEstado = (estadoActual && estadoActual.estadoFlujo) ? estadoActual.estadoFlujo : 'E';

        const idx = (this.archivosLogs || []).findIndex(a => (a.token || '').trim() === tok);
        if (idx !== -1) {
          this.archivosLogs.splice(idx, 1, {
            ...this.archivosLogs[idx],
            estadoFlujo: nuevoEstado,
            EstadoFlujo: nuevoEstado,
          });
        }

        if (this.archivoSeleccionado && (String(this.archivoSeleccionado.token).trim() === tok)) {
          this.archivoSeleccionado = {
            ...this.archivoSeleccionado,
            estadoFlujo: nuevoEstado,
            EstadoFlujo: nuevoEstado,
          };
        }

        await Swal.fire({
          title: this.$t('listo'),
          text: this.$t('clusters_marcados_ecommerce').replace('{n}', nombresSeleccionados.length),
          icon: 'success',
          confirmButtonText: this.$t('entendido'),
        });
      } catch (e) {
        console.error('Error al enviar a e-commerce:', e);
        this.$notify && this.$notify({ type: 'error', message: this.$t('error_enviar_ecommerce') });
      }
    },

    // Algunos valores de NombreCluster vienen fijos en español desde la BD (ej. "SIN
    // INFORMACION" cuando el material no tiene marca/clase/categoría cargada). Como no son
    // un nombre propio sino un texto genérico, se traducen en pantalla según el idioma activo.
    nombreClusterParaMostrar(nombre) {
      const txt = String(nombre == null ? '' : nombre).trim();
      if (this.lang === 'en' && txt.toUpperCase() === 'SIN INFORMACION') {
        return this.$t('sin_informacion_cluster');
      }
      return nombre;
    },

    async editarNombreCustomCluster(item) {
      const ids = (item && item.ids && item.ids.length) ? item.ids : [item && (item.id != null ? item.id : item.Id)].filter(id => id != null);
      if (!ids.length) return;

      const actual = item.nombreCustom || item.NombreCustom || item.nombreCluster || item.NombreCluster || '';
      const { value, isConfirmed } = await Swal.fire({
        title: this.$t('editar_nombre_cluster') || 'Editar nombre del cluster',
        input: 'text',
        inputValue: actual,
        inputPlaceholder: actual,
        showCancelButton: true,
        confirmButtonText: this.$t('guardar'),
        cancelButtonText: this.$t('cancelar'),
      });
      if (!isConfirmed) return;

      const nuevoNombre = (value || '').trim();
      try {
        await materialService.updateNombreCustomCluster(ids, nuevoNombre || null);
        this.$set(item, 'nombreCustom', nuevoNombre || null);
        Swal.fire({ icon: 'success', title: this.$t('guardado'), timer: 1500, showConfirmButton: false });
      } catch (e) {
        console.error('[editarNombreCustomCluster] error:', e);
        Swal.fire('Error', this.$t('error_guardar_cambios') || 'No se pudo guardar el nombre.', 'error');
      }
    },

    async onCheckResumenChange(item, event) {
      const token = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
      if (!token) return;

      if (event.target.checked) {
        await this.persistirSeleccionEcommerce(token);
        return;
      }

      const nombreCluster = item.nombreCluster || item.NombreCluster;

      try {
        const apiBase = process.env.VUE_APP_API_URL || '';
        const idCluster = item.id || item.Id || 0;
        const resp = await fetch(
          `${apiBase}/api/cluster/getFichasPublicadas/${encodeURIComponent(token)}/${idCluster}`,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
              'Accept': 'application/json'
            }
          }
        );

        if (!resp.ok) return;

        const data = await resp.json();
        if (!Array.isArray(data) || data.length === 0) {
          // Sin fichas publicadas: el desmarque procede, persiste de inmediato
          await this.persistirSeleccionEcommerce(token);
          return;
        }

        // Bloquear el desmarque: restaurar el valor en el array
        if (!this.clustersSelectedResumen.includes(nombreCluster)) {
          this.clustersSelectedResumen = [...this.clustersSelectedResumen, nombreCluster];
        }

        // Solo el nombre del archivo (sin duplicar): pueden ser cientos de fichas
        const nombresArchivos = [...new Set(data.map(f => f.nombreXLSX || '—'))];
        const items = nombresArchivos.map(n => `<li style="margin-bottom:4px"><b>${n}</b></li>`).join('');

        // SweetAlert2 v9 no soporta showDenyButton (llegó en v10.10), así que el
        // tercer botón se agrega manualmente dentro del html y se captura por evento.
        let eliminarIgualmenteClicked = false;
        const result = await Swal.fire({
          icon: 'error',
          title: this.$t('no_permitido'),
          html: `<p>${this.$t('cluster_fichas_publicadas')}</p>
                 <ul style="text-align:left;padding-left:1.2rem">${items}</ul>
                 <p style="margin-top:8px"><b>${this.$t('revise_modulo_ecommerce')}</b></p>
                 <button id="btnEliminarIgualmente" type="button" class="btn btn-sm btn-danger mt-2">
                   ${this.$t('eliminar_igualmente')}
                 </button>`,
          confirmButtonText: this.$t('entendido'),
          showCancelButton: true,
          cancelButtonText: this.$t('ir_a_ficha'),
          cancelButtonColor: '#17a2b8',
          onOpen: (popup) => {
            const btn = popup.querySelector('#btnEliminarIgualmente');
            if (btn) {
              btn.addEventListener('click', () => {
                eliminarIgualmenteClicked = true;
                Swal.close();
              });
            }
          }
        });

        if (eliminarIgualmenteClicked) {
          await this.eliminarFichasPublicadasIgualmente(token, idCluster, nombreCluster);
          return;
        }

        if (result.dismiss === Swal.DismissReason.cancel) {
          sessionStorage.setItem('lecturaVentasEstado', JSON.stringify({
            empresaSeleccionada: this.empresaSeleccionada,
            tokenActual: token,
            archivoSeleccionado: this.archivoSeleccionado
          }));
          window.open('/lectura-ventas-inventario', '_blank');
          return;
        }
      } catch (e) {
        console.error('Error al verificar fichas publicadas:', e);
      }
    },

    async eliminarFichasPublicadasIgualmente(token, idCluster, nombreCluster) {
      const confirm = await Swal.fire({
        icon: 'warning',
        title: this.$t('confirmar_eliminar_fichas'),
        text: this.$t('accion_irreversible'),
        showCancelButton: true,
        confirmButtonText: this.$t('eliminar_igualmente'),
        confirmButtonColor: '#d33',
        cancelButtonText: this.$t('cancelar'),
        reverseButtons: true
      });
      if (!confirm.isConfirmed) return;

      try {
        const apiBase = process.env.VUE_APP_API_URL || '';
        const resp = await fetch(
          `${apiBase}/api/cluster/desactivarFichasPublicadas/${encodeURIComponent(token)}/${idCluster}`,
          {
            method: 'PUT',
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
              'Accept': 'application/json'
            }
          }
        );

        if (!resp.ok) throw new Error(await resp.text());

        // Ahora sí se permite el desmarque, y se persiste de inmediato en e-commerce
        this.clustersSelectedResumen = this.clustersSelectedResumen.filter(c => c !== nombreCluster);
        await this.persistirSeleccionEcommerce(token);

        Swal.fire({ icon: 'success', title: this.$t('eliminado'), timer: 1800, showConfirmButton: false });
      } catch (e) {
        console.error('Error al desactivar fichas publicadas:', e);
        Swal.fire({
          icon: 'error',
          title: this.$t('error') || 'Error',
          text: this.$t('no_se_pudo_eliminar') || 'No se pudo eliminar.'
        });
      }
    },

    // El nombreCluster ("1", "2"...) se repite entre distintos idCriterio, así que no
    // sirve como llave única para marcar/desmarcar ParaEcommerce en dbo.ClustersResumen.
    // Se resuelven los Id reales (agrupados en "ids" durante el merge de tryFetchResumen).
    resolverIdsClusterResumenPorNombre(nombres) {
      const set = new Set(nombres || []);
      return (this.clusterResumen || [])
        .filter(item => set.has(item.nombreCluster || item.NombreCluster))
        .flatMap(item => (item.ids && item.ids.length) ? item.ids : [item.id != null ? item.id : item.Id])
        .filter(id => id != null);
    },

    async persistirSeleccionEcommerce(token) {
      if (!this.puedeEscribir) return;
      // Selección vacía es un estado válido: significa que ningún cluster
      // queda marcado para e-commerce (el backend resetea todo a 0).
      const nombresSeleccionados = (this.clustersSelectedResumen || []).filter(Boolean);

      const todosLosNombres = (this.clusterResumen || [])
        .map(it => it.nombreCluster || it.NombreCluster)
        .filter(Boolean);

      const idsSeleccionados = this.resolverIdsClusterResumenPorNombre(nombresSeleccionados);
      const todosLosIds = this.resolverIdsClusterResumenPorNombre(todosLosNombres);

      try {
        await materialService.updateClustersParaEcommerce(token, idsSeleccionados, todosLosIds);

        const selSet = new Set(nombresSeleccionados);
        this.clusterResumen = this.clusterResumen.map(it => ({
          ...it,
          paraEcommerce: selSet.has(it.nombreCluster || it.NombreCluster),
          ParaEcommerce: selSet.has(it.nombreCluster || it.NombreCluster),
        }));
      } catch (e) {
        console.error('Error al actualizar selección de e-commerce:', e);
        this.$notify && this.$notify({ type: 'error', message: this.$t('error_enviar_ecommerce') });
      }
    },

    async cargarResumenSiF(idCriterio) {
  if (!this.archivoSeleccionado || !this.archivoSeleccionado.token) {
    this.$notify && this.$notify({ type: 'warning', message: 'Selecciona un archivo primero' });
    return;
  }
  const tok = String(this.archivoSeleccionado.token || '').trim();

  try {
    // 🔹 Lee estados custom desde el backend Cluster
    const estados = await materialService.getEstadosCustom(tok);
    const e1 = estados ? estados.estadoCustom1 : null;
    const e2 = estados ? estados.estadoCustom2 : null;
    const e3 = estados ? estados.estadoCustom3 : null;

    // Sincroniza en memoria
    this.archivoSeleccionado = {
      ...this.archivoSeleccionado,
      EstadoCustom1: e1, estadoCustom1: e1,
      EstadoCustom2: e2, estadoCustom2: e2,
      EstadoCustom3: e3, estadoCustom3: e3,
    };

    // 8 = Custom1, 9 = Custom2, 10 = Custom3
    const estado =
      idCriterio === 8 ? this.normalizeEstado(e1) :
      idCriterio === 9 ? this.normalizeEstado(e2) :
      idCriterio === 10 ? this.normalizeEstado(e3) : null;

    // Si está Finalizado (F) → mostrar resumen
    // Si está Finalizado (F) → SIEMPRE mostrar contenedores,
// aunque el resumen venga vacío.
if (estado === 'F') {
  this.isEditing = false;
  this.mostrarCustom1 = this.mostrarCustom2 = this.mostrarCustom3 = false;
  this.mostrarDetalleCluster = false;

  this.clusterResumen = [];
  this.sinDatos = false;
  this.msgSinDatos = this.$t('no_hay_datos_criterio');

  let ok = false;
  try {
    ok = await this.tryFetchResumen(idCriterio);
  } catch (e) {
    console.error('Resumen Custom(F) error:', e);
    ok = false;
  }

  // 🔴 Antes: this.mostrarCluster = ok;
  // ✅ Ahora: SIEMPRE mostrar contenedores al estar F
  this.mostrarCluster = true;

  // Mantén la bandera para el aviso, pero sin ocultar el layout
  this.seHizoConsultaResumen = true;
  this.sinDatos = !ok;

  // Selecciona el criterio correspondiente, aunque esté vacío
  this.tipoClusterSeleccionado = {
    id: idCriterio,
    texto: idCriterio === 8 ? 'Custom 1' : idCriterio === 9 ? 'Custom 2' : 'Custom 3'
  };

  return;
}

    // No finalizado → abrir edición del custom elegido
    this.isEditing = true;
    this.mostrarCluster = true;
    this.mostrarDetalleCluster = false;
    this.tipoClusterSeleccionado = null;

    if (idCriterio === 8) {
      this.mostrarCustom1 = true;
      this.mostrarCustom2 = false;
      this.mostrarCustom3 = false;
      await this.fetchCustom1(1);
      return;
    }

    if (idCriterio === 9) {
      this.mostrarCustom1 = false;
      this.mostrarCustom2 = true;
      this.mostrarCustom3 = false;
      await this.fetchCustom2(1);
      return;
    }

    if (idCriterio === 10) {
      this.mostrarCustom1 = false;
      this.mostrarCustom2 = false;
      this.mostrarCustom3 = true;

      this.mostrarCluster = true;
      this.mostrarDetalleCluster = false;

      this.isEditing = true;

      this.tipoClusterSeleccionado = {
        id: 10,
        texto: "Custom 3",
      };

      await this.fetchCustom3(1);

      return;
    }
  } catch (err) {
    console.error('Error al cargar estados desde BD:', err);
    this.$notify && this.$notify({ type: 'danger', message: 'No se pudieron leer los estados del backend' });
  }
},
async editarCustom2DesdeResumen() {
  // No importará si está F: este botón fuerza MODO EDICIÓN (como Custom 1)
  await this.refrescarEstadoArchivo(); // opcional, mantiene estado al día

  await this.resetEstadoCustomEnBD(2);

  this.isEditing = true;
  this.mostrarCustom1 = false;
  this.mostrarCustom2 = true;
  this.mostrarCustom3 = false;

  this.mostrarDetalleCluster = false;
  this.mostrarCluster = true;
  this.tipoClusterSeleccionado = null; // clave: salimos del resumen

  await this.fetchCustom2(1);
},
async editarCustom3DesdeResumen() {
  await this.refrescarEstadoArchivo();

  await this.resetEstadoCustomEnBD(3);

  // No finalizado → abre edición
  this.isEditing = true;
  this.mostrarCustom1 = false;
  this.mostrarCustom2 = false;
  this.mostrarCustom3 = true;
  this.mostrarDetalleCluster = false;
  this.mostrarCluster = true;
  this.tipoClusterSeleccionado = null;

  await this.fetchCustom3(1);
},
    async volverAlResumenCustom2() {
      this.isEditing = false;
      this.mostrarCustom1 = false;
      this.mostrarCustom2 = false;
      this.mostrarCustom3 = false;
      this.mostrarDetalleCluster = false;
      this.mostrarCluster = true;

      this.tipoClusterSeleccionado = { id: 9, texto: 'Custom 2' };
      this.clusterResumen = [];
      try {
        await this.tryFetchResumen(9);
      } catch (e) {
        console.error('Error al volver al resumen de Custom 2:', e);
        this.$notify && this.$notify({ type: 'error', message: 'No se pudo cargar el resumen de Custom 2' });
      }
    },
    async volverAlResumenCustom3() {
  this.isEditing = false;
  this.mostrarCustom1 = false;
  this.mostrarCustom2 = false;
  this.mostrarCustom3 = false;
  this.mostrarDetalleCluster = false;
  this.mostrarCluster = true;

  this.tipoClusterSeleccionado = { id: 10, texto: 'Custom 3' };
  this.clusterResumen = [];
  try {
    await this.tryFetchResumen(10);
  } catch (e) {
    console.error('Error al volver al resumen de Custom 3:', e);
    this.$notify && this.$notify({ type: 'error', message: 'No se pudo cargar el resumen de Custom 3' });
  }
},
    async volverAlResumenCustom1() {
      this.isEditing = false;
      // Volver a la vista de criterio (gráfico + resumen)
      this.mostrarCustom1 = false;
      this.mostrarCustom2 = false;
      this.mostrarCustom3 = false;
      this.mostrarDetalleCluster = false;
      this.mostrarCluster = true;

      // Selecciona el criterio Custom 1 y carga su resumen
      this.tipoClusterSeleccionado = { id: 8, texto: 'Custom 1' };
      this.clusterResumen = [];
      try {
        await this.tryFetchResumen(8); // reutiliza tu fetch de resumen
      } catch (e) {
        console.error('Error al volver al resumen de Custom 1:', e);
        this.$notify && this.$notify({ type: 'error', message: 'No se pudo cargar el resumen de Custom 1' });
      }
    },
    async editarCustom1DesdeResumen() {
      await this.refrescarEstadoArchivo();

      await this.resetEstadoCustomEnBD(1);

      this.isEditing = true;
      this.mostrarCustom1 = true;
      this.mostrarCustom2 = false;
      this.mostrarCustom3 = false;

      this.mostrarDetalleCluster = false;
      this.mostrarCluster = true;

      this.tipoClusterSeleccionado = null;

      await this.fetchCustom1(1);
    },

    async resetEstadoCustomEnBD(nro) {
      const token = this.archivoSeleccionado && this.archivoSeleccionado.token;
      if (!token) return;
      const apiBase = process.env.VUE_APP_API_URL || '';
      try {
        await fetch(`${apiBase}/api/cluster/reset-estado-custom/${encodeURIComponent(token)}/${nro}`, {
          method: 'PUT',
          headers: { 'Authorization': 'Bearer ' + localStorage.getItem('user-session') },
        });
        // Actualiza el estado local para que isCustomNFinalizado reactive inmediatamente
        const key = `EstadoCustom${nro}`;
        const keyCamel = `estadoCustom${nro}`;
        if (this.archivoSeleccionado) {
          this.$set(this.archivoSeleccionado, key, null);
          this.$set(this.archivoSeleccionado, keyCamel, null);
        }
      } catch (e) {
        console.error(`Error al resetear EstadoCustom${nro}:`, e);
      }
    },

    async tryFetchResumen(idCriterio) {
  // resetea bandera en cada intento
  this.seHizoConsultaResumen = false;

  const token = this.archivoSeleccionado && this.archivoSeleccionado.token;
  const apiBase = process.env.VUE_APP_API_URL || '';
  const url = apiBase + '/api/cluster/getClustersResumenAgrupado/' + token + '/' + idCriterio;

  const resp = await fetch(url, {
    headers: { 'Authorization': 'Bearer ' + localStorage.getItem('user-session') }
  });
  if (!resp.ok) {
    throw new Error('Error ' + resp.status + ': ' + resp.statusText);
  }

  const data = await resp.json();
  console.log('📦 Resumen recibido desde API:', data);

  // --- Normaliza a array
  const arr = Array.isArray(data) ? data : [];

  // --- 1) Normaliza la clave de nombre y el valor numérico
  const normalizados = arr.map(x => {
    let nombre =
      (x && x.nombreCluster != null) ? x.nombreCluster :
      (x && x.NombreCluster != null) ? x.NombreCluster :
      (x && x.NombreClase   != null) ? x.NombreClase   :
      (x && x.nombreClase   != null) ? x.nombreClase   :
      (x && x.cluster       != null) ? x.cluster       :
      (x ? x.numeroCluster : '');

    let valorRaw =
      (x && x.valor != null) ? x.valor :
      (x && x.total != null) ? x.total :
      (x && x.monto != null) ? x.monto : 0;

    return {
      ...x,
      nombreCluster: String(nombre || '').trim(),
      valor: Number(valorRaw || 0)
    };
  });

  // --- 2) Dedupe + sumatoria por nombreCluster
  // Se conservan TODOS los Id reales agrupados en "ids": el nombreCluster ("1", "2"...)
  // se repite entre distintos idCriterio, así que no sirve como llave única para
  // identificar filas de dbo.ClustersResumen (ver updateClustersParaEcommerce).
  const byNombre = {};
  for (let i = 0; i < normalizados.length; i++) {
    const it = normalizados[i];
    const k = it && it.nombreCluster ? it.nombreCluster : '';
    if (!k) continue;
    const idFila = it.id != null ? it.id : it.Id;
    if (!byNombre[k]) {
      byNombre[k] = { ...it, ids: idFila != null ? [idFila] : [] };
    } else {
      byNombre[k].valor = Number(byNombre[k].valor || 0) + Number(it.valor || 0);
      // si cualquier fila del grupo tiene ParaEcommerce, la suma lo hereda
      if (it.paraEcommerce || it.ParaEcommerce) byNombre[k].paraEcommerce = true;
      if (idFila != null) byNombre[k].ids.push(idFila);
    }
  }

  // --- 3) Lista final sin duplicados, ordenada por valor desc
  const lista = Object.values(byNombre).sort((a, b) => (b.valor || 0) - (a.valor || 0));
  this.clusterResumen = lista;

  // pre-marca los clusters que ya tienen ParaEcommerce = true en BD
  this.clustersSelectedResumen = lista
    .filter(item => item.paraEcommerce || item.ParaEcommerce)
    .map(item => item.nombreCluster || item.NombreCluster);
  this.checkAllResumen = this.clustersSelectedResumen.length === lista.length && lista.length > 0;

  // marca que hicimos la consulta y si hay o no datos
  this.seHizoConsultaResumen = true;
  this.sinDatos = this.clusterResumen.length === 0;

  // asegura mostrar contenedores
  this.mostrarCluster = true;

  // devuelve true si hay filas
  const tieneFilas = this.clusterResumen.length > 0;
  return tieneFilas;
},
    normalizeEstado(val) {
      if (val === null || val === undefined) return null;
      return String(val).trim().toUpperCase(); // " f " -> "F"
    },
    // "NR" (Directo a Cluster): el archivo salta la rentabilización y se clusteriza
    // directamente, así que no se le ofrece la acción de rentabilizar.
    esFlujoDirectoCluster(archivo) {
      return String((archivo && (archivo.tipoFlujo || archivo.TipoFlujo)) || '').trim().toUpperCase() === 'NR';
    },

    async refrescarEstadoArchivo() {
      try {
        const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
        if (!tok) return;

        // Usa el método que sí existe en tu service
const log = await materialService.getFileLog(tok);

        // Normaliza nombres según cómo venga del backend (sin ??)
        const back1 = log ? (log.EstadoCustom1 != null ? log.EstadoCustom1 : (log.estadoCustom1 != null ? log.estadoCustom1 : null)) : null;
        const back2 = log ? (log.EstadoCustom2 != null ? log.EstadoCustom2 : (log.estadoCustom2 != null ? log.estadoCustom2 : null)) : null;
        const back3 = log ? (log.EstadoCustom3 != null ? log.EstadoCustom3 : (log.estadoCustom3 != null ? log.estadoCustom3 : null)) : null;

        // 🔒 CONSERVA el valor previo si el backend viene null/undefined
        const prev1 = this.archivoSeleccionado ? (this.archivoSeleccionado.EstadoCustom1 != null ? this.archivoSeleccionado.EstadoCustom1 : this.archivoSeleccionado.estadoCustom1) : null;
        const prev2 = this.archivoSeleccionado ? (this.archivoSeleccionado.EstadoCustom2 != null ? this.archivoSeleccionado.EstadoCustom2 : this.archivoSeleccionado.estadoCustom2) : null;
        const prev3 = this.archivoSeleccionado ? (this.archivoSeleccionado.EstadoCustom3 != null ? this.archivoSeleccionado.EstadoCustom3 : this.archivoSeleccionado.estadoCustom3) : null;

        // Valor final: backend si existe; si no, mantén el previo
        const estado1 = (back1 != null ? String(back1).trim() : (prev1 != null ? String(prev1).trim() : null));
        const estado2 = (back2 != null ? String(back2).trim() : (prev2 != null ? String(prev2).trim() : null));
        const estado3 = (back3 != null ? String(back3).trim() : (prev3 != null ? String(prev3).trim() : null));

        // Actualiza el seleccionado
        this.archivoSeleccionado = {
          ...this.archivoSeleccionado,
          EstadoCustom1: estado1,
          EstadoCustom2: estado2,
          EstadoCustom3: estado3,
          estadoCustom1: estado1,
          estadoCustom2: estado2,
          estadoCustom3: estado3,
        };

        // Actualiza también la lista para mantener consistencia
        const i = (this.archivosLogs || []).findIndex(a => String(a.token).trim() === tok);
        if (i !== -1) {
          this.archivosLogs.splice(i, 1, {
            ...this.archivosLogs[i],
            EstadoCustom1: estado1,
            EstadoCustom2: estado2,
            EstadoCustom3: estado3,
            estadoCustom1: estado1,
            estadoCustom2: estado2,
            estadoCustom3: estado3,
          });
        }


      } catch (e) {
        console.error('No se pudo refrescar estado del archivo:', e);
      }
    },

    getEstadoCustomByCriterio(idCriterio) {
      if (!this.archivoSeleccionado) return null;

      const pick = (o, keys) => {
        for (let k of keys) {
          const v = o[k];
          if (v !== undefined && v !== null && String(v).trim() !== '') return String(v).toUpperCase();
        }
        return null;
      };

      if (idCriterio === 8) return pick(this.archivoSeleccionado, ['EstadoCustom1', 'estadoCustom1', 'Estado1', 'estado1', 'EstadoCustom']);
      if (idCriterio === 9) return pick(this.archivoSeleccionado, ['EstadoCustom2', 'estadoCustom2', 'Estado2', 'estado2', 'EstadoCustom']);
      if (idCriterio === 10) return pick(this.archivoSeleccionado, ['EstadoCustom3', 'estadoCustom3', 'Estado3', 'estado3', 'EstadoCustom']);
      return null;
    },
    confirmarModalFinalizarCustom3(archivo) {
  this.archivoPendienteFinalizacionCustom3 = archivo || this.archivoSeleccionado || null;
  this.$bvModal && this.$bvModal.show('modal-confirmar-finalizar-custom3');
},

// ====== FINALIZAR CUSTOM (1/2/3) USANDO update-estado-custom ======
async onClickFinalizarCustom(nro) {
  if (!this.puedeEscribir) return;
  const prop = nro === 1 ? 'finalizandoCustom1' : nro === 2 ? 'finalizandoCustom2' : 'finalizandoCustom3';
  if (this[prop]) return;
  this[prop] = true;
  try {
    await this.finalizarCustom(nro);
  } finally {
    this[prop] = false;
  }
},

    async finalizarCustom3(archivo) {
      try {
        if (!archivo || !archivo.token) {
          if (this.$notify) this.$notify({ type: 'warning', message: 'Selecciona un archivo válido' });
          return;
        }

        // Llama al endpoint del servicio (igual patrón que Custom 1)
        const resp = await materialService.finalizarCustom3(archivo.token);
        if (!resp || resp.success === false) {
          if (this.$notify) this.$notify({ type: 'warning', message: 'No se pudo actualizar EstadoCustom3' });
          return;
        }

        // Sincroniza UI local (cubre PascalCase/camelCase)
        const lista = this.archivosLogs || [];
        const idx = lista.findIndex(a => a.token === archivo.token);
        if (idx !== -1) {
          this.archivosLogs.splice(idx, 1, {
            ...this.archivosLogs[idx],
            EstadoCustom3: 'F',
            estadoCustom3: 'F',
          });
        }
        if (this.archivoSeleccionado && this.archivoSeleccionado.token === archivo.token) {
          this.archivoSeleccionado = {
            ...this.archivoSeleccionado,
            EstadoCustom3: 'F',
            estadoCustom3: 'F',
          };
        }

        if (this.$notify) this.$notify({ type: 'success', message: 'Custom 3 finalizado (EstadoCustom3 = F)' });
        await this.refrescarEstadoArchivo();
      } catch (e) {
        console.error('Error al finalizar Custom 3:', e);
        if (this.$notify) this.$notify({ type: 'error', message: 'Error al finalizar Custom 3' });
      }
      // Llevar al resumen de Custom 3 (igual que C1)
      this.isEditing = false;
      this.mostrarCustom1 = false;
      this.mostrarCustom2 = false;
      this.mostrarCustom3 = false;
      this.mostrarDetalleCluster = false;
      this.mostrarCluster = true;
      this.tipoClusterSeleccionado = { id: 9, texto: 'Custom 3' };
      this.clusterResumen = [];
      try {
        await this.tryFetchResumen(9);
      } catch (e) {
        console.error('No se pudo recargar el resumen de Custom 3:', e);
      }
    },
    confirmarModalFinalizarCustom2(archivo) {
      this.archivoPendienteFinalizacionCustom2 = archivo || this.archivoSeleccionado;
      if (this.$bvModal) this.$bvModal.show('modal-confirmar-finalizar-custom2');
    },

    async finalizarCustom2(archivo) {
      try {
        if (!archivo || !archivo.token) {
          if (this.$notify) this.$notify({ type: 'warning', message: 'Selecciona un archivo válido' });
          return;
        }

        // Llama al endpoint del servicio (igual patrón que Custom 1)
        const resp = await materialService.finalizarCustom2(archivo.token);
        if (!resp || resp.success === false) {
          if (this.$notify) this.$notify({ type: 'warning', message: 'No se pudo actualizar EstadoCustom2' });
          return;
        }

        // Sincroniza UI local (cubre PascalCase/camelCase)
        const lista = this.archivosLogs || [];
        const idx = lista.findIndex(a => a.token === archivo.token);
        if (idx !== -1) {
          this.archivosLogs.splice(idx, 1, {
            ...this.archivosLogs[idx],
            EstadoCustom2: 'F',
            estadoCustom2: 'F',
          });
        }
        if (this.archivoSeleccionado && this.archivoSeleccionado.token === archivo.token) {
          this.archivoSeleccionado = {
            ...this.archivoSeleccionado,
            EstadoCustom2: 'F',
            estadoCustom2: 'F',
          };
        }

        if (this.$notify) this.$notify({ type: 'success', message: 'Custom 2 finalizado (EstadoCustom2 = F)' });
        await this.refrescarEstadoArchivo();
      } catch (e) {
        console.error('Error al finalizar Custom 2:', e);
        if (this.$notify) this.$notify({ type: 'error', message: 'Error al finalizar Custom 2' });
      }
      // Llevar al resumen de Custom 2 (igual que C1)
      this.isEditing = false;
      this.mostrarCustom1 = false;
      this.mostrarCustom2 = false;
      this.mostrarCustom3 = false;
      this.mostrarDetalleCluster = false;
      this.mostrarCluster = true;
      this.tipoClusterSeleccionado = { id: 9, texto: 'Custom 2' };
      this.clusterResumen = [];
      try {
        await this.tryFetchResumen(9);
      } catch (e) {
        console.error('No se pudo recargar el resumen de Custom 2:', e);
      }
    },
    confirmarModalFinalizarCustom1(archivo) {
      this.archivoPendienteFinalizacionCustom1 = archivo || this.archivoSeleccionado;
      this.$bvModal && this.$bvModal.show('modal-confirmar-finalizar-custom1');
    },



async finalizarCustom1(archivo) {
  try {
    const tok = archivo && String(archivo.token || '').trim();
    if (!tok) {
      this.$notify && this.$notify({ type: 'warning', message: 'Selecciona un archivo válido' });
      return;
    }

    // 👉 Llama al endpoint correcto de MaterialesController
    const resp = await materialService.finalizarCustom1(tok);
    if (!resp || resp.success === false) {
      this.$notify && this.$notify({ type: 'warning', message: 'No se pudo actualizar EstadoCustom1' });
      return;
    }

    // ✅ Sincroniza UI local
    const idx = (this.archivosLogs || []).findIndex(a => (String(a.token || '').trim() === tok));
    if (idx !== -1) {
      this.archivosLogs.splice(idx, 1, {
        ...this.archivosLogs[idx],
        EstadoCustom1: 'F',
        estadoCustom1: 'F',
      });
    }
    if (this.archivoSeleccionado && (String(this.archivoSeleccionado.token || '').trim() === tok)) {
      this.archivoSeleccionado = {
        ...this.archivoSeleccionado,
        EstadoCustom1: 'F',
        estadoCustom1: 'F',
      };
    }

    this.$notify && this.$notify({ type: 'success', message: 'Custom 1 finalizado (EstadoCustom1 = F)' });

    // ➜ Volver al resumen de Custom 1
    this.isEditing = false;
    this.mostrarCustom1 = false;
    this.mostrarCustom2 = false;
    this.mostrarCustom3 = false;
    this.mostrarDetalleCluster = false;
    this.mostrarCluster = true;
    this.tipoClusterSeleccionado = { id: 8, texto: 'Custom 1' };
    this.clusterResumen = [];
    try { await this.tryFetchResumen(8); } catch (e) { console.error('No se pudo recargar el resumen de Custom 1:', e); }
  } catch (e) {
    console.error('Error al finalizar Custom 1:', e);
    this.$notify && this.$notify({ type: 'danger', message: 'Error al finalizar Custom 1' });
  }
},   

    async confirmarFinalizacion() {
      if (!this.archivoPendienteFinalizacion) return;
      const archivo = this.archivoPendienteFinalizacion;
      this.archivoPendienteFinalizacion = null;
      await this.finalizarCluster(archivo);
    },

    async finalizarCluster(archivo) {
      try {
        if (!archivo || !archivo.token) {
          this.$notify && this.$notify({ type: 'warning', message: 'Selecciona un archivo válido' });
          return;
        }

        // 1) Cambia estado a 'C'
        const updateResp = await materialService.updateEstadoFlujo(archivo.token, 'C');

        if (!updateResp || updateResp.success === false) {
          this.$notify && this.$notify({ type: 'warning', message: 'No se pudo actualizar el estado a C' });
          return;
        }

        // 2) Refresca estado real del archivo (si tu API lo expone)
        let estadoActual = null;
        try {
          estadoActual = await materialService.getEstadoFlujoArchivo(archivo.token);
        } catch (e) {
          // Si no existe este endpoint en tu service, puedes omitir este bloque
          console.warn('No se pudo refrescar estado actual del archivo:', e);
        }

        // 3) Sincroniza en memoria: archivosLogs y archivoSeleccionado
        const idx = this.archivosLogs.findIndex(a => a.token === archivo.token);
        if (idx !== -1) {
          this.archivosLogs.splice(idx, 1, {
            ...this.archivosLogs[idx],
            estadoFlujo: (estadoActual && estadoActual.estadoFlujo) ? estadoActual.estadoFlujo : 'C',
            fechaRentabilizacion: estadoActual ? estadoActual.fechaRentabilizacion : this.archivosLogs[idx].fechaRentabilizacion
          });
        }

        if (this.archivoSeleccionado && this.archivoSeleccionado.token === archivo.token) {
          this.archivoSeleccionado = {
            ...this.archivoSeleccionado,
            estadoFlujo: (estadoActual && estadoActual.estadoFlujo) ? estadoActual.estadoFlujo : 'C',
            fechaRentabilizacion: estadoActual ? estadoActual.fechaRentabilizacion : this.archivoSeleccionado.fechaRentabilizacion
          };
        }

        // 4) Opcional: bloquear edición en vistas Custom o limpiar selección
        // this.mostrarCustom1 = false;
        // this.mostrarCustom2 = false;
        // this.mostrarCustom3 = false;

        //this.$notify && this.$notify({ type: 'success', message: 'Cluster finalizado. Estado actualizado a "C"' });
      } catch (e) {
        console.error('Error al finalizar cluster:', e);
        this.$notify && this.$notify({ type: 'error', message: 'Error al finalizar cluster' });
      }
    },
    onCriterioCustom3Input(value, item) {
      item.criterioCustom3 = value != null ? String(value) : '';
    },

    hasSeleccionC1(row) {
  return Number(this.normalizeC1Value(row) || 0) > 0;
},
    hasSeleccionC2(row) {
  return Number(this.normalizeC2Value(row) || 0) > 0;
},
    hasSeleccionC3(row) {
  return Number(this.normalizeC3Value(row) || 0) > 0;
},

    isC1Checked(row, n) {
  // marcado si el valor actual es exactamente n (como número o string)
  const v = row && row.criterioCustom1;
  if (v === null || v === undefined || v === '') return false;
  return String(v).trim() === String(n);
},

isTodosC1Checked(n) {
  const data = this.custom1DataFiltrado;
  return data.length > 0 && data.every(r => this.isC1Checked(r, n));
},
toggleAllClustersResumen(event) {
  const checked = event.target.checked;
  if (checked) {
    this.clustersSelectedResumen = this.clusterResumenFiltrado.map(
      item => item.nombreCluster || item.NombreCluster
    );
  } else {
    this.clustersSelectedResumen = [];
  }
},

async toggleTodosC1(n, checked) {
  // Solo lo que esta filtrado/visible en la tabla, no this.custom1Data completo.
  const filas = this.custom1DataFiltrado;
  const ids = filas.map(r => this.getMaterialId(r)).filter(id => id != null && id > 0);
  if (!ids.length) return;

  const result = await Swal.fire({
    title: this.$t('esta_seguro'),
    text: this.$t('accion_afecta_registros_filtrados').replace('{n}', ids.length),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: this.$t('confirmar'),
    cancelButtonText: this.$t('cancelar'),
  });
  if (!result.isConfirmed) return;

  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  if (!tok) return;

  Swal.fire({ title: 'Procesando...', text: 'Esto puede tardar unos segundos, espera el mensaje de término.', allowOutsideClick: false, showConfirmButton: false, timer: 99999 });
  try {
    const valor = checked ? Number(n) : 0;
    await this.putUpdateMaterialClusterBulkByIds(tok, 1, valor, ids);
    filas.forEach(row => {
      this.$set(row, 'numeroClusterCustom1', valor);
      this.$set(row, 'criterioCustom1', checked ? String(n) : null);
    });
    Swal.fire({ title: '¡Listo!', icon: 'success', timer: 1500, showConfirmButton: false });
  } catch (e) {
    console.error('[toggleTodosC1] error:', e);
    Swal.fire({ icon: 'error', title: 'Oops...', text: 'Error al actualizar los registros.' });
  }
},

isTodosC2Checked(n) {
  const data = this.custom2DataFiltrado;
  return data.length > 0 && data.every(r => this.isC2Checked(r, n));
},
async toggleTodosC2(n, checked) {
  const filas = this.custom2DataFiltrado;
  const ids = filas.map(r => this.getMaterialId(r)).filter(id => id != null && id > 0);
  if (!ids.length) return;

  const result = await Swal.fire({
    title: this.$t('esta_seguro'),
    text: this.$t('accion_afecta_registros_filtrados').replace('{n}', ids.length),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: this.$t('confirmar'),
    cancelButtonText: this.$t('cancelar'),
  });
  if (!result.isConfirmed) return;

  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  if (!tok) return;

  Swal.fire({ title: 'Procesando...', text: 'Esto puede tardar unos segundos, espera el mensaje de término.', allowOutsideClick: false, showConfirmButton: false, timer: 99999 });
  try {
    const valor = checked ? Number(n) : 0;
    await this.putUpdateMaterialClusterBulkByIds(tok, 2, valor, ids);
    filas.forEach(row => {
      this.$set(row, 'numeroClusterCustom2', valor);
      this.$set(row, 'criterioCustom2', checked ? String(n) : null);
    });
    Swal.fire({ title: '¡Listo!', icon: 'success', timer: 1500, showConfirmButton: false });
  } catch (e) {
    console.error('[toggleTodosC2] error:', e);
    Swal.fire({ icon: 'error', title: 'Oops...', text: 'Error al actualizar los registros.' });
  }
},

isTodosC3Checked(n) {
  const data = this.custom3DataFiltrado;
  return data.length > 0 && data.every(r => this.isC3Checked(r, n));
},
async toggleTodosC3(n, checked) {
  const filas = this.custom3DataFiltrado;
  const ids = filas.map(r => this.getMaterialId(r)).filter(id => id != null && id > 0);
  if (!ids.length) return;

  const result = await Swal.fire({
    title: this.$t('esta_seguro'),
    text: this.$t('accion_afecta_registros_filtrados').replace('{n}', ids.length),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: this.$t('confirmar'),
    cancelButtonText: this.$t('cancelar'),
  });
  if (!result.isConfirmed) return;

  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  if (!tok) return;

  Swal.fire({ title: 'Procesando...', text: 'Esto puede tardar unos segundos, espera el mensaje de término.', allowOutsideClick: false, showConfirmButton: false, timer: 99999 });
  try {
    const valor = checked ? Number(n) : 0;
    await this.putUpdateMaterialClusterBulkByIds(tok, 3, valor, ids);
    filas.forEach(row => {
      this.$set(row, 'numeroClusterCustom3', valor);
      this.$set(row, 'criterioCustom3', checked ? String(n) : null);
    });
    Swal.fire({ title: '¡Listo!', icon: 'success', timer: 1500, showConfirmButton: false });
  } catch (e) {
    console.error('[toggleTodosC3] error:', e);
    Swal.fire({ icon: 'error', title: 'Oops...', text: 'Error al actualizar los registros.' });
  }
},

async onToggleC1(row, n, checked) {
  if (!row) return;

  const valor = checked ? Number(n) : 0;
  this.$set(row, 'numeroClusterCustom1', valor);
  this.$set(row, 'criterioCustom1', checked ? String(n) : null);

  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  const id  = Number(this.getMaterialId(row) || 0);
  if (!tok || !id) return;

  try {
    await this.putUpdateMaterialCluster(tok, id, 1, valor);
  } catch (e) {
    console.error('[onToggleC1] error al guardar:', e);
    this.$notify && this.$notify({ type: 'danger', message: 'Error al guardar el cambio.' });
  }
},

// ====== CUSTOM 2 ======
isC2Checked(row, n) {
  return Number(this.normalizeC2Value(row) || 0) === Number(n || 0);
},
async onToggleC2(row, n, checked) {
  if (!this.puedeEscribir) return;
  if (!row) return;

  const valor = checked ? Number(n) : 0;
  this.$set(row, 'numeroClusterCustom2', valor);
  this.$set(row, 'criterioCustom2', checked ? String(n) : null);

  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  const id  = Number(this.getMaterialId(row) || 0);
  if (!tok || !id) return;

  try {
    await this.putUpdateMaterialCluster(tok, id, 2, valor);
  } catch (e) {
    console.error('[onToggleC2] error al guardar:', e);
    this.$notify && this.$notify({ type: 'danger', message: 'Error al guardar el cambio.' });
  }
},
async confirmarGuardarCustom2() {
  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  if (!tok) {
    this.$notify && this.$notify({ type: 'warning', message: 'Selecciona un archivo válido' });
    return;
  }

  try {
    this.cargandoCustom1 = true;

    // 1) Calcula diffs locales (solo lo que cambió)
    const cambios = this.getModifiedRowsCustom2();
    console.log('💾 [C1] cambios a guardar:', cambios.length, cambios);

    // 2) Persiste cada cambio y ESPERA a que termine
    if (cambios.length > 0) {
      // En serie (más seguro con SQL)
      for (const ch of cambios) {
        await this.putUpdateMaterialCluster(
          tok,
          ch.idMaterialETL,
          1,               // ← C1
          ch.valor == null ? 0 : Number(ch.valor)
        );
      }
      //this.$notify && this.$notify({ type: 'success', message: 'Cambios guardados en Custom 1.' });
    } else {
      console.log('💾 [C1] No hay cambios que guardar.');
    }

    // 3) Actualiza snapshot local (para que al volver no aparezcan como "pendientes")
    this.initialCustom1Data = (this.custom1Data || []).map(r => ({
      idMaterialETL: this.getMaterialId(r),
      numeroClusterCustom1: this.normalizeC1Value(r)
    }));

    // 4) Finaliza y refresca el RESUMEN (esto navega al resumen)
    //    → SOLO después de terminar de guardar
    const ok = await this.finalizarCustom(2);
    if (!ok) {
      // Si no pudo finalizar, al menos quédate en la pantalla y no “pierdas” el contexto
      this.$notify && this.$notify({ type: 'warning', message: 'Cambios quedaron guardados, pero no se pudo finalizar.' });
    }
  } catch (e) {
    console.error('Error al guardar o finalizar Custom 2:', e);
    this.$notify && this.$notify({ type: 'danger', message: 'Error al guardar o finalizar Custom 1' });
  } finally {
    this.cargandoCustom1 = false;
  }
},

// =======================
//   GUARDAR CUSTOM 3
// =======================
async confirmarGuardarCustom3() {
  try {
    const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
    if (!tok) {
      this.$notify && this.$notify({ type: 'warning', message: 'Selecciona un archivo válido' });
      return;
    }

    // 1️⃣ OBTENER SOLO LOS CAMBIOS
    const cambios = this.getModifiedRowsCustom3();
    if (!cambios.length) {
      this.$notify && this.$notify({ type: 'info', message: 'No hay cambios para guardar' });
      return;
    }

    this.$notify && this.$notify({ type: 'info', message: 'Guardando cambios…' });

    // 2️⃣ GUARDAR UNO POR UNO
    for (let i = 0; i < cambios.length; i++) {
      const it = cambios[i];
      await this.putUpdateMaterialCluster(tok, it.idMaterialETL, 3, it.valor);
    }

    // 3️⃣ FINALIZAR CUSTOM 3 (estado = F)
    this.$notify && this.$notify({ type: 'info', message: 'Finalizando Custom 3…' });

    await this.finalizarCustom(3); // 🔥🔥🔥 esto lo lleva al resumen

    // 4️⃣ REFRESCAR Y MOSTRAR EL RESUMEN
    this.$notify && this.$notify({
      type: 'success',
      message: 'Custom 3 guardado y finalizado'
    });

    // 🔥 Mostrar resumen actualizado del Custom 3
    await this.cargarResumenSiF(10);

  } catch (err) {
    console.error('Error guardar Custom 3:', err);
    this.$notify && this.$notify({
      type: 'danger',
      message: 'No se pudo guardar Custom 3'
    });
  }
},

// ===== CHECKBOX C3 =====
isC3Checked(row, n) {
  if (!row) return false;
  return Number(this.normalizeC3Value(row)) === Number(n);
},
async onToggleC3(row, n, checked) {
  if (!row) return;

  const valor = checked ? Number(n) : 0;
  this.$set(row, 'numeroClusterCustom3', valor);
  this.$set(row, 'criterioCustom3', checked ? String(n) : null);

  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  const id  = Number(this.getMaterialId(row) || 0);
  if (!tok || !id) return;

  try {
    await this.putUpdateMaterialCluster(tok, id, 3, valor);
  } catch (e) {
    console.error('[onToggleC3] error al guardar:', e);
    this.$notify && this.$notify({ type: 'danger', message: 'Error al guardar el cambio.' });
  }
},

async guardarCustom3(cambios) {
  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  if (!tok) throw new Error('Token vacío.');

  // Guarda todos los cambios en paralelo (como C1/C2)
  await Promise.all(
    cambios.map(({ idMaterialETL, valor }) =>
      this.putUpdateMaterialCluster(tok, idMaterialETL, /* nroCriterioCustom */ 3, valor)
    )
  );
},
    onCriterioCustom2Input(value, item) {
      item.criterioCustom2 = value != null ? String(value) : '';
    },

    onCriterioCustom1Input(value, row) {
  row.criterioCustom1 = (value === null) ? null : (value !== undefined ? String(value) : null);
},
    parseNumberC1(value) {
      if (value === null || value === undefined || value === '') return NaN;
      return parseFloat(String(value).replace(/,/g, ''));
    },

    async fetchCustom1(page = 1) {
  try {
    this.cargandoCustom1 = true;
    const token = this.archivoSeleccionado && this.archivoSeleccionado.token;
    if (!token) return;

    const resp = await materialService.getResultETL(token, 1, 999999);
    const items = (resp && resp.items) ? resp.items : [];

    this.custom1Data = items.map(x => {
      // lee TODAS las variantes posibles desde backend
      let raw =
        (x.criterioCustom1 !== undefined ? x.criterioCustom1 :
         x.CriterioCustom1 !== undefined ? x.CriterioCustom1 :
         x.Custom1 !== undefined ? x.Custom1 :
         x.custom1 !== undefined ? x.custom1 :
         null);

      if (raw === '') raw = null; // '' -> null para checkbox apagado

      return {
        ...x,
        criterioCustom1: raw
      };
    });

    this.initialCustom1Data = JSON.parse(JSON.stringify(this.custom1Data));
    this.currentPageC1 = 1;
  } catch (e) {
    console.error('Error fetchCustom1:', e);
    this.$notify && this.$notify({ type: 'error', message: 'No se pudo cargar Custom 1' });
  } finally {
    this.cargandoCustom1 = false;
  }
  // Detecta el mayor valor almacenado en criterioCustom1 y expande columnas si es necesario
try {
  const maxInData = Math.max(
    3,
    ...this.custom1Data
      .map(x => Number(x.criterioCustom1))
      .filter(v => Number.isFinite(v))
  );
  this.c1Max = Math.max(this.c1Max, maxInData);
} catch (_) {
  // no-op
}
},
    actualizarTotalC1(item) {
      const val = this.parseNumberC1(item.valorSugeridoGeneral);
      const qty = this.parseNumberC1(item.cantidad);
      item.valorSugeridoGeneralTotal = (!isNaN(val) && !isNaN(qty)) ? (val * qty) : '';
    },



async confirmarGuardarCustom1() {
  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  if (!tok) {
    this.$notify && this.$notify({ type: 'warning', message: 'Selecciona un archivo válido' });
    return;
  }

  try {
    this.cargandoCustom1 = true;

    // 1) Calcula diffs locales (solo lo que cambió)
    const cambios = this.getModifiedRowsCustom1();
    console.log('💾 [C1] cambios a guardar:', cambios.length, cambios);

    // 2) Persiste cada cambio y ESPERA a que termine
    if (cambios.length > 0) {
      // En serie (más seguro con SQL)
      for (const ch of cambios) {
        await this.putUpdateMaterialCluster(
          tok,
          ch.idMaterialETL,
          1,               // ← C1
          ch.valor == null ? 0 : Number(ch.valor)
        );
      }
      //this.$notify && this.$notify({ type: 'success', message: 'Cambios guardados en Custom 1.' });
    } else {
      console.log('💾 [C1] No hay cambios que guardar.');
    }

    // 3) Actualiza snapshot local (para que al volver no aparezcan como "pendientes")
    this.initialCustom1Data = (this.custom1Data || []).map(r => ({
      idMaterialETL: this.getMaterialId(r),
      numeroClusterCustom1: this.normalizeC1Value(r)
    }));

    // 4) Finaliza y refresca el RESUMEN (esto navega al resumen)
    //    → SOLO después de terminar de guardar
    const ok = await this.finalizarCustom(1);
    if (!ok) {
      // Si no pudo finalizar, al menos quédate en la pantalla y no “pierdas” el contexto
      this.$notify && this.$notify({ type: 'warning', message: 'Cambios quedaron guardados, pero no se pudo finalizar.' });
    }
  } catch (e) {
    console.error('Error al guardar o finalizar Custom 1:', e);
    this.$notify && this.$notify({ type: 'danger', message: 'Error al guardar o finalizar Custom 1' });
  } finally {
    this.cargandoCustom1 = false;
  }
},
// Extrae el número desde nombres tipo 'REPUESTO_C0' => '0'
getNumeroFromNombreCluster: function (nombre) {
  if (!nombre) return null;
  var m = /_C(\d+)$/i.exec(String(nombre));
  return m ? m[1] : null;
},

// Helper: obtiene la clave para /getClustersDetalle según el item del resumen
extractDetalleClave(item) {
  if (!item || typeof item !== 'object') return null;

  // Preferencias de campos posibles
  const name = (
    (item.nombreCluster != null ? item.nombreCluster :
    (item.NombreCluster != null ? item.NombreCluster :
    (item.NombreClase   != null ? item.NombreClase   :
    (item.nombreClase   != null ? item.nombreClase   :
    (item.cluster       != null ? item.cluster       :
    (item.numeroCluster != null ? item.numeroCluster :
    (item.id != null ? item.id : null)))))))
  );

  if (name == null) return null;

  // No lo fuerces a número: puede ser string en algunos criterios
  const clave = String(name).trim();
  return clave;
},

// Reemplazo completo
async eliminarItemDeCluster(item) {
  if (!this.puedeEscribir) return;
  const tok = this.archivoSeleccionado && String(this.archivoSeleccionado.token || '').trim();
  const idCriterio = this.tipoClusterSeleccionado && this.tipoClusterSeleccionado.id;
  if (!tok || !idCriterio || !item.id) return;

  const confirm = await Swal.fire({
    title: '¿Eliminar item?',
    html: `¿Está seguro de quitar <strong>${item.nombre || item.id}</strong> de este cluster?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
  });
  if (!confirm.isConfirmed) return;

  this.$set(item, '_eliminando', true);
  try {
    await materialService.removeItemFromCluster(tok, item.id, idCriterio);
    const idx = this.clusterDetalle.findIndex(d => d.id === item.id);
    if (idx !== -1) this.clusterDetalle.splice(idx, 1);
  } catch (e) {
    console.error('Error al eliminar item del cluster:', e);
    this.$notify && this.$notify({ type: 'error', message: 'Error al eliminar el item' });
    this.$set(item, '_eliminando', false);
  }
},

async obtenerClusterDetalle(item) {
  try {
    if (!this.archivoSeleccionado || !this.archivoSeleccionado.token) {
      this.$notify && this.$notify({ type: 'warning', message: 'Selecciona un archivo válido' });
      return;
    }

    // Criterio actual (debe estar seteado al hacer click en el resumen)
    const criterio = (this.tipoClusterSeleccionado && this.tipoClusterSeleccionado.id) ? this.tipoClusterSeleccionado.id : null;
    if (!criterio) {
      this.$notify && this.$notify({ type: 'warning', message: 'No hay un criterio seleccionado' });
      return;
    }

    // Clave a enviar (número de cluster o nombre de clase, según corresponda)
    const clave = this.extractDetalleClave(item);
    if (!clave) {
      this.$notify && this.$notify({ type: 'warning', message: 'No se pudo determinar la clave del detalle' });
      return;
    }

    const tok = String(this.archivoSeleccionado.token).trim();
    const apiBase = process.env.VUE_APP_API_URL || '';
    const url = `${apiBase}/api/cluster/getClustersDetalle/${encodeURIComponent(tok)}/${encodeURIComponent(criterio)}/${encodeURIComponent(clave)}`;

    console.log('➡️ Detalle URL:', url, '| criterio:', criterio, '| clave enviada:', clave);

    const resp = await fetch(url, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
        'Accept': 'application/json'
      }
    });

    if (!resp.ok) {
      const txt = await resp.text().catch(() => '');
      console.error('❌ Detalle HTTP', resp.status, txt);
      this.$notify && this.$notify({
        type: 'danger',
        message: `No se pudo obtener el detalle (HTTP ${resp.status})`
      });
      return;
    }

    const data = await resp.json();

    // Normaliza a array y muestra
    this.clusterDetalle = Array.isArray(data) ? data : (data ? [data] : []);
    this.resetPaginadorDetalle();
    this.mostrarCluster = true;          // << antes lo ponías en false
    this.mostrarDetalleCluster = true;   // muestra la tabla de detalle
  } catch (e) {
    console.error('Error en obtenerClusterDetalle:', e);
    this.$notify && this.$notify({ type: 'danger', message: 'Error al obtener el detalle del cluster' });
  }
},

    async aplicarCluster(tipo) {
  if (!this.archivoSeleccionado || !tipo) return;

  // reset de vistas
  this.mostrarCustom1 = false;
  this.mostrarCustom2 = false;
  this.mostrarCustom3 = false;
  this.mostrarDetalleCluster = false;

  // arrancar limpio
  this.clusterResumen = [];
  this.sinDatos = false;
  this.msgSinDatos = this.$t('no_hay_datos_criterio');

  // fetch centralizado
  let ok = false;
  try {
    ok = await this.tryFetchResumen(tipo.id);
  } catch (e) {
    console.error('Error al obtener resumen del cluster:', e);
    ok = false;
  }

  // flags de UI
  this.sinDatos = !ok;
  this.mostrarCluster = ok;                 // si quieres mantener layout aunque no haya datos, usa true
  this.mostrarDetalleCluster = false;

  // criterio activo sólo si hay datos
  this.tipoClusterSeleccionado = ok ? tipo : null;
},
    async seleccionarArchivoDesdeTabla(archivo) {
      this.archivoSeleccionado = archivo;
      await this.onArchivoSeleccionado();
    },

    ordenarPorArchivos(col) {
      if (this.ordenColumnaArchivos === col) {
        this.ordenDireccionArchivos = this.ordenDireccionArchivos === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumnaArchivos = col;
        this.ordenDireccionArchivos = 'asc';
      }
    },
    iconoOrdenArchivos(col) {
      if (this.ordenColumnaArchivos !== col) return 'fas fa-sort text-muted';
      return this.ordenDireccionArchivos === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },

    async seleccionarArchivoYVolverAdm(archivo) {
      if (!this.puedeEscribir) return;
      this.archivoSeleccionado = archivo;
      await this.confirmarVolverAdmInventario();
    },

    async ejecutarRentabilizar(archivo) {
      if (!this.puedeEscribir || this.esFlujoDirectoCluster(archivo)) return;
      const tok = archivo && (archivo.token || archivo.Token);
      if (!tok) return;

      const res = await Swal.fire({
        title: this.$t('confirmar_ejecucion') || '¿Ejecutar rentabilización?',
        text: this.$t('seguro_ejecutar') || '¿Está seguro de que desea ejecutar?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('si_ejecutar') || 'Sí, ejecutar',
        cancelButtonText: this.$t('cancelar') || 'Cancelar',
        confirmButtonColor: '#e3342f',
      });

      if (!res.isConfirmed) return;

      try {
        const resp = await materialService.updateEstadoFlujo(tok, 'S');
        if (resp && (resp.success === true || resp.Success === true)) {
          const idx = (this.archivosLogs || []).findIndex(a => (a.token || a.Token) === tok);
          if (idx !== -1) {
            this.archivosLogs.splice(idx, 1, { ...this.archivosLogs[idx], estadoFlujo: 'S', EstadoFlujo: 'S' });
          }
          this.$notify && this.$notify({ type: 'success', message: this.$t('en_proceso') || 'En proceso' });
        } else {
          this.$notify && this.$notify({ type: 'warning', message: 'No se pudo iniciar la rentabilización' });
        }
      } catch (e) {
        console.error(e);
        this.$notify && this.$notify({ type: 'error', message: 'Error al ejecutar rentabilización' });
      }
    },

    async ejecutarClusterizar(archivo) {
      if (!this.puedeEscribir) return;
      const tok = archivo && (archivo.token || archivo.Token);
      if (!tok) return;

      const res = await Swal.fire({
        title: this.$t('confirmar_clusterizar') || '¿Iniciar clusterización?',
        text: this.$t('confirmar_clusterizar_texto') || 'Se enviará el archivo a clusterización.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('clusterizar') || 'Clusterizar',
        cancelButtonText: this.$t('cancelar') || 'Cancelar',
      });

      if (!res.isConfirmed) return;

      try {
        const resp = await materialService.updateEstadoFlujo(tok, 'C');
        if (resp && (resp.success === true || resp.Success === true)) {
          const idx = (this.archivosLogs || []).findIndex(a => (a.token || a.Token) === tok);
          if (idx !== -1) {
            this.archivosLogs.splice(idx, 1, { ...this.archivosLogs[idx], estadoFlujo: 'C', EstadoFlujo: 'C' });
          }
          this.$notify && this.$notify({ type: 'success', message: this.$t('clusterizando') || 'Clusterización iniciada' });
        } else {
          this.$notify && this.$notify({ type: 'warning', message: 'No se pudo iniciar la clusterización' });
        }
      } catch (e) {
        console.error(e);
        this.$notify && this.$notify({ type: 'error', message: 'Error al solicitar clusterización' });
      }
    },

    async onEmpresaSeleccionada() {
      try {
        this.stopPollingEstado();
        this.archivoSeleccionado = null;
        this.mostrarCluster = false;
        this.archivosConsultados = false;
        this.archivosLogs = [];
        const archivos = await materialService.getLogsFiles(this.empresaSeleccionada);
        this.archivosLogs = archivos;
        this.archivosConsultados = true;
      } catch (error) {
        console.error("Error al cargar archivos:", error);
        this.archivosLogs = [];
        this.archivosConsultados = true;
      }
    },
    async onArchivoSeleccionado() {
  // 1) Limpia estados/flags
  this.resultados = [];
  this.isEditing = false;
  this.sinDatos = false;
  this.msgSinDatos = this.$t('no_hay_datos_criterio');

  // 🔒 Al elegir archivo: no mostrar nada aún
  this.mostrarCluster = false;
  this.tipoClusterSeleccionado = null;
  this.clusterResumen = [];
  this.mostrarDetalleCluster = false;
  this.mostrarCustom1 = false;
  this.mostrarCustom2 = false;
  this.mostrarCustom3 = false;

  // Log opcional
  if (this.archivoSeleccionado && this.archivoSeleccionado.token) {
    console.log('📌 Archivo seleccionado — token:', this.archivoSeleccionado.token, 'obj:', this.archivoSeleccionado);
  } else {
    console.warn('⚠️ No hay token en archivoSeleccionado:', this.archivoSeleccionado);
  }

  // 2) Resetea data/paginación de Custom 1/2/3
  this.cargandoCustom1 = false; this.custom1Data = []; this.initialCustom1Data = []; this.currentPageC1 = 1;
  this.cargandoCustom2 = false; this.custom2Data = []; this.initialCustom2Data = []; this.currentPageC2 = 1;
  this.cargandoCustom3 = false; this.custom3Data = []; this.initialCustom3Data = []; this.currentPageC3 = 1;

  // 3) Refresca estados reales desde BD
  await this.refrescarEstadoArchivo();

  // 4) Polling SOLO si ya viene en C; de lo contrario, se detiene
  if (this.getEstadoFlujoLocal() === 'C') {
    this.startPollingEstado();
  } else {
    this.stopPollingEstado();
  }

},
    // ===== SCROLL NAV =====
scrollTablaCustom(refName, dir) {
  const el = this.$refs[refName];
  if (!el) return;
  const px = 300;
  if (dir === 'left')   el.scrollBy({ left: -px, behavior: 'smooth' });
  if (dir === 'right')  el.scrollBy({ left:  px, behavior: 'smooth' });
  if (dir === 'top')    window.scrollTo({ top: 0, behavior: 'smooth' });
  if (dir === 'bottom') window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
},
    // ===== SORT HELPERS RESUMEN/DETALLE =====
ordenarResumen(campo) {
  if (this.ordenResumen.campo === campo) {
    this.ordenResumen = { campo, dir: this.ordenResumen.dir * -1 };
  } else {
    this.ordenResumen = { campo, dir: 1 };
  }
},
iconoOrdenResumen(campo) {
  if (this.ordenResumen.campo !== campo) return 'fas fa-sort text-muted';
  return this.ordenResumen.dir === 1 ? 'fas fa-sort-up' : 'fas fa-sort-down';
},
ordenarDetalle(campo) {
  if (this.ordenDetalle.campo === campo) {
    this.ordenDetalle = { campo, dir: this.ordenDetalle.dir * -1 };
  } else {
    this.ordenDetalle = { campo, dir: 1 };
  }
},
iconoOrdenDetalle(campo) {
  if (this.ordenDetalle.campo !== campo) return 'fas fa-sort text-muted';
  return this.ordenDetalle.dir === 1 ? 'fas fa-sort-up' : 'fas fa-sort-down';
},
    // ===== SORT HELPERS C1/C2/C3 =====
ordenarC1(campo) {
  if (this.ordenC1.campo === campo) {
    this.ordenC1 = { campo, dir: this.ordenC1.dir * -1 };
  } else {
    this.ordenC1 = { campo, dir: 1 };
  }
},
ordenarC2(campo) {
  if (this.ordenC2.campo === campo) {
    this.ordenC2 = { campo, dir: this.ordenC2.dir * -1 };
  } else {
    this.ordenC2 = { campo, dir: 1 };
  }
},
ordenarC3(campo) {
  if (this.ordenC3.campo === campo) {
    this.ordenC3 = { campo, dir: this.ordenC3.dir * -1 };
  } else {
    this.ordenC3 = { campo, dir: 1 };
  }
},
iconoOrdenC1(campo) {
  if (this.ordenC1.campo !== campo) return 'fas fa-sort text-muted';
  return this.ordenC1.dir === 1 ? 'fas fa-sort-up' : 'fas fa-sort-down';
},
iconoOrdenC2(campo) {
  if (this.ordenC2.campo !== campo) return 'fas fa-sort text-muted';
  return this.ordenC2.dir === 1 ? 'fas fa-sort-up' : 'fas fa-sort-down';
},
iconoOrdenC3(campo) {
  if (this.ordenC3.campo !== campo) return 'fas fa-sort text-muted';
  return this.ordenC3.dir === 1 ? 'fas fa-sort-up' : 'fas fa-sort-down';
},
// ===== SCROLL HANDLERS =====
_onWindowScrollC1() {
  const cont = this.$refs.tablaScrollC1;
  if (!cont) return;
  const thead = cont.querySelector('thead.thead-sticky');
  if (!thead) return;
  const top = cont.getBoundingClientRect().top;
  thead.style.transform = top < 0 ? `translateY(${-top}px)` : '';
},
_onWindowScrollC2() {
  const cont = this.$refs.tablaScrollC2;
  if (!cont) return;
  const thead = cont.querySelector('thead.thead-sticky');
  if (!thead) return;
  const top = cont.getBoundingClientRect().top;
  thead.style.transform = top < 0 ? `translateY(${-top}px)` : '';
},
_onWindowScrollC3() {
  const cont = this.$refs.tablaScrollC3;
  if (!cont) return;
  const thead = cont.querySelector('thead.thead-sticky');
  if (!thead) return;
  const top = cont.getBoundingClientRect().top;
  thead.style.transform = top < 0 ? `translateY(${-top}px)` : '';
},
_onWindowScrollResumen() {
  const cont = this.$refs.tablaScrollResumen;
  if (!cont) return;
  const thead = cont.querySelector('thead.thead-sticky');
  if (!thead) return;
  const top = cont.getBoundingClientRect().top;
  thead.style.transform = top < 0 ? `translateY(${-top}px)` : '';
},
_onWindowScrollDetalle() {
  const cont = this.$refs.tablaScrollDetalle;
  if (!cont) return;
  const thead = cont.querySelector('thead.thead-sticky');
  if (!thead) return;
  const top = cont.getBoundingClientRect().top;
  thead.style.transform = top < 0 ? `translateY(${-top}px)` : '';
},
    async ejecutarClusterizacion() {
      if (!this.archivoSeleccionado) return;

      try {
        // Aquí se llama a tu servicio de clusterización
        const res = await materialService.getClusterizacionResultado(this.archivoSeleccionado.token);
        this.resultados = res.data;
      } catch (error) {
        console.error("Error ejecutando clusterización:", error);
      }
    },
  },
};

</script>

<style scoped>
.btn-enviar-ecommerce {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1050;
}

.btn-ver-ranking {
  position: fixed;
  bottom: 72px;
  right: 20px;
  z-index: 1050;
}

input.form-control.input-custom {
    height: 30px !important;
    padding: 0;
}
.btn-custom{
  background: #5dcc7e;
  color: #000000 !important;
}

/* ===== Columnas de criterio (fondo gris diferenciador) ===== */
.th-criterio {
  background-color: #d6d8db !important;
  color: #343a40;
}
.td-criterio {
  background-color: #f0f1f2;
}

/* ===== Tabla con cabecera inmóvil ===== */
.tabla-scroll-fixed {
  overflow-x: auto;
  position: relative;
  font-size: 0.75rem;
  /* La barra de paginación/scroll es position:fixed sobre el viewport: sin este
     espacio, al llegar al final de la tabla la ultima fila queda tapada detras
     de la barra en vez de arriba de ella. */
  padding-bottom: 60px;
}

.thead-sticky {
  position: relative;
  z-index: 2;
  background: #f8f9fa;
}

.th-ordenable {
  cursor: pointer;
  user-select: none;
  min-width: 90px;
  vertical-align: top;
  white-space: nowrap;
}

.tabla-archivos-cargados th,
.tabla-archivos-cargados td {
  font-size: 12px;
}

.tabla-archivos-cargados td .badge {
  font-size: 11px;
}

/* Badge ecommerce: Bootstrap no define esta clase */
.badge-ecommerce {
  background-color: #007bff;
  color: white;
}

.th-search-input {
  width: 100%;
  font-size: 10px;
  padding: 1px 3px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  margin-bottom: 3px;
  display: block;
  font-weight: normal;
}

.th-label {
  display: block;
  font-size: 10.5px;
  font-weight: 600;
  white-space: nowrap;
}

/* Checklist de Fabricante: mismo alto/tamano que los .th-search-input de al lado */
.th-filter-select {
  width: 100%;
  margin-bottom: 3px;
  display: block;
}
.th-filter-select >>> .el-input__inner {
  height: 22px;
  line-height: 22px;
  font-size: 10px;
  padding: 0 18px 0 6px;
  border-radius: 3px;
}
.th-filter-select >>> .el-input__icon {
  line-height: 22px;
}

/* Icono de ayuda dentro del encabezado de una columna */
.btn-info-columna {
  color: #5e72e4;
  cursor: pointer;
  margin-left: 4px;
  font-size: 12px;
}
.btn-info-columna:hover {
  color: #324cdd;
}

.txt-truncate-sm {
  font-size: 10px;
  line-height: 1.15;
}

.tabla-scroll-fixed .table th,
.tabla-scroll-fixed .table td {
  font-size: 10px;
  padding: 0.3rem 0.4rem;
}

.btn-scroll-nav {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ced4da;
  background: #f8f9fa;
  color: #495057;
  border-radius: 6px;
}
.btn-scroll-nav:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

/* ===== Barra flotante de paginación (igual que Rentabilizacion) ===== */
.pagination-floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  background: #fff;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.08);
}
</style>
